//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.5.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param search (optional)
     * @param isInvestorOnly (optional)
     * @param brokerId (optional)
     * @return Success
     */
    searchLookups(search?: string | undefined, isInvestorOnly?: boolean | undefined, brokerId?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/accounts/lookups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isInvestorOnly === null)
            throw new Error("The parameter 'isInvestorOnly' cannot be null.");
        else if (isInvestorOnly !== undefined)
            url_ += "IsInvestorOnly=" + encodeURIComponent("" + isInvestorOnly) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processSearchLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getTokenBalances(id: string): Observable<(AccountTokenBalanceModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/token-balances";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
        }));
    }

    protected processGetTokenBalances(response: HttpResponseBase): Observable<(AccountTokenBalanceModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountTokenBalanceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(AccountTokenBalanceModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getAccountTokens(id: string): Observable<(TokenBalanceDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/account-tokens";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenBalanceDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenBalanceDisplayModel | undefined)[]>;
        }));
    }

    protected processGetAccountTokens(response: HttpResponseBase): Observable<(TokenBalanceDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenBalanceDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenBalanceDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param search (optional)
     * @param tokenIds (optional)
     * @param tokenTypeIds (optional)
     * @param accountId (optional)
     * @param showAccountLevel (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param includeExpiredTokens (optional)
     * @param includeVotingTokens (optional)
     * @param brokerId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, tokenIds?: string[] | undefined, tokenTypeIds?: number[] | undefined, accountId?: string | undefined, showAccountLevel?: boolean | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, includeExpiredTokens?: boolean | undefined, includeVotingTokens?: boolean | undefined, brokerId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<AccountTokenBalanceModelPagedResult> {
        let url_ = this.baseUrl + "/api/accounts/token-balances?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (showAccountLevel === null)
            throw new Error("The parameter 'showAccountLevel' cannot be null.");
        else if (showAccountLevel !== undefined)
            url_ += "ShowAccountLevel=" + encodeURIComponent("" + showAccountLevel) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (includeExpiredTokens === null)
            throw new Error("The parameter 'includeExpiredTokens' cannot be null.");
        else if (includeExpiredTokens !== undefined)
            url_ += "IncludeExpiredTokens=" + encodeURIComponent("" + includeExpiredTokens) + "&";
        if (includeVotingTokens === null)
            throw new Error("The parameter 'includeVotingTokens' cannot be null.");
        else if (includeVotingTokens !== undefined)
            url_ += "IncludeVotingTokens=" + encodeURIComponent("" + includeVotingTokens) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountTokenBalanceModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountTokenBalanceModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AccountTokenBalanceModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountTokenBalanceModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountTokenBalanceModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param tokenIds (optional)
     * @param accountId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    debtConfig(search?: string | undefined, tokenIds?: string[] | undefined, accountId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<DebtConfigModelPagedResult> {
        let url_ = this.baseUrl + "/api/accounts/debt-config?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDebtConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDebtConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebtConfigModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebtConfigModelPagedResult>;
        }));
    }

    protected processDebtConfig(response: HttpResponseBase): Observable<DebtConfigModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtConfigModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebtConfigModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param tokenIds (optional)
     * @param tokenTypeIds (optional)
     * @param accountId (optional)
     * @param showAccountLevel (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param includeExpiredTokens (optional)
     * @param includeVotingTokens (optional)
     * @param brokerId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, tokenIds?: string[] | undefined, tokenTypeIds?: number[] | undefined, accountId?: string | undefined, showAccountLevel?: boolean | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, includeExpiredTokens?: boolean | undefined, includeVotingTokens?: boolean | undefined, brokerId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/token-balances/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (showAccountLevel === null)
            throw new Error("The parameter 'showAccountLevel' cannot be null.");
        else if (showAccountLevel !== undefined)
            url_ += "ShowAccountLevel=" + encodeURIComponent("" + showAccountLevel) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (includeExpiredTokens === null)
            throw new Error("The parameter 'includeExpiredTokens' cannot be null.");
        else if (includeExpiredTokens !== undefined)
            url_ += "IncludeExpiredTokens=" + encodeURIComponent("" + includeExpiredTokens) + "&";
        if (includeVotingTokens === null)
            throw new Error("The parameter 'includeVotingTokens' cannot be null.");
        else if (includeVotingTokens !== undefined)
            url_ += "IncludeVotingTokens=" + encodeURIComponent("" + includeVotingTokens) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param tokenIds (optional)
     * @param tokenTypeIds (optional)
     * @param accountId (optional)
     * @param showAccountLevel (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param includeExpiredTokens (optional)
     * @param includeVotingTokens (optional)
     * @param brokerId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, tokenIds?: string[] | undefined, tokenTypeIds?: number[] | undefined, accountId?: string | undefined, showAccountLevel?: boolean | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, includeExpiredTokens?: boolean | undefined, includeVotingTokens?: boolean | undefined, brokerId?: string | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/accounts/token-balances/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (showAccountLevel === null)
            throw new Error("The parameter 'showAccountLevel' cannot be null.");
        else if (showAccountLevel !== undefined)
            url_ += "ShowAccountLevel=" + encodeURIComponent("" + showAccountLevel) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (includeExpiredTokens === null)
            throw new Error("The parameter 'includeExpiredTokens' cannot be null.");
        else if (includeExpiredTokens !== undefined)
            url_ += "IncludeExpiredTokens=" + encodeURIComponent("" + includeExpiredTokens) + "&";
        if (includeVotingTokens === null)
            throw new Error("The parameter 'includeVotingTokens' cannot be null.");
        else if (includeVotingTokens !== undefined)
            url_ += "IncludeVotingTokens=" + encodeURIComponent("" + includeVotingTokens) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorAccountLookups(): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/accounts/investor-account-lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorAccountLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorAccountLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetInvestorAccountLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @param productPaymentOptionId (optional)
     * @return Success
     */
    getBalancesForProductPurchase(id: string, productPaymentOptionId?: string | undefined): Observable<PurchaseTokenBalancesModel | null> {
        let url_ = this.baseUrl + "/api/accounts/{id}/balances-for-purchase?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productPaymentOptionId === null)
            throw new Error("The parameter 'productPaymentOptionId' cannot be null.");
        else if (productPaymentOptionId !== undefined)
            url_ += "productPaymentOptionId=" + encodeURIComponent("" + productPaymentOptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalancesForProductPurchase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalancesForProductPurchase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseTokenBalancesModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseTokenBalancesModel | null>;
        }));
    }

    protected processGetBalancesForProductPurchase(response: HttpResponseBase): Observable<PurchaseTokenBalancesModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseTokenBalancesModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseTokenBalancesModel | null>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolioValueHistory(id: string): Observable<(DateValueModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/portfolio-history";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolioValueHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolioValueHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(DateValueModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(DateValueModel | undefined)[]>;
        }));
    }

    protected processGetPortfolioValueHistory(response: HttpResponseBase): Observable<(DateValueModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateValueModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(DateValueModel | undefined)[]>(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getProjectTokens(id: string, projectId?: string | undefined): Observable<(ProjectTokenModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/project-tokens?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectTokenModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectTokenModel | undefined)[]>;
        }));
    }

    protected processGetProjectTokens(response: HttpResponseBase): Observable<(ProjectTokenModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTokenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectTokenModel | undefined)[]>(null as any);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getSellableTokenSelections(id: string, searchTerm?: string | undefined): Observable<(TokenSelectionModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/sellable-token-selections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellableTokenSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellableTokenSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenSelectionModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenSelectionModel | undefined)[]>;
        }));
    }

    protected processGetSellableTokenSelections(response: HttpResponseBase): Observable<(TokenSelectionModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenSelectionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenSelectionModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getUtilityTokenSelections(id: string): Observable<(TokenSelectionModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/utility-token-selections";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityTokenSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityTokenSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenSelectionModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenSelectionModel | undefined)[]>;
        }));
    }

    protected processGetUtilityTokenSelections(response: HttpResponseBase): Observable<(TokenSelectionModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenSelectionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenSelectionModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getPortfolio(id: string): Observable<(AccountTokenBalanceModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/portfolio";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
        }));
    }

    protected processGetPortfolio(response: HttpResponseBase): Observable<(AccountTokenBalanceModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountTokenBalanceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(AccountTokenBalanceModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getTokenActions(id: string): Observable<(TokenActionsModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/accounts/{id}/token-cards";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenActionsModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenActionsModel | undefined)[]>;
        }));
    }

    protected processGetTokenActions(response: HttpResponseBase): Observable<(TokenActionsModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenActionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenActionsModel | undefined)[]>(null as any);
    }

    /**
     * @param tokenId (optional)
     * @return Success
     */
    toggleReinvestInterest(id: string, tokenId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}/toggle-reinvest-interest?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tokenId === null)
            throw new Error("The parameter 'tokenId' cannot be null.");
        else if (tokenId !== undefined)
            url_ += "tokenId=" + encodeURIComponent("" + tokenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleReinvestInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleReinvestInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleReinvestInterest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    scheduleEarlyPayout(body?: ScheduleEarlyPayoutInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/schedule-early-payout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleEarlyPayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleEarlyPayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleEarlyPayout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    configureRolloverToken(body?: ConfigureRolloverTokenInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/configure-rollover-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigureRolloverToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigureRolloverToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigureRolloverToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAdminDashboardTodos(): Observable<(AdminDashboardTodo | undefined)[]> {
        let url_ = this.baseUrl + "/api/admin-dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminDashboardTodos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminDashboardTodos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(AdminDashboardTodo | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(AdminDashboardTodo | undefined)[]>;
        }));
    }

    protected processGetAdminDashboardTodos(response: HttpResponseBase): Observable<(AdminDashboardTodo | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDashboardTodo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(AdminDashboardTodo | undefined)[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BankAccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<BankAccountDisplayModel | null> {
        let url_ = this.baseUrl + "/api/bank-accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<BankAccountDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BankAccountDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: BankAccountInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param accountId (optional)
     * @param investorId (optional)
     * @param hasBeenVerified (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, accountId?: string | undefined, investorId?: string | undefined, hasBeenVerified?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<BankAccountDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/bank-accounts?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<BankAccountDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: BankAccountInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/bank-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param accountId (optional)
     * @param investorId (optional)
     * @param hasBeenVerified (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, accountId?: string | undefined, investorId?: string | undefined, hasBeenVerified?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-accounts/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param accountId (optional)
     * @param investorId (optional)
     * @param hasBeenVerified (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, accountId?: string | undefined, investorId?: string | undefined, hasBeenVerified?: boolean | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/bank-accounts/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param accountId (optional)
     * @return Success
     */
    getActiveBankAccounts(accountId?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/bank-accounts/active-accounts?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveBankAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveBankAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetActiveBankAccounts(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @param investorId (optional)
     * @return Success
     */
    getInvestorActiveBankAccounts(investorId?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/bank-accounts/investor-active-accounts?";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "investorId=" + encodeURIComponent("" + investorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorActiveBankAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorActiveBankAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetInvestorActiveBankAccounts(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    verify(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-accounts/{id}/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BankAccountTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param search (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param tokenIds (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, tokenIds?: string[] | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<BankAccountTransactionDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/bank-account-transactions?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountTransactionDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountTransactionDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<BankAccountTransactionDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountTransactionDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountTransactionDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: BankAccountTransactionInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/bank-account-transactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getBankAccountTransactionSummary(): Observable<(BankAccountSummaryModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/bank-account-transactions/get-bank-account-transactions-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountTransactionSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountTransactionSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(BankAccountSummaryModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(BankAccountSummaryModel | undefined)[]>;
        }));
    }

    protected processGetBankAccountTransactionSummary(response: HttpResponseBase): Observable<(BankAccountSummaryModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(BankAccountSummaryModel | undefined)[]>(null as any);
    }

    /**
     * @param search (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param tokenIds (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, tokenIds?: string[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-account-transactions/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param tokenIds (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, tokenIds?: string[] | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/bank-account-transactions/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param search (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param tokenIds (optional)
     * @param orderBy (optional)
     * @return Success
     */
    getBalance(search?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, tokenIds?: string[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/bank-account-transactions/get-balance?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetBalance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChatsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getChatroom(id: string): Observable<ChatDisplayModel | null> {
        let url_ = this.baseUrl + "/api/chats/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatroom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatroom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDisplayModel | null>;
        }));
    }

    protected processGetChatroom(response: HttpResponseBase): Observable<ChatDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChatDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatDisplayModel | null>(null as any);
    }

    /**
     * @return Success
     */
    getChatroomMessages(index: number, chatId: string): Observable<ChatMessageDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/chats/{chatId}/messages/{index}";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        if (chatId === undefined || chatId === null)
            throw new Error("The parameter 'chatId' must be defined.");
        url_ = url_.replace("{chatId}", encodeURIComponent("" + chatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatroomMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatroomMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessageDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessageDisplayModelPagedResult>;
        }));
    }

    protected processGetChatroomMessages(response: HttpResponseBase): Observable<ChatMessageDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatMessageDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMessageDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendMessageToChat(body?: ChatMessageInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/chats/messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageToChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageToChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMessageToChat(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param messageId (optional)
     * @return Success
     */
    censorMessageInChat(messageId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/chats/messages?";
        if (messageId === null)
            throw new Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCensorMessageInChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCensorMessageInChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCensorMessageInChat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    approveMessageInChat(messageId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/chats/messages/{messageId}/approve";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveMessageInChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveMessageInChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveMessageInChat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    declineMessageInChat(messageId: string, adminReply: string): Observable<void> {
        let url_ = this.baseUrl + "/api/chats/messages/{messageId}/decline/{adminReply}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (adminReply === undefined || adminReply === null)
            throw new Error("The parameter 'adminReply' must be defined.");
        url_ = url_.replace("{adminReply}", encodeURIComponent("" + adminReply));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineMessageInChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineMessageInChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeclineMessageInChat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DepositsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<DepositDisplayModel | null> {
        let url_ = this.baseUrl + "/api/deposits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepositDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepositDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DepositDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepositDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: DepositInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/deposits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/deposits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param transactionHasBeenSynced (optional)
     * @param isOutstanding (optional)
     * @param investorId (optional)
     * @param tokenIds (optional)
     * @param ids (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, transactionHasBeenSynced?: boolean | undefined, isOutstanding?: boolean | undefined, investorId?: string | undefined, tokenIds?: string[] | undefined, ids?: string[] | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<DepositDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/deposits?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (transactionHasBeenSynced === null)
            throw new Error("The parameter 'transactionHasBeenSynced' cannot be null.");
        else if (transactionHasBeenSynced !== undefined)
            url_ += "TransactionHasBeenSynced=" + encodeURIComponent("" + transactionHasBeenSynced) + "&";
        if (isOutstanding === null)
            throw new Error("The parameter 'isOutstanding' cannot be null.");
        else if (isOutstanding !== undefined)
            url_ += "IsOutstanding=" + encodeURIComponent("" + isOutstanding) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepositDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepositDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<DepositDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepositDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepositDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: DepositInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/deposits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param transactionHasBeenSynced (optional)
     * @param isOutstanding (optional)
     * @param investorId (optional)
     * @param tokenIds (optional)
     * @param ids (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, transactionHasBeenSynced?: boolean | undefined, isOutstanding?: boolean | undefined, investorId?: string | undefined, tokenIds?: string[] | undefined, ids?: string[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/deposits/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (transactionHasBeenSynced === null)
            throw new Error("The parameter 'transactionHasBeenSynced' cannot be null.");
        else if (transactionHasBeenSynced !== undefined)
            url_ += "TransactionHasBeenSynced=" + encodeURIComponent("" + transactionHasBeenSynced) + "&";
        if (isOutstanding === null)
            throw new Error("The parameter 'isOutstanding' cannot be null.");
        else if (isOutstanding !== undefined)
            url_ += "IsOutstanding=" + encodeURIComponent("" + isOutstanding) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param transactionHasBeenSynced (optional)
     * @param isOutstanding (optional)
     * @param investorId (optional)
     * @param tokenIds (optional)
     * @param ids (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, transactionHasBeenSynced?: boolean | undefined, isOutstanding?: boolean | undefined, investorId?: string | undefined, tokenIds?: string[] | undefined, ids?: string[] | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/deposits/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (transactionHasBeenSynced === null)
            throw new Error("The parameter 'transactionHasBeenSynced' cannot be null.");
        else if (transactionHasBeenSynced !== undefined)
            url_ += "TransactionHasBeenSynced=" + encodeURIComponent("" + transactionHasBeenSynced) + "&";
        if (isOutstanding === null)
            throw new Error("The parameter 'isOutstanding' cannot be null.");
        else if (isOutstanding !== undefined)
            url_ += "IsOutstanding=" + encodeURIComponent("" + isOutstanding) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    confirm(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/deposits/{id}/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPaymentIntent(body?: PaymentIntentInputModel | null | undefined): Observable<PaymentIntentDisplayModel | null> {
        let url_ = this.baseUrl + "/api/deposits/create-card-deposit-intent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentIntent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentIntent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentIntentDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentIntentDisplayModel | null>;
        }));
    }

    protected processCreatePaymentIntent(response: HttpResponseBase): Observable<PaymentIntentDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentIntentDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentIntentDisplayModel | null>(null as any);
    }

    /**
     * @param stripeId (optional)
     * @param body (optional)
     * @return Success
     */
    processPaymentIntent(stripeId?: string | undefined, body?: DepositInputModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/deposits/process-card-deposit-intent?";
        if (stripeId === null)
            throw new Error("The parameter 'stripeId' cannot be null.");
        else if (stripeId !== undefined)
            url_ += "stripeId=" + encodeURIComponent("" + stripeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessPaymentIntent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPaymentIntent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processProcessPaymentIntent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<EmailDisplayModel | null> {
        let url_ = this.baseUrl + "/api/emails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<EmailDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailDisplayModel | null>(null as any);
    }

    /**
     * @param search (optional)
     * @param opened (optional)
     * @param userId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, opened?: boolean | undefined, userId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<EmailDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/emails?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (opened === null)
            throw new Error("The parameter 'opened' cannot be null.");
        else if (opened !== undefined)
            url_ += "Opened=" + encodeURIComponent("" + opened) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<EmailDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailDisplayModelPagedResult>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExternalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInvestorPortfolio(id: string): Observable<(AccountTokenBalanceModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/external/investor/{id}/portfolio";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorPortfolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorPortfolio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(AccountTokenBalanceModel | undefined)[]>;
        }));
    }

    protected processGetInvestorPortfolio(response: HttpResponseBase): Observable<(AccountTokenBalanceModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountTokenBalanceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(AccountTokenBalanceModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorTransactions(id: string): Observable<(TransactionDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/external/investor/{id}/transactions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TransactionDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TransactionDisplayModel | undefined)[]>;
        }));
    }

    protected processGetInvestorTransactions(response: HttpResponseBase): Observable<(TransactionDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TransactionDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    uploadKycDocument(body?: FileModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/external/investor/upload-kyc-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadKycDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadKycDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadKycDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submitKycDocuments(body?: ExternalDocumentInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/external/investor/submit-kyc-documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitKycDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitKycDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitKycDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    registerInvestor(body?: ExternalUserRegistrationModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/external/investor/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRegisterInvestor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    depositFunds(body?: ExternalDepositInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/external/investor/deposit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDepositFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDepositFunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDepositFunds(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    purchaseProduct(body?: ExternalPurchaseInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/external/product/purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPurchaseProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getProduct(id: string): Observable<ProductDisplayModel | null> {
        let url_ = this.baseUrl + "/api/external/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDisplayModel | null>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDisplayModel | null>(null as any);
    }

    /**
     * @return Success
     */
    getTokenValues(id: string): Observable<TokenValueDisplayModel | null> {
        let url_ = this.baseUrl + "/api/external/token/{id}/values";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenValueDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenValueDisplayModel | null>;
        }));
    }

    protected processGetTokenValues(response: HttpResponseBase): Observable<TokenValueDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TokenValueDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenValueDisplayModel | null>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestorDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<InvestorDocumentDisplayModel | null> {
        let url_ = this.baseUrl + "/api/investor-documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDocumentDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDocumentDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InvestorDocumentDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvestorDocumentDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestorDocumentDisplayModel | null>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/investor-documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param investorId (optional)
     * @param investorDocumentTypeIds (optional)
     * @param showToInvestor (optional)
     * @param hasBeenVerified (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, investorId?: string | undefined, investorDocumentTypeIds?: number[] | undefined, showToInvestor?: boolean | undefined, hasBeenVerified?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<InvestorDocumentDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/investor-documents?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (investorDocumentTypeIds === null)
            throw new Error("The parameter 'investorDocumentTypeIds' cannot be null.");
        else if (investorDocumentTypeIds !== undefined)
            investorDocumentTypeIds && investorDocumentTypeIds.forEach(item => { url_ += "InvestorDocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showToInvestor === null)
            throw new Error("The parameter 'showToInvestor' cannot be null.");
        else if (showToInvestor !== undefined)
            url_ += "ShowToInvestor=" + encodeURIComponent("" + showToInvestor) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDocumentDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDocumentDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<InvestorDocumentDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDocumentDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestorDocumentDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(investorId: string, body?: InvestorDocumentInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/investor-documents/{investorId}";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param investorId (optional)
     * @param investorDocumentTypeIds (optional)
     * @param showToInvestor (optional)
     * @param hasBeenVerified (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    searchAll(search?: string | undefined, investorId?: string | undefined, investorDocumentTypeIds?: number[] | undefined, showToInvestor?: boolean | undefined, hasBeenVerified?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<InvestorDocumentDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/investor-documents/all?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (investorDocumentTypeIds === null)
            throw new Error("The parameter 'investorDocumentTypeIds' cannot be null.");
        else if (investorDocumentTypeIds !== undefined)
            investorDocumentTypeIds && investorDocumentTypeIds.forEach(item => { url_ += "InvestorDocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showToInvestor === null)
            throw new Error("The parameter 'showToInvestor' cannot be null.");
        else if (showToInvestor !== undefined)
            url_ += "ShowToInvestor=" + encodeURIComponent("" + showToInvestor) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDocumentDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDocumentDisplayModelPagedResult>;
        }));
    }

    protected processSearchAll(response: HttpResponseBase): Observable<InvestorDocumentDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDocumentDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestorDocumentDisplayModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param investorId (optional)
     * @param investorDocumentTypeIds (optional)
     * @param showToInvestor (optional)
     * @param hasBeenVerified (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, investorId?: string | undefined, investorDocumentTypeIds?: number[] | undefined, showToInvestor?: boolean | undefined, hasBeenVerified?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/investor-documents/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (investorDocumentTypeIds === null)
            throw new Error("The parameter 'investorDocumentTypeIds' cannot be null.");
        else if (investorDocumentTypeIds !== undefined)
            investorDocumentTypeIds && investorDocumentTypeIds.forEach(item => { url_ += "InvestorDocumentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showToInvestor === null)
            throw new Error("The parameter 'showToInvestor' cannot be null.");
        else if (showToInvestor !== undefined)
            url_ += "ShowToInvestor=" + encodeURIComponent("" + showToInvestor) + "&";
        if (hasBeenVerified === null)
            throw new Error("The parameter 'hasBeenVerified' cannot be null.");
        else if (hasBeenVerified !== undefined)
            url_ += "HasBeenVerified=" + encodeURIComponent("" + hasBeenVerified) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    verifyDocument(investorDocumentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/investor-documents/{investorDocumentId}/verify";
        if (investorDocumentId === undefined || investorDocumentId === null)
            throw new Error("The parameter 'investorDocumentId' must be defined.");
        url_ = url_.replace("{investorDocumentId}", encodeURIComponent("" + investorDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<InvestorDisplayModel | null> {
        let url_ = this.baseUrl + "/api/investors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InvestorDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvestorDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestorDisplayModel | null>(null as any);
    }


    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: InvestorInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param brokerId (optional)
     * @param investorStatusIds (optional)
     * @param hasUploadedDocuments (optional)
     * @param hasBeenVerifiedByBankID (optional)
     * @param isCompany (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, brokerId?: string | undefined, investorStatusIds?: number[] | undefined, hasUploadedDocuments?: boolean | undefined, hasBeenVerifiedByBankID?: boolean | undefined, isCompany?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<InvestorDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/investors?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (investorStatusIds === null)
            throw new Error("The parameter 'investorStatusIds' cannot be null.");
        else if (investorStatusIds !== undefined)
            investorStatusIds && investorStatusIds.forEach(item => { url_ += "InvestorStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasUploadedDocuments === null)
            throw new Error("The parameter 'hasUploadedDocuments' cannot be null.");
        else if (hasUploadedDocuments !== undefined)
            url_ += "hasUploadedDocuments=" + encodeURIComponent("" + hasUploadedDocuments) + "&";
        if (hasBeenVerifiedByBankID === null)
            throw new Error("The parameter 'hasBeenVerifiedByBankID' cannot be null.");
        else if (hasBeenVerifiedByBankID !== undefined)
            url_ += "hasBeenVerifiedByBankID=" + encodeURIComponent("" + hasBeenVerifiedByBankID) + "&";
        if (isCompany === null)
            throw new Error("The parameter 'isCompany' cannot be null.");
        else if (isCompany !== undefined)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<InvestorDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestorDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: InvestorInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/investors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param brokerId (optional)
     * @param investorStatusIds (optional)
     * @param hasUploadedDocuments (optional)
     * @param hasBeenVerifiedByBankID (optional)
     * @param isCompany (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, brokerId?: string | undefined, investorStatusIds?: number[] | undefined, hasUploadedDocuments?: boolean | undefined, hasBeenVerifiedByBankID?: boolean | undefined, isCompany?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (investorStatusIds === null)
            throw new Error("The parameter 'investorStatusIds' cannot be null.");
        else if (investorStatusIds !== undefined)
            investorStatusIds && investorStatusIds.forEach(item => { url_ += "InvestorStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasUploadedDocuments === null)
            throw new Error("The parameter 'hasUploadedDocuments' cannot be null.");
        else if (hasUploadedDocuments !== undefined)
            url_ += "hasUploadedDocuments=" + encodeURIComponent("" + hasUploadedDocuments) + "&";
        if (hasBeenVerifiedByBankID === null)
            throw new Error("The parameter 'hasBeenVerifiedByBankID' cannot be null.");
        else if (hasBeenVerifiedByBankID !== undefined)
            url_ += "hasBeenVerifiedByBankID=" + encodeURIComponent("" + hasBeenVerifiedByBankID) + "&";
        if (isCompany === null)
            throw new Error("The parameter 'isCompany' cannot be null.");
        else if (isCompany !== undefined)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param brokerId (optional)
     * @param investorStatusIds (optional)
     * @param hasUploadedDocuments (optional)
     * @param hasBeenVerifiedByBankID (optional)
     * @param isCompany (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, brokerId?: string | undefined, investorStatusIds?: number[] | undefined, hasUploadedDocuments?: boolean | undefined, hasBeenVerifiedByBankID?: boolean | undefined, isCompany?: boolean | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/investors/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (investorStatusIds === null)
            throw new Error("The parameter 'investorStatusIds' cannot be null.");
        else if (investorStatusIds !== undefined)
            investorStatusIds && investorStatusIds.forEach(item => { url_ += "InvestorStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasUploadedDocuments === null)
            throw new Error("The parameter 'hasUploadedDocuments' cannot be null.");
        else if (hasUploadedDocuments !== undefined)
            url_ += "hasUploadedDocuments=" + encodeURIComponent("" + hasUploadedDocuments) + "&";
        if (hasBeenVerifiedByBankID === null)
            throw new Error("The parameter 'hasBeenVerifiedByBankID' cannot be null.");
        else if (hasBeenVerifiedByBankID !== undefined)
            url_ += "hasBeenVerifiedByBankID=" + encodeURIComponent("" + hasBeenVerifiedByBankID) + "&";
        if (isCompany === null)
            throw new Error("The parameter 'isCompany' cannot be null.");
        else if (isCompany !== undefined)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAddress(id: string, body?: InvestorAddressInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/{id}/update-address";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getNonKycInvestorDocuments(investorId: string): Observable<(InvestorDocumentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/investors/{investorId}/investor-documents";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonKycInvestorDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonKycInvestorDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(InvestorDocumentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(InvestorDocumentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetNonKycInvestorDocuments(response: HttpResponseBase): Observable<(InvestorDocumentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestorDocumentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(InvestorDocumentDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getKycDocumentStatuses(investorId: string): Observable<(KycDocumentStatusModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/investors/{investorId}/kyc-document-statuses";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKycDocumentStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKycDocumentStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(KycDocumentStatusModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(KycDocumentStatusModel | undefined)[]>;
        }));
    }

    protected processGetKycDocumentStatuses(response: HttpResponseBase): Observable<(KycDocumentStatusModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KycDocumentStatusModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(KycDocumentStatusModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    validateInvestor(investorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/{investorId}/validate";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateInvestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    suspendInvestor(investorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/{investorId}/suspend";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuspendInvestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    confirmTakeon(): Observable<void> {
        let url_ = this.baseUrl + "/api/investors/confirmTakeon";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmTakeon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTakeon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmTakeon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

  /**
   * @return Success
   */
  getQualifyingCriteria(): Observable<InvestorQualifyingCriteriaDisplayModel | null> {
    let url_ = this.baseUrl + "/api/investors/get-qualifying-criteria";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetQualifyingCriteria(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetQualifyingCriteria(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<InvestorQualifyingCriteriaDisplayModel | null>;
        }
      } else
        return _observableThrow(response_) as any as Observable<InvestorQualifyingCriteriaDisplayModel | null>;
    }));
  }

  protected processGetQualifyingCriteria(response: HttpResponseBase): Observable<InvestorQualifyingCriteriaDisplayModel | null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? InvestorQualifyingCriteriaDisplayModel.fromJS(resultData200) : <any>null;
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<InvestorQualifyingCriteriaDisplayModel | null>(null as any);
  }

    /**
     * @param body (optional)
     * @return Success
     */
    completeQualifyingCriteria(body?: InvestorQualifyingCriteriaInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/investors/complete-qualifying-criteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteQualifyingCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteQualifyingCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteQualifyingCriteria(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param brokerId (optional)
     * @param investorStatusIds (optional)
     * @param hasUploadedDocuments (optional)
     * @param hasBeenVerifiedByBankID (optional)
     * @param isCompany (optional)
     * @param orderBy (optional)
     * @return Success
     */
    searchLookups(search?: string | undefined, brokerId?: string | undefined, investorStatusIds?: number[] | undefined, hasUploadedDocuments?: boolean | undefined, hasBeenVerifiedByBankID?: boolean | undefined, isCompany?: boolean | undefined, orderBy?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/investors/lookups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (investorStatusIds === null)
            throw new Error("The parameter 'investorStatusIds' cannot be null.");
        else if (investorStatusIds !== undefined)
            investorStatusIds && investorStatusIds.forEach(item => { url_ += "InvestorStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasUploadedDocuments === null)
            throw new Error("The parameter 'hasUploadedDocuments' cannot be null.");
        else if (hasUploadedDocuments !== undefined)
            url_ += "hasUploadedDocuments=" + encodeURIComponent("" + hasUploadedDocuments) + "&";
        if (hasBeenVerifiedByBankID === null)
            throw new Error("The parameter 'hasBeenVerifiedByBankID' cannot be null.");
        else if (hasBeenVerifiedByBankID !== undefined)
            url_ += "hasBeenVerifiedByBankID=" + encodeURIComponent("" + hasBeenVerifiedByBankID) + "&";
        if (isCompany === null)
            throw new Error("The parameter 'isCompany' cannot be null.");
        else if (isCompany !== undefined)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processSearchLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LookupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInvestorStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getProjectReturnTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/project-return-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectReturnTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectReturnTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetProjectReturnTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getProjectStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/project-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetProjectStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getProjectTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/project-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetProjectTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getProductStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/product-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetProductStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPriceTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/price-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetPriceTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getTransactionTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/transaction-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetTransactionTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getManualTransactionTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/manual-transaction-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualTransactionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetManualTransactionTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getTransactionSources(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/transaction-sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetTransactionSources(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getTokenTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/token-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetTokenTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllTokenTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/all-token-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTokenTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTokenTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetAllTokenTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPayoutTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/payout-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayoutTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayoutTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetPayoutTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getBankAccountTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/bank-account-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetBankAccountTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getMintingOptions(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/minting-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMintingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMintingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetMintingOptions(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getCountries(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getCountriesCodes(): Observable<StringLookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/countries-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringLookupModel[]>;
        }));
    }

    protected processGetCountriesCodes(response: HttpResponseBase): Observable<StringLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/user-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetUserTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getBrokers(searchTerm?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/brokers?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrokers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrokers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetBrokers(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getQualityAssessors(searchTerm?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/quality-assessors?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualityAssessors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualityAssessors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetQualityAssessors(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/payment-frequencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentFrequencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentFrequencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetPaymentFrequencies(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getCurrencyTokens(): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencyTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencyTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetCurrencyTokens(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getMarketplaceListingTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/marketplace-listing-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarketplaceListingTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketplaceListingTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetMarketplaceListingTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getMarketplaceListingStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/marketplace-listing-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarketplaceListingStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketplaceListingStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetMarketplaceListingStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPledgeStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/pledge-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPledgeStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPledgeStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetPledgeStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getShareholderMeetingStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/shareholder-meeting-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShareholderMeetingStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShareholderMeetingStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetShareholderMeetingStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getMfaTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/mfa-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMfaTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMfaTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetMfaTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorDocumentTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-document-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorDocumentTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorSourceOfFunds(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-source-of-funds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorSourceOfFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorSourceOfFunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorSourceOfFunds(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorEmploymentStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-employment-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorEmploymentStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorEmploymentStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorEmploymentStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorYearlyNetIncomeRanges(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-yearly-net-income-ranges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorYearlyNetIncomeRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorYearlyNetIncomeRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorYearlyNetIncomeRanges(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorNetWorthRanges(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-net-worth-ranges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorNetWorthRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorNetWorthRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorNetWorthRanges(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorExcpectedYearlyInvestment(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/investor-expected-yearly-investment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorExcpectedYearlyInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorExcpectedYearlyInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetInvestorExcpectedYearlyInvestment(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getLabourTaskStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/labour-task-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabourTaskStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourTaskStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetLabourTaskStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getConstraintStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/constraint-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstraintStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstraintStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetConstraintStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getConstraintTypes(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/constraint-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstraintTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstraintTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetConstraintTypes(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getContractStatus(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/contract-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetContractStatus(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getQuoteStatus(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/quote-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetQuoteStatus(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getOverheadStatus(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/overhead-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverheadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverheadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetOverheadStatus(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getMaterialStatuses(): Observable<Int32LookupModel[]> {
        let url_ = this.baseUrl + "/api/lookups/material-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32LookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32LookupModel[]>;
        }));
    }

    protected processGetMaterialStatuses(response: HttpResponseBase): Observable<Int32LookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Int32LookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32LookupModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MarketplaceListingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<MarketplaceListingDisplayModel | null> {
        let url_ = this.baseUrl + "/api/marketplace-listings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketplaceListingDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketplaceListingDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MarketplaceListingDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MarketplaceListingDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarketplaceListingDisplayModel | null>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/marketplace-listings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param typeId (optional)
     * @param isAvailable (optional)
     * @param tokenIds (optional)
     * @param paymentTokenIds (optional)
     * @param statusIds (optional)
     * @param excludeListingsByInvestorId (optional)
     * @param minPrice (optional)
     * @param maxPrice (optional)
     * @param investorId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, typeId?: number | undefined, isAvailable?: boolean | undefined, tokenIds?: string[] | undefined, paymentTokenIds?: string[] | undefined, statusIds?: number[] | undefined, excludeListingsByInvestorId?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, investorId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<MarketplaceListingDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/marketplace-listings?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentTokenIds === null)
            throw new Error("The parameter 'paymentTokenIds' cannot be null.");
        else if (paymentTokenIds !== undefined)
            paymentTokenIds && paymentTokenIds.forEach(item => { url_ += "PaymentTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeListingsByInvestorId === null)
            throw new Error("The parameter 'excludeListingsByInvestorId' cannot be null.");
        else if (excludeListingsByInvestorId !== undefined)
            url_ += "ExcludeListingsByInvestorId=" + encodeURIComponent("" + excludeListingsByInvestorId) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketplaceListingDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketplaceListingDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<MarketplaceListingDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketplaceListingDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarketplaceListingDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: MarketplaceListingInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/marketplace-listings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param typeId (optional)
     * @param isAvailable (optional)
     * @param tokenIds (optional)
     * @param paymentTokenIds (optional)
     * @param statusIds (optional)
     * @param excludeListingsByInvestorId (optional)
     * @param minPrice (optional)
     * @param maxPrice (optional)
     * @param investorId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, typeId?: number | undefined, isAvailable?: boolean | undefined, tokenIds?: string[] | undefined, paymentTokenIds?: string[] | undefined, statusIds?: number[] | undefined, excludeListingsByInvestorId?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, investorId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/marketplace-listings/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentTokenIds === null)
            throw new Error("The parameter 'paymentTokenIds' cannot be null.");
        else if (paymentTokenIds !== undefined)
            paymentTokenIds && paymentTokenIds.forEach(item => { url_ += "PaymentTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeListingsByInvestorId === null)
            throw new Error("The parameter 'excludeListingsByInvestorId' cannot be null.");
        else if (excludeListingsByInvestorId !== undefined)
            url_ += "ExcludeListingsByInvestorId=" + encodeURIComponent("" + excludeListingsByInvestorId) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param typeId (optional)
     * @param isAvailable (optional)
     * @param tokenIds (optional)
     * @param paymentTokenIds (optional)
     * @param statusIds (optional)
     * @param excludeListingsByInvestorId (optional)
     * @param minPrice (optional)
     * @param maxPrice (optional)
     * @param investorId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, typeId?: number | undefined, isAvailable?: boolean | undefined, tokenIds?: string[] | undefined, paymentTokenIds?: string[] | undefined, statusIds?: number[] | undefined, excludeListingsByInvestorId?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, investorId?: string | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/marketplace-listings/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentTokenIds === null)
            throw new Error("The parameter 'paymentTokenIds' cannot be null.");
        else if (paymentTokenIds !== undefined)
            paymentTokenIds && paymentTokenIds.forEach(item => { url_ += "PaymentTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeListingsByInvestorId === null)
            throw new Error("The parameter 'excludeListingsByInvestorId' cannot be null.");
        else if (excludeListingsByInvestorId !== undefined)
            url_ += "ExcludeListingsByInvestorId=" + encodeURIComponent("" + excludeListingsByInvestorId) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param search (optional)
     * @param typeId (optional)
     * @param isAvailable (optional)
     * @param tokenIds (optional)
     * @param paymentTokenIds (optional)
     * @param statusIds (optional)
     * @param excludeListingsByInvestorId (optional)
     * @param minPrice (optional)
     * @param maxPrice (optional)
     * @param investorId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    adminSearch(search?: string | undefined, typeId?: number | undefined, isAvailable?: boolean | undefined, tokenIds?: string[] | undefined, paymentTokenIds?: string[] | undefined, statusIds?: number[] | undefined, excludeListingsByInvestorId?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, investorId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<MarketplaceListingAdminDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/marketplace-listings/admin?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (paymentTokenIds === null)
            throw new Error("The parameter 'paymentTokenIds' cannot be null.");
        else if (paymentTokenIds !== undefined)
            paymentTokenIds && paymentTokenIds.forEach(item => { url_ += "PaymentTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeListingsByInvestorId === null)
            throw new Error("The parameter 'excludeListingsByInvestorId' cannot be null.");
        else if (excludeListingsByInvestorId !== undefined)
            url_ += "ExcludeListingsByInvestorId=" + encodeURIComponent("" + excludeListingsByInvestorId) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketplaceListingAdminDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketplaceListingAdminDisplayModelPagedResult>;
        }));
    }

    protected processAdminSearch(response: HttpResponseBase): Observable<MarketplaceListingAdminDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketplaceListingAdminDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarketplaceListingAdminDisplayModelPagedResult>(null as any);
    }

    /**
     * @return Success
     */
    approveListing(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/marketplace-listings/{id}/approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    rejectListing(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/marketplace-listings/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    fulfillListing(id: string, amount: number): Observable<string> {
        let url_ = this.baseUrl + "/api/marketplace-listings/{id}/fulfill/{amount}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined.");
        url_ = url_.replace("{amount}", encodeURIComponent("" + amount));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFulfillListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFulfillListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFulfillListing(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tokenId (optional)
     * @param paymentTokenId (optional)
     * @return Success
     */
    getOrderBookForPair(tokenId?: string | undefined, paymentTokenId?: string | undefined): Observable<OrderBookModel | null> {
        let url_ = this.baseUrl + "/api/marketplace-listings/order-book/:tokenId/:paymentTokenId?";
        if (tokenId === null)
            throw new Error("The parameter 'tokenId' cannot be null.");
        else if (tokenId !== undefined)
            url_ += "tokenId=" + encodeURIComponent("" + tokenId) + "&";
        if (paymentTokenId === null)
            throw new Error("The parameter 'paymentTokenId' cannot be null.");
        else if (paymentTokenId !== undefined)
            url_ += "paymentTokenId=" + encodeURIComponent("" + paymentTokenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderBookForPair(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderBookForPair(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderBookModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderBookModel | null>;
        }));
    }

    protected processGetOrderBookForPair(response: HttpResponseBase): Observable<OrderBookModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrderBookModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderBookModel | null>(null as any);
    }

    /**
     * @param tokenId (optional)
     * @param paymentTokenId (optional)
     * @return Success
     */
    getFulfillmentHistory(tokenId?: string | undefined, paymentTokenId?: string | undefined): Observable<(FulfillmentHistoryEntry | undefined)[]> {
        let url_ = this.baseUrl + "/api/marketplace-listings/fulfillment-history/:tokenId/:paymentTokenId?";
        if (tokenId === null)
            throw new Error("The parameter 'tokenId' cannot be null.");
        else if (tokenId !== undefined)
            url_ += "tokenId=" + encodeURIComponent("" + tokenId) + "&";
        if (paymentTokenId === null)
            throw new Error("The parameter 'paymentTokenId' cannot be null.");
        else if (paymentTokenId !== undefined)
            url_ += "paymentTokenId=" + encodeURIComponent("" + paymentTokenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFulfillmentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFulfillmentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(FulfillmentHistoryEntry | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(FulfillmentHistoryEntry | undefined)[]>;
        }));
    }

    protected processGetFulfillmentHistory(response: HttpResponseBase): Observable<(FulfillmentHistoryEntry | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FulfillmentHistoryEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(FulfillmentHistoryEntry | undefined)[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PledgesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<PledgeDisplayModel | null> {
        let url_ = this.baseUrl + "/api/pledges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PledgeDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PledgeDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PledgeDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: PledgeInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/pledges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/pledges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param sourceAccountId (optional)
     * @param pledgeStatusIds (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, sourceAccountId?: string | undefined, pledgeStatusIds?: number[] | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<PledgeDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/pledges?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sourceAccountId === null)
            throw new Error("The parameter 'sourceAccountId' cannot be null.");
        else if (sourceAccountId !== undefined)
            url_ += "SourceAccountId=" + encodeURIComponent("" + sourceAccountId) + "&";
        if (pledgeStatusIds === null)
            throw new Error("The parameter 'pledgeStatusIds' cannot be null.");
        else if (pledgeStatusIds !== undefined)
            pledgeStatusIds && pledgeStatusIds.forEach(item => { url_ += "PledgeStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PledgeDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PledgeDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PledgeDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PledgeDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PledgeDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: PledgeInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/pledges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param sourceAccountId (optional)
     * @param pledgeStatusIds (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, sourceAccountId?: string | undefined, pledgeStatusIds?: number[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/pledges/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sourceAccountId === null)
            throw new Error("The parameter 'sourceAccountId' cannot be null.");
        else if (sourceAccountId !== undefined)
            url_ += "SourceAccountId=" + encodeURIComponent("" + sourceAccountId) + "&";
        if (pledgeStatusIds === null)
            throw new Error("The parameter 'pledgeStatusIds' cannot be null.");
        else if (pledgeStatusIds !== undefined)
            pledgeStatusIds && pledgeStatusIds.forEach(item => { url_ += "PledgeStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    cancelPledge(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/pledges/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPledge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    executePledge(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/pledges/{id}/execute";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecutePledge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecutePledge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecutePledge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<ProductDisplayModel | null> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProductDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: ProductInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param includeNonPublicProducts (optional)
     * @param search (optional)
     * @param projectId (optional)
     * @param statusIds (optional)
     * @param canBePurchasedWithTokenId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(includeNonPublicProducts?: boolean | undefined, search?: string | undefined, projectId?: string | undefined, statusIds?: number[] | undefined, canBePurchasedWithTokenId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ProductDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/products?";
        if (includeNonPublicProducts === null)
            throw new Error("The parameter 'includeNonPublicProducts' cannot be null.");
        else if (includeNonPublicProducts !== undefined)
            url_ += "IncludeNonPublicProducts=" + encodeURIComponent("" + includeNonPublicProducts) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (canBePurchasedWithTokenId === null)
            throw new Error("The parameter 'canBePurchasedWithTokenId' cannot be null.");
        else if (canBePurchasedWithTokenId !== undefined)
            url_ += "CanBePurchasedWithTokenId=" + encodeURIComponent("" + canBePurchasedWithTokenId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ProductDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: ProductInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param includeNonPublicProducts (optional)
     * @param search (optional)
     * @param projectId (optional)
     * @param statusIds (optional)
     * @param canBePurchasedWithTokenId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(includeNonPublicProducts?: boolean | undefined, search?: string | undefined, projectId?: string | undefined, statusIds?: number[] | undefined, canBePurchasedWithTokenId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/products/export?";
        if (includeNonPublicProducts === null)
            throw new Error("The parameter 'includeNonPublicProducts' cannot be null.");
        else if (includeNonPublicProducts !== undefined)
            url_ += "IncludeNonPublicProducts=" + encodeURIComponent("" + includeNonPublicProducts) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (canBePurchasedWithTokenId === null)
            throw new Error("The parameter 'canBePurchasedWithTokenId' cannot be null.");
        else if (canBePurchasedWithTokenId !== undefined)
            url_ += "CanBePurchasedWithTokenId=" + encodeURIComponent("" + canBePurchasedWithTokenId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    updateStatus(id: string, statusId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}/status/{statusId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    verifyQuantityIsAvailable(id: string, qty: number): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}/verify-availability/{qty}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (qty === undefined || qty === null)
            throw new Error("The parameter 'qty' must be defined.");
        url_ = url_.replace("{qty}", encodeURIComponent("" + qty));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyQuantityIsAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyQuantityIsAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyQuantityIsAvailable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAvailableQuantity(id: string): Observable<number> {
        let url_ = this.baseUrl + "/api/products/{id}/available-qty";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAvailableQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentOptions(id: string): Observable<(ProductPaymentOptionDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/products/{id}/payment-options";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProductPaymentOptionDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProductPaymentOptionDisplayModel | undefined)[]>;
        }));
    }

    protected processGetPaymentOptions(response: HttpResponseBase): Observable<(ProductPaymentOptionDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductPaymentOptionDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProductPaymentOptionDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addPaymentOption(id: string, body?: ProductPaymentOptionInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/products/{id}/payment-options";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPaymentOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPaymentOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddPaymentOption(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePaymentOption(id: string, body?: ProductPaymentOptionInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/products/payment-options/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaymentOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deletePaymentOption(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/payment-options/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePaymentOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePaymentOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getComponents(id: string): Observable<(ProductComponentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/products/{id}/components";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProductComponentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProductComponentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetComponents(response: HttpResponseBase): Observable<(ProductComponentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductComponentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProductComponentDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addComponent(id: string, body?: ProductComponentInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/products/{id}/components";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddComponent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    deleteComponent(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/components/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<ProjectDisplayModel | null> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: ProjectInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param isFeatured (optional)
     * @param name (optional)
     * @param typeIds (optional)
     * @param returnTypeIds (optional)
     * @param statusIds (optional)
     * @param isPublic (optional)
     * @param hasDates (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, isFeatured?: boolean | undefined, name?: string | undefined, typeIds?: number[] | undefined, returnTypeIds?: number[] | undefined, statusIds?: number[] | undefined, isPublic?: boolean | undefined, hasDates?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ProjectDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/projects?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isFeatured === null)
            throw new Error("The parameter 'isFeatured' cannot be null.");
        else if (isFeatured !== undefined)
            url_ += "IsFeatured=" + encodeURIComponent("" + isFeatured) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "TypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (returnTypeIds === null)
            throw new Error("The parameter 'returnTypeIds' cannot be null.");
        else if (returnTypeIds !== undefined)
            returnTypeIds && returnTypeIds.forEach(item => { url_ += "ReturnTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (hasDates === null)
            throw new Error("The parameter 'hasDates' cannot be null.");
        else if (hasDates !== undefined)
            url_ += "HasDates=" + encodeURIComponent("" + hasDates) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ProjectDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: ProjectInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param isFeatured (optional)
     * @param name (optional)
     * @param typeIds (optional)
     * @param returnTypeIds (optional)
     * @param statusIds (optional)
     * @param isPublic (optional)
     * @param hasDates (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, isFeatured?: boolean | undefined, name?: string | undefined, typeIds?: number[] | undefined, returnTypeIds?: number[] | undefined, statusIds?: number[] | undefined, isPublic?: boolean | undefined, hasDates?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isFeatured === null)
            throw new Error("The parameter 'isFeatured' cannot be null.");
        else if (isFeatured !== undefined)
            url_ += "IsFeatured=" + encodeURIComponent("" + isFeatured) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "TypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (returnTypeIds === null)
            throw new Error("The parameter 'returnTypeIds' cannot be null.");
        else if (returnTypeIds !== undefined)
            returnTypeIds && returnTypeIds.forEach(item => { url_ += "ReturnTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (hasDates === null)
            throw new Error("The parameter 'hasDates' cannot be null.");
        else if (hasDates !== undefined)
            url_ += "HasDates=" + encodeURIComponent("" + hasDates) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    toggleFeaturedStatus(projectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/toggle-featured";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleFeaturedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleFeaturedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleFeaturedStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    publishProject(projectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/publish";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    closeProject(projectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/close";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    openProject(projectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/open";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpenProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTotalFundsRaisedForProject(projectId: string): Observable<ProjectFundRaisingTotalModel | null> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/total-funds-raised-for-project";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalFundsRaisedForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalFundsRaisedForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFundRaisingTotalModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFundRaisingTotalModel | null>;
        }));
    }

    protected processGetTotalFundsRaisedForProject(response: HttpResponseBase): Observable<ProjectFundRaisingTotalModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectFundRaisingTotalModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFundRaisingTotalModel | null>(null as any);
    }

    /**
     * @return Success
     */
    getProjectDocuments(projectId: string): Observable<(ProjectDocumentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/documents";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectDocumentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectDocumentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetProjectDocuments(response: HttpResponseBase): Observable<(ProjectDocumentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDocumentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectDocumentDisplayModel | undefined)[]>(null as any);
    }

  /**
   * @return Success
   */
  getProjectOverviewForPurchaseTransaction(purchaseId: string): Observable<(ProjectOverviewModel | null)> {
    let url_ = this.baseUrl + "/api/projects/overview-for-purchase-transaction/{purchaseId}";
    if (purchaseId === undefined || purchaseId === null)
      throw new Error("The parameter 'purchaseId' must be defined.");
    url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProjectOverviewForPurchaseTransaction(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProjectOverviewForPurchaseTransaction(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<(ProjectOverviewModel | undefined)>;
        }
      } else
        return _observableThrow(response_) as any as Observable<(ProjectOverviewModel | undefined)>;
    }));
  }

  protected processGetProjectOverviewForPurchaseTransaction(response: HttpResponseBase): Observable<(ProjectOverviewModel | null)> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? ProjectOverviewModel.fromJS(resultData200) : <any>null;
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<(ProjectOverviewModel | undefined)>(null as any);
  }

  /**
   * @return Success
   */
  getProjectBankAccounts(projectId: string): Observable<(BankAccountDisplayModel | undefined)[]> {
    let url_ = this.baseUrl + "/api/projects/{projectId}/bank-accounts";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetProjectBankAccounts(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProjectBankAccounts(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<(BankAccountDisplayModel | undefined)[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<(BankAccountDisplayModel | undefined)[]>;
    }));
  }

  protected processGetProjectBankAccounts(response: HttpResponseBase): Observable<(BankAccountDisplayModel | undefined)[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(BankAccountDisplayModel.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<(BankAccountDisplayModel | undefined)[]>(null as any);
  }

    /**
     * @param body (optional)
     * @return Success
     */
    addProjectDocument(projectId: string, body?: ProjectDocumentInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/documents";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProjectDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderProjectDocuments(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/documents/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderProjectDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderProjectDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderProjectDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    editProjectDocument(projectDocumentId: string, body?: ProjectDocumentInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/documents/{projectDocumentId}";
        if (projectDocumentId === undefined || projectDocumentId === null)
            throw new Error("The parameter 'projectDocumentId' must be defined.");
        url_ = url_.replace("{projectDocumentId}", encodeURIComponent("" + projectDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditProjectDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteProjectDocument(projectDocumentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/documents/{projectDocumentId}";
        if (projectDocumentId === undefined || projectDocumentId === null)
            throw new Error("The parameter 'projectDocumentId' must be defined.");
        url_ = url_.replace("{projectDocumentId}", encodeURIComponent("" + projectDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getProjectImages(projectId: string): Observable<(ProjectImageModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/images";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectImageModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectImageModel | undefined)[]>;
        }));
    }

    protected processGetProjectImages(response: HttpResponseBase): Observable<(ProjectImageModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectImageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectImageModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addProjectImage(projectId: string, body?: ProjectImageInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/images";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProjectImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderProjectImages(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/images/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderProjectImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderProjectImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderProjectImages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteProjectImage(projectImageId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/images/{projectImageId}";
        if (projectImageId === undefined || projectImageId === null)
            throw new Error("The parameter 'projectImageId' must be defined.");
        url_ = url_.replace("{projectImageId}", encodeURIComponent("" + projectImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getProjectVideos(projectId: string): Observable<(ProjectVideoModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/videos";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectVideos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectVideos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectVideoModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectVideoModel | undefined)[]>;
        }));
    }

    protected processGetProjectVideos(response: HttpResponseBase): Observable<(ProjectVideoModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectVideoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectVideoModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addProjectVideo(projectId: string, body?: ProjectVideoInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}videos";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProjectVideo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderProjectVideos(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/videos/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderProjectVideos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderProjectVideos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderProjectVideos(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteProjectVideo(projectVideoId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/videos/{projectVideoId}";
        if (projectVideoId === undefined || projectVideoId === null)
            throw new Error("The parameter 'projectVideoId' must be defined.");
        url_ = url_.replace("{projectVideoId}", encodeURIComponent("" + projectVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectVideo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getFeaturedProjects(): Observable<(ProjectDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/projects/featured";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeaturedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectDisplayModel | undefined)[]>;
        }));
    }

    protected processGetFeaturedProjects(response: HttpResponseBase): Observable<(ProjectDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderFeaturedProjects(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/featured/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderFeaturedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderFeaturedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderFeaturedProjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param isFeatured (optional)
     * @param name (optional)
     * @param typeIds (optional)
     * @param returnTypeIds (optional)
     * @param statusIds (optional)
     * @param isPublic (optional)
     * @param hasDates (optional)
     * @param orderBy (optional)
     * @return Success
     */
    searchLookups(search?: string | undefined, isFeatured?: boolean | undefined, name?: string | undefined, typeIds?: number[] | undefined, returnTypeIds?: number[] | undefined, statusIds?: number[] | undefined, isPublic?: boolean | undefined, hasDates?: boolean | undefined, orderBy?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/projects/lookups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isFeatured === null)
            throw new Error("The parameter 'isFeatured' cannot be null.");
        else if (isFeatured !== undefined)
            url_ += "IsFeatured=" + encodeURIComponent("" + isFeatured) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "TypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (returnTypeIds === null)
            throw new Error("The parameter 'returnTypeIds' cannot be null.");
        else if (returnTypeIds !== undefined)
            returnTypeIds && returnTypeIds.forEach(item => { url_ += "ReturnTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (hasDates === null)
            throw new Error("The parameter 'hasDates' cannot be null.");
        else if (hasDates !== undefined)
            url_ += "HasDates=" + encodeURIComponent("" + hasDates) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processSearchLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PurchasesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<PurchaseDisplayModel | null> {
        let url_ = this.baseUrl + "/api/purchases/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PurchaseDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseDisplayModel | null>(null as any);
    }

    /**
     * @param search (optional)
     * @param investorIds (optional)
     * @param productIds (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param isReservation (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, investorIds?: string[] | undefined, productIds?: string[] | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, isReservation?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<PurchaseDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/purchases?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (investorIds === null)
            throw new Error("The parameter 'investorIds' cannot be null.");
        else if (investorIds !== undefined)
            investorIds && investorIds.forEach(item => { url_ += "InvestorIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isReservation === null)
            throw new Error("The parameter 'isReservation' cannot be null.");
        else if (isReservation !== undefined)
            url_ += "IsReservation=" + encodeURIComponent("" + isReservation) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PurchaseDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseDisplayModelPagedResult>(null as any);
    }

    /**
     * @param productId (optional)
     * @param productPaymentOptionId (optional)
     * @param qty (optional)
     * @return Success
     */
    purchaseProduct(productId?: string | undefined, productPaymentOptionId?: string | undefined, qty?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/purchases?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productPaymentOptionId === null)
            throw new Error("The parameter 'productPaymentOptionId' cannot be null.");
        else if (productPaymentOptionId !== undefined)
            url_ += "productPaymentOptionId=" + encodeURIComponent("" + productPaymentOptionId) + "&";
        if (qty === null)
            throw new Error("The parameter 'qty' cannot be null.");
        else if (qty !== undefined)
            url_ += "qty=" + encodeURIComponent("" + qty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPurchaseProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param investorIds (optional)
     * @param productIds (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param isReservation (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, investorIds?: string[] | undefined, productIds?: string[] | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, isReservation?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/purchases/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (investorIds === null)
            throw new Error("The parameter 'investorIds' cannot be null.");
        else if (investorIds !== undefined)
            investorIds && investorIds.forEach(item => { url_ += "InvestorIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isReservation === null)
            throw new Error("The parameter 'isReservation' cannot be null.");
        else if (isReservation !== undefined)
            url_ += "IsReservation=" + encodeURIComponent("" + isReservation) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional)
     * @param productPaymentOptionId (optional)
     * @param qty (optional)
     * @param effectiveDate (optional)
     * @return Success
     */
    reserveProduct(productId?: string | undefined, productPaymentOptionId?: string | undefined, qty?: number | undefined, effectiveDate?: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/purchases/reserve?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productPaymentOptionId === null)
            throw new Error("The parameter 'productPaymentOptionId' cannot be null.");
        else if (productPaymentOptionId !== undefined)
            url_ += "productPaymentOptionId=" + encodeURIComponent("" + productPaymentOptionId) + "&";
        if (qty === null)
            throw new Error("The parameter 'qty' cannot be null.");
        else if (qty !== undefined)
            url_ += "qty=" + encodeURIComponent("" + qty) + "&";
        if (effectiveDate === null)
            throw new Error("The parameter 'effectiveDate' cannot be null.");
        else if (effectiveDate !== undefined)
            url_ += "effectiveDate=" + encodeURIComponent(effectiveDate ? "" + effectiveDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReserveProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReserveProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReserveProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScheduledPayoutsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param payoutTypeIds (optional)
     * @param sourceTokenIds (optional)
     * @param payoutTokenIds (optional)
     * @param brokerId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, payoutTypeIds?: number[] | undefined, sourceTokenIds?: string[] | undefined, payoutTokenIds?: string[] | undefined, brokerId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ScheduledPayoutDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/scheduled-payouts?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (payoutTypeIds === null)
            throw new Error("The parameter 'payoutTypeIds' cannot be null.");
        else if (payoutTypeIds !== undefined)
            payoutTypeIds && payoutTypeIds.forEach(item => { url_ += "PayoutTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceTokenIds === null)
            throw new Error("The parameter 'sourceTokenIds' cannot be null.");
        else if (sourceTokenIds !== undefined)
            sourceTokenIds && sourceTokenIds.forEach(item => { url_ += "SourceTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (payoutTokenIds === null)
            throw new Error("The parameter 'payoutTokenIds' cannot be null.");
        else if (payoutTokenIds !== undefined)
            payoutTokenIds && payoutTokenIds.forEach(item => { url_ += "PayoutTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledPayoutDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledPayoutDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ScheduledPayoutDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledPayoutDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledPayoutDisplayModelPagedResult>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param payoutTypeIds (optional)
     * @param sourceTokenIds (optional)
     * @param payoutTokenIds (optional)
     * @param brokerId (optional)
     * @return Success
     */
    getScheduledPayouts(fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, payoutTypeIds?: number[] | undefined, sourceTokenIds?: string[] | undefined, payoutTokenIds?: string[] | undefined, brokerId?: string | undefined): Observable<(ScheduledPayoutDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/scheduled-payouts/get-scheduled-payouts?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (payoutTypeIds === null)
            throw new Error("The parameter 'payoutTypeIds' cannot be null.");
        else if (payoutTypeIds !== undefined)
            payoutTypeIds && payoutTypeIds.forEach(item => { url_ += "PayoutTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceTokenIds === null)
            throw new Error("The parameter 'sourceTokenIds' cannot be null.");
        else if (sourceTokenIds !== undefined)
            sourceTokenIds && sourceTokenIds.forEach(item => { url_ += "SourceTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (payoutTokenIds === null)
            throw new Error("The parameter 'payoutTokenIds' cannot be null.");
        else if (payoutTokenIds !== undefined)
            payoutTokenIds && payoutTokenIds.forEach(item => { url_ += "PayoutTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduledPayouts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduledPayouts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ScheduledPayoutDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ScheduledPayoutDisplayModel | undefined)[]>;
        }));
    }

    protected processGetScheduledPayouts(response: HttpResponseBase): Observable<(ScheduledPayoutDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledPayoutDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ScheduledPayoutDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param payoutTypeIds (optional)
     * @param sourceTokenIds (optional)
     * @param payoutTokenIds (optional)
     * @param brokerId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, payoutTypeIds?: number[] | undefined, sourceTokenIds?: string[] | undefined, payoutTokenIds?: string[] | undefined, brokerId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduled-payouts/export?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (payoutTypeIds === null)
            throw new Error("The parameter 'payoutTypeIds' cannot be null.");
        else if (payoutTypeIds !== undefined)
            payoutTypeIds && payoutTypeIds.forEach(item => { url_ += "PayoutTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceTokenIds === null)
            throw new Error("The parameter 'sourceTokenIds' cannot be null.");
        else if (sourceTokenIds !== undefined)
            sourceTokenIds && sourceTokenIds.forEach(item => { url_ += "SourceTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (payoutTokenIds === null)
            throw new Error("The parameter 'payoutTokenIds' cannot be null.");
        else if (payoutTokenIds !== undefined)
            payoutTokenIds && payoutTokenIds.forEach(item => { url_ += "PayoutTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param payoutTypeIds (optional)
     * @param sourceTokenIds (optional)
     * @param payoutTokenIds (optional)
     * @param brokerId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, payoutTypeIds?: number[] | undefined, sourceTokenIds?: string[] | undefined, payoutTokenIds?: string[] | undefined, brokerId?: string | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/scheduled-payouts/send-email?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (payoutTypeIds === null)
            throw new Error("The parameter 'payoutTypeIds' cannot be null.");
        else if (payoutTypeIds !== undefined)
            payoutTypeIds && payoutTypeIds.forEach(item => { url_ += "PayoutTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceTokenIds === null)
            throw new Error("The parameter 'sourceTokenIds' cannot be null.");
        else if (sourceTokenIds !== undefined)
            sourceTokenIds && sourceTokenIds.forEach(item => { url_ += "SourceTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (payoutTokenIds === null)
            throw new Error("The parameter 'payoutTokenIds' cannot be null.");
        else if (payoutTokenIds !== undefined)
            payoutTokenIds && payoutTokenIds.forEach(item => { url_ += "PayoutTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param accountId (optional)
     * @param payoutTypeIds (optional)
     * @param sourceTokenIds (optional)
     * @param payoutTokenIds (optional)
     * @param brokerId (optional)
     * @return Success
     */
    report(fromDate?: Date | undefined, toDate?: Date | undefined, accountId?: string | undefined, payoutTypeIds?: number[] | undefined, sourceTokenIds?: string[] | undefined, payoutTokenIds?: string[] | undefined, brokerId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduled-payouts/report?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (payoutTypeIds === null)
            throw new Error("The parameter 'payoutTypeIds' cannot be null.");
        else if (payoutTypeIds !== undefined)
            payoutTypeIds && payoutTypeIds.forEach(item => { url_ += "PayoutTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceTokenIds === null)
            throw new Error("The parameter 'sourceTokenIds' cannot be null.");
        else if (sourceTokenIds !== undefined)
            sourceTokenIds && sourceTokenIds.forEach(item => { url_ += "SourceTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (payoutTokenIds === null)
            throw new Error("The parameter 'payoutTokenIds' cannot be null.");
        else if (payoutTokenIds !== undefined)
            payoutTokenIds && payoutTokenIds.forEach(item => { url_ += "PayoutTokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScheduledTokenConversionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param tokenIds (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(fromDate?: Date | undefined, toDate?: Date | undefined, tokenIds?: string[] | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ScheduledTokenConversionDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/scheduledTokenConversions?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledTokenConversionDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledTokenConversionDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ScheduledTokenConversionDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledTokenConversionDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledTokenConversionDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: ScheduledTokenConversionInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/scheduledTokenConversions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param tokenIds (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(fromDate?: Date | undefined, toDate?: Date | undefined, tokenIds?: string[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduledTokenConversions/export?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: ScheduledTokenConversionInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduledTokenConversions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduledTokenConversions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<ClientOptions | null> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientOptions | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientOptions | null>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<ClientOptions | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClientOptions.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientOptions | null>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShareholderMeetingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<ShareholderMeetingDisplayModel | null> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareholderMeetingDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareholderMeetingDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ShareholderMeetingDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShareholderMeetingDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShareholderMeetingDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: ShareholderMeetingInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param projectId (optional)
     * @param statusIds (optional)
     * @param isPublic (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(projectId?: string | undefined, statusIds?: number[] | undefined, isPublic?: boolean | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ShareholderMeetingDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/shareholder-meetings?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareholderMeetingDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareholderMeetingDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ShareholderMeetingDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareholderMeetingDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShareholderMeetingDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: ShareholderMeetingInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/shareholder-meetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param projectId (optional)
     * @param statusIds (optional)
     * @param isPublic (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(projectId?: string | undefined, statusIds?: number[] | undefined, isPublic?: boolean | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/export?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "StatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    publishMeeting(meetingId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/publish";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishMeeting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    startMeeting(meetingId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/start";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartMeeting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    endMeeting(meetingId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/end";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEndMeeting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getResolutions(meetingId: string): Observable<(ShareholderMeetingResolutionDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/resolutions";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ShareholderMeetingResolutionDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ShareholderMeetingResolutionDisplayModel | undefined)[]>;
        }));
    }

    protected processGetResolutions(response: HttpResponseBase): Observable<(ShareholderMeetingResolutionDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareholderMeetingResolutionDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ShareholderMeetingResolutionDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addResolution(meetingId: string, body?: ShareholderMeetingResolutionInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/resolutions";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddResolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddResolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddResolution(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderResolutions(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderResolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderResolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderResolutions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getResolution(resolutionId: string): Observable<ShareholderMeetingResolutionDisplayModel | null> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/{resolutionId}";
        if (resolutionId === undefined || resolutionId === null)
            throw new Error("The parameter 'resolutionId' must be defined.");
        url_ = url_.replace("{resolutionId}", encodeURIComponent("" + resolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareholderMeetingResolutionDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareholderMeetingResolutionDisplayModel | null>;
        }));
    }

    protected processGetResolution(response: HttpResponseBase): Observable<ShareholderMeetingResolutionDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShareholderMeetingResolutionDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShareholderMeetingResolutionDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    editResolution(resolutionId: string, body?: ShareholderMeetingResolutionInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/{resolutionId}";
        if (resolutionId === undefined || resolutionId === null)
            throw new Error("The parameter 'resolutionId' must be defined.");
        url_ = url_.replace("{resolutionId}", encodeURIComponent("" + resolutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditResolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditResolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditResolution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteResolution(resolutionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/{resolutionId}";
        if (resolutionId === undefined || resolutionId === null)
            throw new Error("The parameter 'resolutionId' must be defined.");
        url_ = url_.replace("{resolutionId}", encodeURIComponent("" + resolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteResolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteResolution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getDocuments(meetingId: string): Observable<(ShareholderMeetingDocumentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/documents";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ShareholderMeetingDocumentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ShareholderMeetingDocumentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<(ShareholderMeetingDocumentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareholderMeetingDocumentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ShareholderMeetingDocumentDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addDocument(meetingId: string, body?: ShareholderMeetingDocumentInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/documents";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reorderDocuments(body?: (ReorderModel | undefined)[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/documents/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    editDocument(documentId: string, body?: ShareholderMeetingDocumentInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteDocument(documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    castVote(resolutionId: string, votingOptionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/{resolutionId}/vote/{votingOptionId}";
        if (resolutionId === undefined || resolutionId === null)
            throw new Error("The parameter 'resolutionId' must be defined.");
        url_ = url_.replace("{resolutionId}", encodeURIComponent("" + resolutionId));
        if (votingOptionId === undefined || votingOptionId === null)
            throw new Error("The parameter 'votingOptionId' must be defined.");
        url_ = url_.replace("{votingOptionId}", encodeURIComponent("" + votingOptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCastVote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCastVote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCastVote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getResultsForResolution(resolutionId: string): Observable<(VotingResultModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/resolutions/{resolutionId}/results";
        if (resolutionId === undefined || resolutionId === null)
            throw new Error("The parameter 'resolutionId' must be defined.");
        url_ = url_.replace("{resolutionId}", encodeURIComponent("" + resolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultsForResolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultsForResolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(VotingResultModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(VotingResultModel | undefined)[]>;
        }));
    }

    protected processGetResultsForResolution(response: HttpResponseBase): Observable<(VotingResultModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VotingResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(VotingResultModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getUnspentVotingTokensForInvestor(): Observable<(VotingTokenBalanceModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/my-unspent-votes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnspentVotingTokensForInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnspentVotingTokensForInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(VotingTokenBalanceModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(VotingTokenBalanceModel | undefined)[]>;
        }));
    }

    protected processGetUnspentVotingTokensForInvestor(response: HttpResponseBase): Observable<(VotingTokenBalanceModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VotingTokenBalanceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(VotingTokenBalanceModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingsShareholders(meetingId: string): Observable<(InvestorDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{meetingId}/shareholders";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeetingsShareholders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeetingsShareholders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(InvestorDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(InvestorDisplayModel | undefined)[]>;
        }));
    }

    protected processGetMeetingsShareholders(response: HttpResponseBase): Observable<(InvestorDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestorDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(InvestorDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorMeetings(investorId: string): Observable<(ShareholderMeetingDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/shareholder-meetings/{investorId}/meetings";
        if (investorId === undefined || investorId === null)
            throw new Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ShareholderMeetingDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ShareholderMeetingDisplayModel | undefined)[]>;
        }));
    }

    protected processGetInvestorMeetings(response: HttpResponseBase): Observable<(ShareholderMeetingDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareholderMeetingDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ShareholderMeetingDisplayModel | undefined)[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SuppliersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param search (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<SupplierDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/suppliers?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SupplierDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierDisplayModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    importSuppliers(contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/importSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportSuppliers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param orderBy (optional)
     * @return Success
     */
    searchLookups(search?: string | undefined, orderBy?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/suppliers/lookups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processSearchLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TokensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<TokenDisplayModel | null> {
        let url_ = this.baseUrl + "/api/tokens/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TokenDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TokenDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: TokenInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/tokens/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/tokens/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param projectId (optional)
     * @param tokenTypeIds (optional)
     * @param isTradeable (optional)
     * @param ignoreVotingTokens (optional)
     * @param ignoreLoanToValueAggregatorTokens (optional)
     * @param onlyFaceValueTokens (optional)
     * @param onlyLTVAggregatorTokens (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, projectId?: string | undefined, tokenTypeIds?: number[] | undefined, isTradeable?: boolean | undefined, ignoreVotingTokens?: boolean | undefined, ignoreLoanToValueAggregatorTokens?: boolean | undefined, onlyFaceValueTokens?: boolean | undefined, onlyLTVAggregatorTokens?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<TokenDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/tokens?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isTradeable === null)
            throw new Error("The parameter 'isTradeable' cannot be null.");
        else if (isTradeable !== undefined)
            url_ += "IsTradeable=" + encodeURIComponent("" + isTradeable) + "&";
        if (ignoreVotingTokens === null)
            throw new Error("The parameter 'ignoreVotingTokens' cannot be null.");
        else if (ignoreVotingTokens !== undefined)
            url_ += "IgnoreVotingTokens=" + encodeURIComponent("" + ignoreVotingTokens) + "&";
        if (ignoreLoanToValueAggregatorTokens === null)
            throw new Error("The parameter 'ignoreLoanToValueAggregatorTokens' cannot be null.");
        else if (ignoreLoanToValueAggregatorTokens !== undefined)
            url_ += "IgnoreLoanToValueAggregatorTokens=" + encodeURIComponent("" + ignoreLoanToValueAggregatorTokens) + "&";
        if (onlyFaceValueTokens === null)
            throw new Error("The parameter 'onlyFaceValueTokens' cannot be null.");
        else if (onlyFaceValueTokens !== undefined)
            url_ += "OnlyFaceValueTokens=" + encodeURIComponent("" + onlyFaceValueTokens) + "&";
        if (onlyLTVAggregatorTokens === null)
            throw new Error("The parameter 'onlyLTVAggregatorTokens' cannot be null.");
        else if (onlyLTVAggregatorTokens !== undefined)
            url_ += "OnlyLTVAggregatorTokens=" + encodeURIComponent("" + onlyLTVAggregatorTokens) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<TokenDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: TokenInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param projectId (optional)
     * @param tokenTypeIds (optional)
     * @param isTradeable (optional)
     * @param ignoreVotingTokens (optional)
     * @param ignoreLoanToValueAggregatorTokens (optional)
     * @param onlyFaceValueTokens (optional)
     * @param onlyLTVAggregatorTokens (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, projectId?: string | undefined, tokenTypeIds?: number[] | undefined, isTradeable?: boolean | undefined, ignoreVotingTokens?: boolean | undefined, ignoreLoanToValueAggregatorTokens?: boolean | undefined, onlyFaceValueTokens?: boolean | undefined, onlyLTVAggregatorTokens?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/tokens/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isTradeable === null)
            throw new Error("The parameter 'isTradeable' cannot be null.");
        else if (isTradeable !== undefined)
            url_ += "IsTradeable=" + encodeURIComponent("" + isTradeable) + "&";
        if (ignoreVotingTokens === null)
            throw new Error("The parameter 'ignoreVotingTokens' cannot be null.");
        else if (ignoreVotingTokens !== undefined)
            url_ += "IgnoreVotingTokens=" + encodeURIComponent("" + ignoreVotingTokens) + "&";
        if (ignoreLoanToValueAggregatorTokens === null)
            throw new Error("The parameter 'ignoreLoanToValueAggregatorTokens' cannot be null.");
        else if (ignoreLoanToValueAggregatorTokens !== undefined)
            url_ += "IgnoreLoanToValueAggregatorTokens=" + encodeURIComponent("" + ignoreLoanToValueAggregatorTokens) + "&";
        if (onlyFaceValueTokens === null)
            throw new Error("The parameter 'onlyFaceValueTokens' cannot be null.");
        else if (onlyFaceValueTokens !== undefined)
            url_ += "OnlyFaceValueTokens=" + encodeURIComponent("" + onlyFaceValueTokens) + "&";
        if (onlyLTVAggregatorTokens === null)
            throw new Error("The parameter 'onlyLTVAggregatorTokens' cannot be null.");
        else if (onlyLTVAggregatorTokens !== undefined)
            url_ += "OnlyLTVAggregatorTokens=" + encodeURIComponent("" + onlyLTVAggregatorTokens) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param projectId (optional)
     * @param tokenTypeIds (optional)
     * @param isTradeable (optional)
     * @param ignoreVotingTokens (optional)
     * @param ignoreLoanToValueAggregatorTokens (optional)
     * @param onlyFaceValueTokens (optional)
     * @param onlyLTVAggregatorTokens (optional)
     * @param orderBy (optional)
     * @return Success
     */
    searchLookups(search?: string | undefined, projectId?: string | undefined, tokenTypeIds?: number[] | undefined, isTradeable?: boolean | undefined, ignoreVotingTokens?: boolean | undefined, ignoreLoanToValueAggregatorTokens?: boolean | undefined, onlyFaceValueTokens?: boolean | undefined, onlyLTVAggregatorTokens?: boolean | undefined, orderBy?: string | undefined): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/tokens/lookups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isTradeable === null)
            throw new Error("The parameter 'isTradeable' cannot be null.");
        else if (isTradeable !== undefined)
            url_ += "IsTradeable=" + encodeURIComponent("" + isTradeable) + "&";
        if (ignoreVotingTokens === null)
            throw new Error("The parameter 'ignoreVotingTokens' cannot be null.");
        else if (ignoreVotingTokens !== undefined)
            url_ += "IgnoreVotingTokens=" + encodeURIComponent("" + ignoreVotingTokens) + "&";
        if (ignoreLoanToValueAggregatorTokens === null)
            throw new Error("The parameter 'ignoreLoanToValueAggregatorTokens' cannot be null.");
        else if (ignoreLoanToValueAggregatorTokens !== undefined)
            url_ += "IgnoreLoanToValueAggregatorTokens=" + encodeURIComponent("" + ignoreLoanToValueAggregatorTokens) + "&";
        if (onlyFaceValueTokens === null)
            throw new Error("The parameter 'onlyFaceValueTokens' cannot be null.");
        else if (onlyFaceValueTokens !== undefined)
            url_ += "OnlyFaceValueTokens=" + encodeURIComponent("" + onlyFaceValueTokens) + "&";
        if (onlyLTVAggregatorTokens === null)
            throw new Error("The parameter 'onlyLTVAggregatorTokens' cannot be null.");
        else if (onlyLTVAggregatorTokens !== undefined)
            url_ += "OnlyLTVAggregatorTokens=" + encodeURIComponent("" + onlyLTVAggregatorTokens) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processSearchLookups(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }

    /**
     * @return Success
     */
    deployToken(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/tokens/{id}/deploy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeployToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getValues(id: string): Observable<(TokenValueDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/tokens/{id}/values";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenValueDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenValueDisplayModel | undefined)[]>;
        }));
    }

    protected processGetValues(response: HttpResponseBase): Observable<(TokenValueDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenValueDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenValueDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addValue(id: string, body?: TokenValueInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/tokens/{id}/values";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    deleteValue(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/tokens/values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteValue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getInterestCalculationInfo(id: string): Observable<InterestCalculationInfoModel | null> {
        let url_ = this.baseUrl + "/api/tokens/{id}/interest-multipliers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterestCalculationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterestCalculationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterestCalculationInfoModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterestCalculationInfoModel | null>;
        }));
    }

    protected processGetInterestCalculationInfo(response: HttpResponseBase): Observable<InterestCalculationInfoModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InterestCalculationInfoModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InterestCalculationInfoModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setTokenConfiguration(body?: InvestorTokenConfigurationInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/tokens/investor-token-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTokenConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTokenConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetTokenConfiguration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getDepositDetails(id: string): Observable<UtilityTokenDepositDetailsDisplayModel | null> {
        let url_ = this.baseUrl + "/api/tokens/{id}/deposit-details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepositDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepositDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityTokenDepositDetailsDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityTokenDepositDetailsDisplayModel | null>;
        }));
    }

    protected processGetDepositDetails(response: HttpResponseBase): Observable<UtilityTokenDepositDetailsDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UtilityTokenDepositDetailsDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityTokenDepositDetailsDisplayModel | null>(null as any);
    }

    /**
     * @param value (optional)
     * @return Success
     */
    searchFaceValueTokenTypes(value?: string | undefined): Observable<(TokenType | undefined)[]> {
        let url_ = this.baseUrl + "/api/tokens/face-value-token-types?";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFaceValueTokenTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFaceValueTokenTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TokenType | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TokenType | undefined)[]>;
        }));
    }

    protected processSearchFaceValueTokenTypes(response: HttpResponseBase): Observable<(TokenType | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TokenType | undefined)[]>(null as any);
    }

    /**
     * @param dateTime (optional)
     * @return Success
     */
    getCurrentFaceValue(id: string, dateTime?: Date | undefined): Observable<DecimalEthereumResponse> {
        let url_ = this.baseUrl + "/api/tokens/{id}/current-face-value?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentFaceValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentFaceValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalEthereumResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalEthereumResponse>;
        }));
    }

    protected processGetCurrentFaceValue(response: HttpResponseBase): Observable<DecimalEthereumResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalEthereumResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DecimalEthereumResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentLoanToValueRatio(id: string): Observable<DecimalEthereumResponse> {
        let url_ = this.baseUrl + "/api/tokens/{id}/loan-to-value";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoanToValueRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoanToValueRatio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalEthereumResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalEthereumResponse>;
        }));
    }

    protected processGetCurrentLoanToValueRatio(response: HttpResponseBase): Observable<DecimalEthereumResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalEthereumResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DecimalEthereumResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<TransactionDisplayModel | null> {
        let url_ = this.baseUrl + "/api/transactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TransactionDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: TransactionInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/transactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param accountId (optional)
     * @param accountId2 (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param tokenTypeIds (optional)
     * @param isOutstanding (optional)
     * @param transactionSourceId (optional)
     * @param tokenIds (optional)
     * @param search (optional)
     * @param ignoreVotingTokens (optional)
     * @param brokerId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(accountId?: string | undefined, accountId2?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, tokenTypeIds?: number[] | undefined, isOutstanding?: boolean | undefined, transactionSourceId?: number | undefined, tokenIds?: string[] | undefined, search?: string | undefined, ignoreVotingTokens?: boolean | undefined, brokerId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<TransactionDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/transactions?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (accountId2 === null)
            throw new Error("The parameter 'accountId2' cannot be null.");
        else if (accountId2 !== undefined)
            url_ += "AccountId2=" + encodeURIComponent("" + accountId2) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isOutstanding === null)
            throw new Error("The parameter 'isOutstanding' cannot be null.");
        else if (isOutstanding !== undefined)
            url_ += "IsOutstanding=" + encodeURIComponent("" + isOutstanding) + "&";
        if (transactionSourceId === null)
            throw new Error("The parameter 'transactionSourceId' cannot be null.");
        else if (transactionSourceId !== undefined)
            url_ += "TransactionSourceId=" + encodeURIComponent("" + transactionSourceId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (ignoreVotingTokens === null)
            throw new Error("The parameter 'ignoreVotingTokens' cannot be null.");
        else if (ignoreVotingTokens !== undefined)
            url_ += "IgnoreVotingTokens=" + encodeURIComponent("" + ignoreVotingTokens) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<TransactionDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: TransactionInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/transactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accountId (optional)
     * @param accountId2 (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param tokenTypeIds (optional)
     * @param isOutstanding (optional)
     * @param transactionSourceId (optional)
     * @param tokenIds (optional)
     * @param search (optional)
     * @param ignoreVotingTokens (optional)
     * @param brokerId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(accountId?: string | undefined, accountId2?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, tokenTypeIds?: number[] | undefined, isOutstanding?: boolean | undefined, transactionSourceId?: number | undefined, tokenIds?: string[] | undefined, search?: string | undefined, ignoreVotingTokens?: boolean | undefined, brokerId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/transactions/export?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (accountId2 === null)
            throw new Error("The parameter 'accountId2' cannot be null.");
        else if (accountId2 !== undefined)
            url_ += "AccountId2=" + encodeURIComponent("" + accountId2) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (tokenTypeIds === null)
            throw new Error("The parameter 'tokenTypeIds' cannot be null.");
        else if (tokenTypeIds !== undefined)
            tokenTypeIds && tokenTypeIds.forEach(item => { url_ += "TokenTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isOutstanding === null)
            throw new Error("The parameter 'isOutstanding' cannot be null.");
        else if (isOutstanding !== undefined)
            url_ += "IsOutstanding=" + encodeURIComponent("" + isOutstanding) + "&";
        if (transactionSourceId === null)
            throw new Error("The parameter 'transactionSourceId' cannot be null.");
        else if (transactionSourceId !== undefined)
            url_ += "TransactionSourceId=" + encodeURIComponent("" + transactionSourceId) + "&";
        if (tokenIds === null)
            throw new Error("The parameter 'tokenIds' cannot be null.");
        else if (tokenIds !== undefined)
            tokenIds && tokenIds.forEach(item => { url_ += "TokenIds=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (ignoreVotingTokens === null)
            throw new Error("The parameter 'ignoreVotingTokens' cannot be null.");
        else if (ignoreVotingTokens !== undefined)
            url_ += "IgnoreVotingTokens=" + encodeURIComponent("" + ignoreVotingTokens) + "&";
        if (brokerId === null)
            throw new Error("The parameter 'brokerId' cannot be null.");
        else if (brokerId !== undefined)
            url_ += "BrokerId=" + encodeURIComponent("" + brokerId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tokenId (optional)
     * @param amount (optional)
     * @param destinationAddress (optional)
     * @return Success
     */
    transferTokensToExternalWallet(tokenId?: string | undefined, amount?: number | undefined, destinationAddress?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/transactions/transfer/external-wallet?";
        if (tokenId === null)
            throw new Error("The parameter 'tokenId' cannot be null.");
        else if (tokenId !== undefined)
            url_ += "TokenId=" + encodeURIComponent("" + tokenId) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (destinationAddress === null)
            throw new Error("The parameter 'destinationAddress' cannot be null.");
        else if (destinationAddress !== undefined)
            url_ += "DestinationAddress=" + encodeURIComponent("" + destinationAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferTokensToExternalWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferTokensToExternalWallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTransferTokensToExternalWallet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UploadsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadFile(containerName: string, contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/uploads/{containerName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    secureUrl(body?: SecureBlobUrlRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/uploads/secure-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecureUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecureUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSecureUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    importMailingList(contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/uploads/import/mailing-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMailingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMailingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportMailingList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param containerName (optional)
     * @param attachmentModels (optional)
     * @return Success
     */
    getAttachments(containerName?: string | undefined, attachmentModels?: string | undefined): Observable<(FileModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/uploads/attachments?";
        if (containerName === null)
            throw new Error("The parameter 'containerName' cannot be null.");
        else if (containerName !== undefined)
            url_ += "containerName=" + encodeURIComponent("" + containerName) + "&";
        if (attachmentModels === null)
            throw new Error("The parameter 'attachmentModels' cannot be null.");
        else if (attachmentModels !== undefined)
            url_ += "attachmentModels=" + encodeURIComponent("" + attachmentModels) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(FileModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(FileModel | undefined)[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<(FileModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(FileModel | undefined)[]>(null as any);
    }

    /**
     * @param containerName (optional)
     * @param messageId (optional)
     * @return Success
     */
    getHtmlFileContent(containerName?: string | undefined, messageId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/uploads/email-content?";
        if (containerName === null)
            throw new Error("The parameter 'containerName' cannot be null.");
        else if (containerName !== undefined)
            url_ += "containerName=" + encodeURIComponent("" + containerName) + "&";
        if (messageId === null)
            throw new Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHtmlFileContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHtmlFileContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHtmlFileContent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<UserDisplayModel | null> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<UserDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: UserInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param emailAddress (optional)
     * @param firstName (optional)
     * @param lastName (optional)
     * @param userTypeIds (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, emailAddress?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, userTypeIds?: number[] | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<UserListModelPagedResult> {
        let url_ = this.baseUrl + "/api/users?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (userTypeIds === null)
            throw new Error("The parameter 'userTypeIds' cannot be null.");
        else if (userTypeIds !== undefined)
            userTypeIds && userTypeIds.forEach(item => { url_ += "UserTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<UserListModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserListModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: UserInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param emailAddress (optional)
     * @param firstName (optional)
     * @param lastName (optional)
     * @param userTypeIds (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, emailAddress?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, userTypeIds?: number[] | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (userTypeIds === null)
            throw new Error("The parameter 'userTypeIds' cannot be null.");
        else if (userTypeIds !== undefined)
            userTypeIds && userTypeIds.forEach(item => { url_ += "UserTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param utm_source (optional)
     * @param utm_medium (optional)
     * @param utm_campaign (optional)
     * @param utm_term (optional)
     * @param utm_content (optional)
     * @param body (optional)
     * @return Success
     */
    register(utm_source?: string | undefined, utm_medium?: string | undefined, utm_campaign?: string | undefined, utm_term?: string | undefined, utm_content?: string | undefined, body?: UserRegistrationModel | null | undefined): Observable<UserRegistrationResponse | null> {
        let url_ = this.baseUrl + "/api/users/register?";
        if (utm_source === null)
            throw new Error("The parameter 'utm_source' cannot be null.");
        else if (utm_source !== undefined)
            url_ += "utm_source=" + encodeURIComponent("" + utm_source) + "&";
        if (utm_medium === null)
            throw new Error("The parameter 'utm_medium' cannot be null.");
        else if (utm_medium !== undefined)
            url_ += "utm_medium=" + encodeURIComponent("" + utm_medium) + "&";
        if (utm_campaign === null)
            throw new Error("The parameter 'utm_campaign' cannot be null.");
        else if (utm_campaign !== undefined)
            url_ += "utm_campaign=" + encodeURIComponent("" + utm_campaign) + "&";
        if (utm_term === null)
            throw new Error("The parameter 'utm_term' cannot be null.");
        else if (utm_term !== undefined)
            url_ += "utm_term=" + encodeURIComponent("" + utm_term) + "&";
        if (utm_content === null)
            throw new Error("The parameter 'utm_content' cannot be null.");
        else if (utm_content !== undefined)
            url_ += "utm_content=" + encodeURIComponent("" + utm_content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRegistrationResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRegistrationResponse | null>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<UserRegistrationResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserRegistrationResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegistrationResponse | null>(null as any);
    }

    /**
     * @return Success
     */
    validate(token: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/users/validate/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    requireMfa(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/users/require-mfa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequireMfa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequireMfa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequireMfa(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    verifyLogin(body?: LoginRequest | null | undefined): Observable<UserVerificationResponse | null> {
        let url_ = this.baseUrl + "/api/users/verify-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVerificationResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVerificationResponse | null>;
        }));
    }

    protected processVerifyLogin(response: HttpResponseBase): Observable<UserVerificationResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserVerificationResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserVerificationResponse | null>(null as any);
    }

    /**
     * @param utm_source (optional)
     * @param utm_medium (optional)
     * @param utm_campaign (optional)
     * @param utm_term (optional)
     * @param utm_content (optional)
     * @param body (optional)
     * @return Success
     */
    login(utm_source?: string | undefined, utm_medium?: string | undefined, utm_campaign?: string | undefined, utm_term?: string | undefined, utm_content?: string | undefined, body?: LoginRequest | null | undefined): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/users/login?";
        if (utm_source === null)
            throw new Error("The parameter 'utm_source' cannot be null.");
        else if (utm_source !== undefined)
            url_ += "utm_source=" + encodeURIComponent("" + utm_source) + "&";
        if (utm_medium === null)
            throw new Error("The parameter 'utm_medium' cannot be null.");
        else if (utm_medium !== undefined)
            url_ += "utm_medium=" + encodeURIComponent("" + utm_medium) + "&";
        if (utm_campaign === null)
            throw new Error("The parameter 'utm_campaign' cannot be null.");
        else if (utm_campaign !== undefined)
            url_ += "utm_campaign=" + encodeURIComponent("" + utm_campaign) + "&";
        if (utm_term === null)
            throw new Error("The parameter 'utm_term' cannot be null.");
        else if (utm_term !== undefined)
            url_ += "utm_term=" + encodeURIComponent("" + utm_term) + "&";
        if (utm_content === null)
            throw new Error("The parameter 'utm_content' cannot be null.");
        else if (utm_content !== undefined)
            url_ += "utm_content=" + encodeURIComponent("" + utm_content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse | null>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(null as any);
    }

    /**
     * @param newEmail (optional)
     * @param body (optional)
     * @return Success
     */
    updateEmail(newEmail?: string | undefined, body?: LoginRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/update-email?";
        if (newEmail === null)
            throw new Error("The parameter 'newEmail' cannot be null.");
        else if (newEmail !== undefined)
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDispEmail(body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/update-disp-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDispEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDispEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDispEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    enableMfa(body?: EnableMfaRequest | null | undefined): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/users/mfa/enable-mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableMfa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableMfa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse | null>;
        }));
    }

    protected processEnableMfa(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestDispAuthentication(body?: LoginRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/users/request-disp-authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDispAuthentication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDispAuthentication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRequestDispAuthentication(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    completeDispAuthentication(token: string): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/users/complete-disp-authentication/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteDispAuthentication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteDispAuthentication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse | null>;
        }));
    }

    protected processCompleteDispAuthentication(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(null as any);
    }

    /**
     * @return Success
     */
    refreshToken(): Observable<RefreshTokenResponse | null> {
        let url_ = this.baseUrl + "/api/users/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResponse | null>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RefreshTokenResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResponse | null>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUserAccountDetails(): Observable<UserAccountModel | null> {
        let url_ = this.baseUrl + "/api/users/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountModel | null>;
        }));
    }

    protected processGetCurrentUserAccountDetails(response: HttpResponseBase): Observable<UserAccountModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserAccountModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccountModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCurrentUserAccountDetails(body?: UserProfileInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserAccountDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getLoggedInUserAccountDetails(): Observable<UserAccountModel | null> {
        let url_ = this.baseUrl + "/api/users/account/logged-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedInUserAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedInUserAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountModel | null>;
        }));
    }

    protected processGetLoggedInUserAccountDetails(response: HttpResponseBase): Observable<UserAccountModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserAccountModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccountModel | null>(null as any);
    }

    /**
     * @return Success
     */
    getUserAccountDetails(id: string): Observable<UserAccountModel | null> {
        let url_ = this.baseUrl + "/api/users/account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountModel | null>;
        }));
    }

    protected processGetUserAccountDetails(response: HttpResponseBase): Observable<UserAccountModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserAccountModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccountModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    confirmEmail(body?: EmailVerificationRequestModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body?: PasswordResetRequestModel | null | undefined): Observable<PasswordResetResponse | null> {
        let url_ = this.baseUrl + "/api/users/password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PasswordResetResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PasswordResetResponse | null>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<PasswordResetResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PasswordResetResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PasswordResetResponse | null>(null as any);
    }

    /**
     * @return Success
     */
    validatePasswordResetToken(passwordResetToken: string): Observable<void> {
        let url_ = this.baseUrl + "/api/users/validate-password-reset-token/{passwordResetToken}";
        if (passwordResetToken === undefined || passwordResetToken === null)
            throw new Error("The parameter 'passwordResetToken' must be defined.");
        url_ = url_.replace("{passwordResetToken}", encodeURIComponent("" + passwordResetToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePasswordResetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePasswordResetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePasswordResetToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    completePasswordReset(body?: PasswordChangeWithTokenInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password-reset-confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompletePasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body?: PasswordChangeWithCurrentPasswordInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password-change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deactivatePassword(): Observable<string> {
        let url_ = this.baseUrl + "/api/users/password-deactivate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeactivatePassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeProfilePicture(body?: ProfilePictureChangeInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/profile-picture-change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    contactUs(body?: ContactUsInputModel | null | undefined): Observable<ContactUsResponse | null> {
        let url_ = this.baseUrl + "/api/users/contact-us";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactUs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactUsResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactUsResponse | null>;
        }));
    }

    protected processContactUs(response: HttpResponseBase): Observable<ContactUsResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ContactUsResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactUsResponse | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    collectContactDetails(body?: CollectContactDetailsInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/collect-contact-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectContactDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectContactDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCollectContactDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getNewTermsToAccept(): Observable<(TermsToAcceptDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/users/new-terms-to-accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewTermsToAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewTermsToAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TermsToAcceptDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TermsToAcceptDisplayModel | undefined)[]>;
        }));
    }

    protected processGetNewTermsToAccept(response: HttpResponseBase): Observable<(TermsToAcceptDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermsToAcceptDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TermsToAcceptDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param termIds (optional)
     * @return Success
     */
    acceptTerms(termIds?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/accept-terms?";
        if (termIds === null)
            throw new Error("The parameter 'termIds' cannot be null.");
        else if (termIds !== undefined)
            termIds && termIds.forEach(item => { url_ += "termIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptTerms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    sendWelcomeEmail(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/users/{id}/send-welcome-email";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWelcomeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWelcomeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendWelcomeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTemplateEmail(body?: EmailMessageInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/send-template-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTemplateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTemplateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTemplateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    registerSandbox(body?: UserRegistrationModel | null | undefined): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/users/register-sandbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterSandbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterSandbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse | null>;
        }));
    }

    protected processRegisterSandbox(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestDisableMFA(body?: DisableMFARequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/mfa/disable/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDisableMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDisableMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestDisableMFA(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param token (optional)
     * @return Success
     */
    disableMFA(token?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/mfa/disable/:token?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableMFA(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    registerSmsMfa(body?: AuthyUserInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/mfa/register-sms-mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterSmsMfa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterSmsMfa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterSmsMfa(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param emailAddress (optional)
     * @return Success
     */
    sendSmsVerification(emailAddress?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/mfa/send-sms-verification?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSmsVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSmsVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSmsVerification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resendRegisterSmsMfaVerification(body?: AuthyUserInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/mfa/resend-register-sms-mfa-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendRegisterSmsMfaVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendRegisterSmsMfaVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendRegisterSmsMfaVerification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestDispRegistration(body?: DispRegistrationModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/users/request-disp-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDispRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDispRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRequestDispRegistration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    completeDispRegistration(token: string): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/users/complete-disp-registration/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteDispRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteDispRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse | null>;
        }));
    }

    protected processCompleteDispRegistration(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(null as any);
    }

    /**
     * @param page (optional)
     * @return Success
     */
    getTwilioEventLog(page?: number | undefined): Observable<AuthyEventResponse | null> {
        let url_ = this.baseUrl + "/api/users/twilioEventLog?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwilioEventLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwilioEventLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthyEventResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthyEventResponse | null>;
        }));
    }

    protected processGetTwilioEventLog(response: HttpResponseBase): Observable<AuthyEventResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthyEventResponse.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthyEventResponse | null>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksConstraintClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addConstraint(id: string, body?: TaskConstraintInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-constraints/{id}/add-constraint";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConstraint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConstraint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddConstraint(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    deleteConstraint(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-constraints/{id}/delete-constraint";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConstraint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConstraint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConstraint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getConstraints(id: string): Observable<(TaskConstraintDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-constraints/{id}/constraints";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstraints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstraints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TaskConstraintDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TaskConstraintDisplayModel | undefined)[]>;
        }));
    }

    protected processGetConstraints(response: HttpResponseBase): Observable<(TaskConstraintDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskConstraintDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TaskConstraintDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    markConstraintSucceeded(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-constraints/{id}/mark-constraint-succeeded";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkConstraintSucceeded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkConstraintSucceeded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkConstraintSucceeded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constraintId (optional)
     * @return Success
     */
    getPrerequisites(constraintId?: string | undefined): Observable<(TaskPrerequisiteDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-constraints/get-prerequisites?";
        if (constraintId === null)
            throw new Error("The parameter 'constraintId' cannot be null.");
        else if (constraintId !== undefined)
            url_ += "constraintId=" + encodeURIComponent("" + constraintId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrerequisites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrerequisites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TaskPrerequisiteDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TaskPrerequisiteDisplayModel | undefined)[]>;
        }));
    }

    protected processGetPrerequisites(response: HttpResponseBase): Observable<(TaskPrerequisiteDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskPrerequisiteDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TaskPrerequisiteDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param taskId (optional)
     * @return Success
     */
    getPotentialPrerequisites(taskId?: string | undefined): Observable<(TaskConstraintDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-constraints/get-potential-prerequisites?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPotentialPrerequisites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPotentialPrerequisites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TaskConstraintDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TaskConstraintDisplayModel | undefined)[]>;
        }));
    }

    protected processGetPotentialPrerequisites(response: HttpResponseBase): Observable<(TaskConstraintDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskConstraintDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TaskConstraintDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPrerequisite(body?: TaskPrerequisiteInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-constraints/create-prerequisite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrerequisite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrerequisite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePrerequisite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePrerequisite(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-constraints/delete-prerequisite?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrerequisite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrerequisite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePrerequisite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    activatePenalty(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-constraints/{id}/activate-penalty";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivatePenalty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivatePenalty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivatePenalty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksContractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<ContractDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ContractDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ContractDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDisplayModel | null>(null as any);
    }

    /**
     * @param search (optional)
     * @param weekDue (optional)
     * @param supplierId (optional)
     * @param contractStatuses (optional)
     * @param projectId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, weekDue?: number | undefined, supplierId?: string | undefined, contractStatuses?: number[] | undefined, projectId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<ContractDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-contract?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (contractStatuses === null)
            throw new Error("The parameter 'contractStatuses' cannot be null.");
        else if (contractStatuses !== undefined)
            contractStatuses && contractStatuses.forEach(item => { url_ += "ContractStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ContractDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDisplayModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param weekDue (optional)
     * @param supplierId (optional)
     * @param contractStatuses (optional)
     * @param projectId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, weekDue?: number | undefined, supplierId?: string | undefined, contractStatuses?: number[] | undefined, projectId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (contractStatuses === null)
            throw new Error("The parameter 'contractStatuses' cannot be null.");
        else if (contractStatuses !== undefined)
            contractStatuses && contractStatuses.forEach(item => { url_ += "ContractStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getContractTasks(id: string): Observable<(ContractTaskDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/contract-tasks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ContractTaskDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ContractTaskDisplayModel | undefined)[]>;
        }));
    }

    protected processGetContractTasks(response: HttpResponseBase): Observable<(ContractTaskDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractTaskDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ContractTaskDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getContractMaterials(id: string): Observable<(ContractMaterialDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/contract-materials";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ContractMaterialDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ContractMaterialDisplayModel | undefined)[]>;
        }));
    }

    protected processGetContractMaterials(response: HttpResponseBase): Observable<(ContractMaterialDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractMaterialDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ContractMaterialDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    accept(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/accept";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reject(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getContractReworkTasks(id: string): Observable<(TaskDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/get-rework-tasks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractReworkTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractReworkTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TaskDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TaskDisplayModel | undefined)[]>;
        }));
    }

    protected processGetContractReworkTasks(response: HttpResponseBase): Observable<(TaskDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TaskDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    freeze(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/freeze";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFreeze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFreeze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFreeze(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unfreeze(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/{id}/unfreeze";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnfreeze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnfreeze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnfreeze(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contractId (optional)
     * @return Success
     */
    payContract(contractId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/pay-contract?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPayContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contractId (optional)
     * @return Success
     */
    generateInvoice(contractId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/generate-invoice?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    cancelTaskOnContract(body?: CancelTaskInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/cancel-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTaskOnContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTaskOnContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelTaskOnContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param taskId (optional)
     * @return Success
     */
    acceptTaskCancelled(taskId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/confirm-cancel?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTaskCancelled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTaskCancelled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptTaskCancelled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param taskId (optional)
     * @return Success
     */
    rejectTaskCancelled(taskId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-contract/reject-cancel?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTaskCancelled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTaskCancelled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectTaskCancelled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksFulfillmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: MaterialFulfillmentInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-fulfillments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getFulfillments(id: string): Observable<(MaterialFulfillmentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-fulfillments/{id}/fulfillments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFulfillments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFulfillments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(MaterialFulfillmentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(MaterialFulfillmentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetFulfillments(response: HttpResponseBase): Observable<(MaterialFulfillmentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialFulfillmentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(MaterialFulfillmentDisplayModel | undefined)[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksMaterialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param search (optional)
     * @param materialStatusIds (optional)
     * @param projectId (optional)
     * @param weekDue (optional)
     * @param quantity (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, materialStatusIds?: number[] | undefined, projectId?: string | undefined, weekDue?: number | undefined, quantity?: number | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<MaterialDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-materials?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (materialStatusIds === null)
            throw new Error("The parameter 'materialStatusIds' cannot be null.");
        else if (materialStatusIds !== undefined)
            materialStatusIds && materialStatusIds.forEach(item => { url_ += "MaterialStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<MaterialDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaterialDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: MaterialInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param materialStatusIds (optional)
     * @param projectId (optional)
     * @param weekDue (optional)
     * @param quantity (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, materialStatusIds?: number[] | undefined, projectId?: string | undefined, weekDue?: number | undefined, quantity?: number | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (materialStatusIds === null)
            throw new Error("The parameter 'materialStatusIds' cannot be null.");
        else if (materialStatusIds !== undefined)
            materialStatusIds && materialStatusIds.forEach(item => { url_ += "MaterialStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<MaterialDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-materials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MaterialDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: MaterialInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getQuotableMaterials(): Observable<(MaterialDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-materials/get-quotable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuotableMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotableMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(MaterialDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(MaterialDisplayModel | undefined)[]>;
        }));
    }

    protected processGetQuotableMaterials(response: HttpResponseBase): Observable<(MaterialDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(MaterialDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    notifyPublished(): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/notify-published";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyPublished(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    cancel(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getValidCatalogs(id: string): Observable<(MaterialCatalogDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-materials/{id}/get-catalogs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidCatalogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidCatalogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(MaterialCatalogDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(MaterialCatalogDisplayModel | undefined)[]>;
        }));
    }

    protected processGetValidCatalogs(response: HttpResponseBase): Observable<(MaterialCatalogDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCatalogDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(MaterialCatalogDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    selectCatalog(body?: QuoteInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/select-catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createBulkQuote(body?: QuoteInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/create-bulk-quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBulkQuote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    importMaterials(contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-materials/import-materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportMaterials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksMaterialCatalogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<MaterialCatalogDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialCatalogDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialCatalogDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MaterialCatalogDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialCatalogDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialCatalogDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: MaterialCatalogInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param supplierId (optional)
     * @param validFromDate (optional)
     * @param validToDate (optional)
     * @param minQuantity (optional)
     * @param isAvailable (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, supplierId?: string | undefined, validFromDate?: Date | undefined, validToDate?: Date | undefined, minQuantity?: number | undefined, isAvailable?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<MaterialCatalogDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (validFromDate === null)
            throw new Error("The parameter 'validFromDate' cannot be null.");
        else if (validFromDate !== undefined)
            url_ += "ValidFromDate=" + encodeURIComponent(validFromDate ? "" + validFromDate.toISOString() : "") + "&";
        if (validToDate === null)
            throw new Error("The parameter 'validToDate' cannot be null.");
        else if (validToDate !== undefined)
            url_ += "ValidToDate=" + encodeURIComponent(validToDate ? "" + validToDate.toISOString() : "") + "&";
        if (minQuantity === null)
            throw new Error("The parameter 'minQuantity' cannot be null.");
        else if (minQuantity !== undefined)
            url_ += "MinQuantity=" + encodeURIComponent("" + minQuantity) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialCatalogDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialCatalogDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<MaterialCatalogDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaterialCatalogDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialCatalogDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: MaterialCatalogInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param supplierId (optional)
     * @param validFromDate (optional)
     * @param validToDate (optional)
     * @param minQuantity (optional)
     * @param isAvailable (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, supplierId?: string | undefined, validFromDate?: Date | undefined, validToDate?: Date | undefined, minQuantity?: number | undefined, isAvailable?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (validFromDate === null)
            throw new Error("The parameter 'validFromDate' cannot be null.");
        else if (validFromDate !== undefined)
            url_ += "ValidFromDate=" + encodeURIComponent(validFromDate ? "" + validFromDate.toISOString() : "") + "&";
        if (validToDate === null)
            throw new Error("The parameter 'validToDate' cannot be null.");
        else if (validToDate !== undefined)
            url_ += "ValidToDate=" + encodeURIComponent(validToDate ? "" + validToDate.toISOString() : "") + "&";
        if (minQuantity === null)
            throw new Error("The parameter 'minQuantity' cannot be null.");
        else if (minQuantity !== undefined)
            url_ += "MinQuantity=" + encodeURIComponent("" + minQuantity) + "&";
        if (isAvailable === null)
            throw new Error("The parameter 'isAvailable' cannot be null.");
        else if (isAvailable !== undefined)
            url_ += "IsAvailable=" + encodeURIComponent("" + isAvailable) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    cancel(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reinstate(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/{id}/reinstate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReinstate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReinstate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReinstate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    importMaterialCatalogs(contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-material-catalog/importMaterialCatalogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMaterialCatalogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMaterialCatalogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportMaterialCatalogs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksProjectDateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProjectDatesOverview(): Observable<(ProjectDateOverviewDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/project-dates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDatesOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDatesOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectDateOverviewDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectDateOverviewDisplayModel | undefined)[]>;
        }));
    }

    protected processGetProjectDatesOverview(response: HttpResponseBase): Observable<(ProjectDateOverviewDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDateOverviewDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectDateOverviewDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @return Success
     */
    getByProjectId(id: string): Observable<ProjectDateOverviewDisplayModel | null> {
        let url_ = this.baseUrl + "/api/project-dates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDateOverviewDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDateOverviewDisplayModel | null>;
        }));
    }

    protected processGetByProjectId(response: HttpResponseBase): Observable<ProjectDateOverviewDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectDateOverviewDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDateOverviewDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addWeeks(body?: ProjectDateInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/project-dates/dates-add-weeks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWeeks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWeeks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddWeeks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addProjectDate(body?: ProjectDateInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/project-dates/add-project-dates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProjectDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProjectDate(body?: ProjectDateUpdateModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/project-dates/update-project-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProjectDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksQuoteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<QuoteDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<QuoteDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QuoteDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: QuoteInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param quoteStatuses (optional)
     * @param supplierId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, quoteStatuses?: number[] | undefined, supplierId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<QuoteListDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-quote?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (quoteStatuses === null)
            throw new Error("The parameter 'quoteStatuses' cannot be null.");
        else if (quoteStatuses !== undefined)
            quoteStatuses && quoteStatuses.forEach(item => { url_ += "QuoteStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteListDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteListDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<QuoteListDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteListDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteListDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: QuoteInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param quoteStatuses (optional)
     * @param supplierId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, quoteStatuses?: number[] | undefined, supplierId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (quoteStatuses === null)
            throw new Error("The parameter 'quoteStatuses' cannot be null.");
        else if (quoteStatuses !== undefined)
            quoteStatuses && quoteStatuses.forEach(item => { url_ += "QuoteStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    cancel(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    accept(id: string, body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}/accept";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reject(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-quote/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<TaskDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TaskDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TaskDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: LabourTaskInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param taskStatusIds (optional)
     * @param projectId (optional)
     * @param weekDue (optional)
     * @param weekStart (optional)
     * @param supplierId (optional)
     * @param qualityAssessorId (optional)
     * @param onlyReturnQuoteableTasks (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, taskStatusIds?: number[] | undefined, projectId?: string | undefined, weekDue?: number | undefined, weekStart?: number | undefined, supplierId?: string | undefined, qualityAssessorId?: string | undefined, onlyReturnQuoteableTasks?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<TaskListDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-task?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (taskStatusIds === null)
            throw new Error("The parameter 'taskStatusIds' cannot be null.");
        else if (taskStatusIds !== undefined)
            taskStatusIds && taskStatusIds.forEach(item => { url_ += "TaskStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (weekStart === null)
            throw new Error("The parameter 'weekStart' cannot be null.");
        else if (weekStart !== undefined)
            url_ += "WeekStart=" + encodeURIComponent("" + weekStart) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (qualityAssessorId === null)
            throw new Error("The parameter 'qualityAssessorId' cannot be null.");
        else if (qualityAssessorId !== undefined)
            url_ += "QualityAssessorId=" + encodeURIComponent("" + qualityAssessorId) + "&";
        if (onlyReturnQuoteableTasks === null)
            throw new Error("The parameter 'onlyReturnQuoteableTasks' cannot be null.");
        else if (onlyReturnQuoteableTasks !== undefined)
            url_ += "OnlyReturnQuoteableTasks=" + encodeURIComponent("" + onlyReturnQuoteableTasks) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskListDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskListDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<TaskListDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskListDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: LabourTaskInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/weeks-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param taskStatusIds (optional)
     * @param projectId (optional)
     * @param weekDue (optional)
     * @param weekStart (optional)
     * @param supplierId (optional)
     * @param qualityAssessorId (optional)
     * @param onlyReturnQuoteableTasks (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, taskStatusIds?: number[] | undefined, projectId?: string | undefined, weekDue?: number | undefined, weekStart?: number | undefined, supplierId?: string | undefined, qualityAssessorId?: string | undefined, onlyReturnQuoteableTasks?: boolean | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (taskStatusIds === null)
            throw new Error("The parameter 'taskStatusIds' cannot be null.");
        else if (taskStatusIds !== undefined)
            taskStatusIds && taskStatusIds.forEach(item => { url_ += "TaskStatusIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weekDue === null)
            throw new Error("The parameter 'weekDue' cannot be null.");
        else if (weekDue !== undefined)
            url_ += "WeekDue=" + encodeURIComponent("" + weekDue) + "&";
        if (weekStart === null)
            throw new Error("The parameter 'weekStart' cannot be null.");
        else if (weekStart !== undefined)
            url_ += "WeekStart=" + encodeURIComponent("" + weekStart) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (qualityAssessorId === null)
            throw new Error("The parameter 'qualityAssessorId' cannot be null.");
        else if (qualityAssessorId !== undefined)
            url_ += "QualityAssessorId=" + encodeURIComponent("" + qualityAssessorId) + "&";
        if (onlyReturnQuoteableTasks === null)
            throw new Error("The parameter 'onlyReturnQuoteableTasks' cannot be null.");
        else if (onlyReturnQuoteableTasks !== undefined)
            url_ += "OnlyReturnQuoteableTasks=" + encodeURIComponent("" + onlyReturnQuoteableTasks) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    importTasks(contentType?: string | undefined, contentDisposition?: string | undefined, headers?: any | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/importTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportTasks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    allocate(id: string, body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}/allocate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllocate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllocate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAllocate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    cancel(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    markAsComplete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/{id}/mark-as-complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    notifyPublished(): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/notify-published";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyPublished(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkUpdateStartDueWeek(body?: BulkUpdateWeeksInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/bulk-update-weeks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateStartDueWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateStartDueWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateStartDueWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    allocateTasksToQualityAssessor(body?: AllocateTasksToQualityAssessorInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/allocate-tasks-to-quality-assessor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllocateTasksToQualityAssessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllocateTasksToQualityAssessor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAllocateTasksToQualityAssessor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createReworkTasks(body?: ReworkTaskInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task/create-rework-tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReworkTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReworkTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateReworkTasks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksTaskDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    linkDocument(body?: TaskDocumentProjectInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task-documents/link-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    importDocument(body?: TaskDocumentImportInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task-documents/add-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param taskId (optional)
     * @return Success
     */
    getTaskDocuments(taskId?: string | undefined): Observable<(TaskDocumentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-task-documents/task-documents?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(TaskDocumentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(TaskDocumentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetTaskDocuments(response: HttpResponseBase): Observable<(TaskDocumentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDocumentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(TaskDocumentDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param taskDocumentId (optional)
     * @return Success
     */
    unlinkTaskDocument(taskDocumentId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task-documents/delete-document?";
        if (taskDocumentId === null)
            throw new Error("The parameter 'taskDocumentId' cannot be null.");
        else if (taskDocumentId !== undefined)
            url_ += "taskDocumentId=" + encodeURIComponent("" + taskDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkTaskDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkTaskDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkTaskDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param projectIds (optional)
     * @return Success
     */
    getMultipleProjectsDocuments(projectIds?: string[] | undefined): Observable<(ProjectDocumentDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/weeks-task-documents/project-documents?";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultipleProjectsDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultipleProjectsDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(ProjectDocumentDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(ProjectDocumentDisplayModel | undefined)[]>;
        }));
    }

    protected processGetMultipleProjectsDocuments(response: HttpResponseBase): Observable<(ProjectDocumentDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDocumentDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(ProjectDocumentDisplayModel | undefined)[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeksTaskQuoteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<TaskQuoteDisplayModel | null> {
        let url_ = this.baseUrl + "/api/weeks-task-quote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskQuoteDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskQuoteDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TaskQuoteDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TaskQuoteDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskQuoteDisplayModel | null>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(id: string, body?: TaskQuoteInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task-quote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param supplierId (optional)
     * @param quoteId (optional)
     * @param quoteStatuses (optional)
     * @param labourTaskId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, supplierId?: string | undefined, quoteId?: string | undefined, quoteStatuses?: number[] | undefined, labourTaskId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<TaskQuoteDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/weeks-task-quote?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (quoteId === null)
            throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined)
            url_ += "QuoteId=" + encodeURIComponent("" + quoteId) + "&";
        if (quoteStatuses === null)
            throw new Error("The parameter 'quoteStatuses' cannot be null.");
        else if (quoteStatuses !== undefined)
            quoteStatuses && quoteStatuses.forEach(item => { url_ += "QuoteStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (labourTaskId === null)
            throw new Error("The parameter 'labourTaskId' cannot be null.");
        else if (labourTaskId !== undefined)
            url_ += "LabourTaskId=" + encodeURIComponent("" + labourTaskId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskQuoteDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskQuoteDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<TaskQuoteDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskQuoteDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskQuoteDisplayModelPagedResult>(null as any);
    }

    /**
     * @param search (optional)
     * @param supplierId (optional)
     * @param quoteId (optional)
     * @param quoteStatuses (optional)
     * @param labourTaskId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, supplierId?: string | undefined, quoteId?: string | undefined, quoteStatuses?: number[] | undefined, labourTaskId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/weeks-task-quote/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (quoteId === null)
            throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined)
            url_ += "QuoteId=" + encodeURIComponent("" + quoteId) + "&";
        if (quoteStatuses === null)
            throw new Error("The parameter 'quoteStatuses' cannot be null.");
        else if (quoteStatuses !== undefined)
            quoteStatuses && quoteStatuses.forEach(item => { url_ += "QuoteStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (labourTaskId === null)
            throw new Error("The parameter 'labourTaskId' cannot be null.");
        else if (labourTaskId !== undefined)
            url_ += "LabourTaskId=" + encodeURIComponent("" + labourTaskId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getSuppliersWithTaskQuote(taskId: string): Observable<GuidLookupModel[]> {
        let url_ = this.baseUrl + "/api/weeks-task-quote/{taskId}/getSuppliersWithTaskQuote";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliersWithTaskQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliersWithTaskQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidLookupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidLookupModel[]>;
        }));
    }

    protected processGetSuppliersWithTaskQuote(response: HttpResponseBase): Observable<GuidLookupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidLookupModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuidLookupModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WhitelistIpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    search(): Observable<(WhitelistIpDisplayModel | undefined)[]> {
        let url_ = this.baseUrl + "/api/whitelist-ip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<(WhitelistIpDisplayModel | undefined)[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<(WhitelistIpDisplayModel | undefined)[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<(WhitelistIpDisplayModel | undefined)[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhitelistIpDisplayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<(WhitelistIpDisplayModel | undefined)[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: WhitelistIpInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/whitelist-ip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/whitelist-ip/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WithdrawalsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: string): Observable<WithdrawalDisplayModel | null> {
        let url_ = this.baseUrl + "/api/withdrawals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithdrawalDisplayModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithdrawalDisplayModel | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<WithdrawalDisplayModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WithdrawalDisplayModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WithdrawalDisplayModel | null>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/withdrawals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param hasBeenProcessed (optional)
     * @param investorId (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param orderBy (optional)
     * @return Success
     */
    search(search?: string | undefined, hasBeenProcessed?: boolean | undefined, investorId?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined): Observable<WithdrawalDisplayModelPagedResult> {
        let url_ = this.baseUrl + "/api/withdrawals?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (hasBeenProcessed === null)
            throw new Error("The parameter 'hasBeenProcessed' cannot be null.");
        else if (hasBeenProcessed !== undefined)
            url_ += "HasBeenProcessed=" + encodeURIComponent("" + hasBeenProcessed) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithdrawalDisplayModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithdrawalDisplayModelPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<WithdrawalDisplayModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithdrawalDisplayModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WithdrawalDisplayModelPagedResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body?: WithdrawalInputModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/withdrawals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param search (optional)
     * @param hasBeenProcessed (optional)
     * @param investorId (optional)
     * @param orderBy (optional)
     * @return Success
     */
    export(search?: string | undefined, hasBeenProcessed?: boolean | undefined, investorId?: string | undefined, orderBy?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/withdrawals/export?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (hasBeenProcessed === null)
            throw new Error("The parameter 'hasBeenProcessed' cannot be null.");
        else if (hasBeenProcessed !== undefined)
            url_ += "HasBeenProcessed=" + encodeURIComponent("" + hasBeenProcessed) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param search (optional)
     * @param hasBeenProcessed (optional)
     * @param investorId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmail(search?: string | undefined, hasBeenProcessed?: boolean | undefined, investorId?: string | undefined, body?: EmailMessageInputModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/withdrawals/send-email?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (hasBeenProcessed === null)
            throw new Error("The parameter 'hasBeenProcessed' cannot be null.");
        else if (hasBeenProcessed !== undefined)
            url_ += "HasBeenProcessed=" + encodeURIComponent("" + hasBeenProcessed) + "&";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    convertToPurchase(body?: WithdrawalConversionInputModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/withdrawals/convertToPurchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToPurchase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToPurchase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConvertToPurchase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    markAsProcessed(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/withdrawals/{id}/mark-as-processed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsProcessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsProcessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsProcessed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AccountDisplayModel implements IAccountDisplayModel {
    id?: string;
    ethereumAddress?: string | undefined;

    constructor(data?: IAccountDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ethereumAddress = _data["ethereumAddress"];
        }
    }

    static fromJS(data: any): AccountDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ethereumAddress"] = this.ethereumAddress;
        return data;
    }
}

export interface IAccountDisplayModel {
    id?: string;
    ethereumAddress?: string | undefined;
}

export class AccountTokenBalanceModel implements IAccountTokenBalanceModel {
    accountId?: string | undefined;
    accountInvestorId?: string | undefined;
    accountName?: string | undefined;
    accountEthereumAddress?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountInvestorUserEmailAddress?: string | undefined;
    brokerId?: string;
    brokerName?: string | undefined;
    accountInvestorBrokerUserFirstName?: string | undefined;
    accountInvestorBrokerUserLastName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenEthereumContractAddress?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    tokenTokenTypeIsFaceValue?: boolean;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    tokenBackingPledgeId?: string | undefined;
    tokenBackingPledgeName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    payoutTokenId?: string | undefined;
    payoutTokenName?: string | undefined;
    conversionTokenId?: string | undefined;
    conversionTokenName?: string | undefined;
    tokenContractDocumentUrl?: string | undefined;
    tokenCanReinvestInterest?: boolean;

    constructor(data?: IAccountTokenBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountInvestorId = _data["accountInvestorId"];
            this.accountName = _data["accountName"];
            this.accountEthereumAddress = _data["accountEthereumAddress"];
            this.accountInvestorCompanyName = _data["accountInvestorCompanyName"];
            this.accountInvestorUserFirstName = _data["accountInvestorUserFirstName"];
            this.accountInvestorUserLastName = _data["accountInvestorUserLastName"];
            this.accountInvestorUserEmailAddress = _data["accountInvestorUserEmailAddress"];
            this.brokerId = _data["brokerId"];
            this.brokerName = _data["brokerName"];
            this.accountInvestorBrokerUserFirstName = _data["accountInvestorBrokerUserFirstName"];
            this.accountInvestorBrokerUserLastName = _data["accountInvestorBrokerUserLastName"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.tokenEthereumContractAddress = _data["tokenEthereumContractAddress"];
            this.tokenTokenTypeId = _data["tokenTokenTypeId"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.tokenTokenTypeIsFaceValue = _data["tokenTokenTypeIsFaceValue"];
            this.tokenProjectId = _data["tokenProjectId"];
            this.tokenProjectName = _data["tokenProjectName"];
            this.tokenBackingPledgeId = _data["tokenBackingPledgeId"];
            this.tokenBackingPledgeName = _data["tokenBackingPledgeName"];
            this.balance = _data["balance"];
            this.currentValue = _data["currentValue"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.currentOutstandingValue = _data["currentOutstandingValue"];
            this.payoutTokenId = _data["payoutTokenId"];
            this.payoutTokenName = _data["payoutTokenName"];
            this.conversionTokenId = _data["conversionTokenId"];
            this.conversionTokenName = _data["conversionTokenName"];
            this.tokenContractDocumentUrl = _data["tokenContractDocumentUrl"];
            this.tokenCanReinvestInterest = _data["tokenCanReinvestInterest"];
        }
    }

    static fromJS(data: any): AccountTokenBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTokenBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountInvestorId"] = this.accountInvestorId;
        data["accountName"] = this.accountName;
        data["accountEthereumAddress"] = this.accountEthereumAddress;
        data["accountInvestorCompanyName"] = this.accountInvestorCompanyName;
        data["accountInvestorUserFirstName"] = this.accountInvestorUserFirstName;
        data["accountInvestorUserLastName"] = this.accountInvestorUserLastName;
        data["accountInvestorUserEmailAddress"] = this.accountInvestorUserEmailAddress;
        data["brokerId"] = this.brokerId;
        data["brokerName"] = this.brokerName;
        data["accountInvestorBrokerUserFirstName"] = this.accountInvestorBrokerUserFirstName;
        data["accountInvestorBrokerUserLastName"] = this.accountInvestorBrokerUserLastName;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["tokenEthereumContractAddress"] = this.tokenEthereumContractAddress;
        data["tokenTokenTypeId"] = this.tokenTokenTypeId;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["tokenTokenTypeIsFaceValue"] = this.tokenTokenTypeIsFaceValue;
        data["tokenProjectId"] = this.tokenProjectId;
        data["tokenProjectName"] = this.tokenProjectName;
        data["tokenBackingPledgeId"] = this.tokenBackingPledgeId;
        data["tokenBackingPledgeName"] = this.tokenBackingPledgeName;
        data["balance"] = this.balance;
        data["currentValue"] = this.currentValue;
        data["outstandingBalance"] = this.outstandingBalance;
        data["currentOutstandingValue"] = this.currentOutstandingValue;
        data["payoutTokenId"] = this.payoutTokenId;
        data["payoutTokenName"] = this.payoutTokenName;
        data["conversionTokenId"] = this.conversionTokenId;
        data["conversionTokenName"] = this.conversionTokenName;
        data["tokenContractDocumentUrl"] = this.tokenContractDocumentUrl;
        data["tokenCanReinvestInterest"] = this.tokenCanReinvestInterest;
        return data;
    }
}

export interface IAccountTokenBalanceModel {
    accountId?: string | undefined;
    accountInvestorId?: string | undefined;
    accountName?: string | undefined;
    accountEthereumAddress?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountInvestorUserEmailAddress?: string | undefined;
    brokerId?: string;
    brokerName?: string | undefined;
    accountInvestorBrokerUserFirstName?: string | undefined;
    accountInvestorBrokerUserLastName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenEthereumContractAddress?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    tokenTokenTypeIsFaceValue?: boolean;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    tokenBackingPledgeId?: string | undefined;
    tokenBackingPledgeName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    payoutTokenId?: string | undefined;
    payoutTokenName?: string | undefined;
    conversionTokenId?: string | undefined;
    conversionTokenName?: string | undefined;
    tokenContractDocumentUrl?: string | undefined;
    tokenCanReinvestInterest?: boolean;
}

export class AccountTokenBalanceModelPagedResult implements IAccountTokenBalanceModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (AccountTokenBalanceModel | undefined)[] | undefined;

    constructor(data?: IAccountTokenBalanceModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AccountTokenBalanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountTokenBalanceModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTokenBalanceModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountTokenBalanceModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (AccountTokenBalanceModel | undefined)[] | undefined;
}

export class AdminDashboardTodo implements IAdminDashboardTodo {
    value?: number;
    description?: string | undefined;
    link?: string | undefined;

    constructor(data?: IAdminDashboardTodo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): AdminDashboardTodo {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDashboardTodo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["link"] = this.link;
        return data;
    }
}

export interface IAdminDashboardTodo {
    value?: number;
    description?: string | undefined;
    link?: string | undefined;
}

export class AllocateTasksToQualityAssessorInputModel implements IAllocateTasksToQualityAssessorInputModel {
    qualityAssessorId?: string;
    selectedTaskIds?: string[] | undefined;

    constructor(data?: IAllocateTasksToQualityAssessorInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityAssessorId = _data["qualityAssessorId"];
            if (Array.isArray(_data["selectedTaskIds"])) {
                this.selectedTaskIds = [] as any;
                for (let item of _data["selectedTaskIds"])
                    this.selectedTaskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AllocateTasksToQualityAssessorInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocateTasksToQualityAssessorInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityAssessorId"] = this.qualityAssessorId;
        if (Array.isArray(this.selectedTaskIds)) {
            data["selectedTaskIds"] = [];
            for (let item of this.selectedTaskIds)
                data["selectedTaskIds"].push(item);
        }
        return data;
    }
}

export interface IAllocateTasksToQualityAssessorInputModel {
    qualityAssessorId?: string;
    selectedTaskIds?: string[] | undefined;
}

export class App implements IApp {
    accountSid?: string | undefined;
    errors?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountSid = _data["accountSid"];
            this.errors = _data["errors"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): App {
        data = typeof data === 'object' ? data : {};
        let result = new App();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountSid"] = this.accountSid;
        data["errors"] = this.errors;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IApp {
    accountSid?: string | undefined;
    errors?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class AuthyEventResponse implements IAuthyEventResponse {
    events?: (TwilioEvent | undefined)[] | undefined;
    success?: boolean;

    constructor(data?: IAuthyEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TwilioEvent.fromJS(item));
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AuthyEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthyEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["success"] = this.success;
        return data;
    }
}

export interface IAuthyEventResponse {
    events?: (TwilioEvent | undefined)[] | undefined;
    success?: boolean;
}

export class AuthyToken implements IAuthyToken {
    id?: string | undefined;
    type?: string | undefined;

    constructor(data?: IAuthyToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AuthyToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthyToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IAuthyToken {
    id?: string | undefined;
    type?: string | undefined;
}

export class AuthyUser implements IAuthyUser {
    banned?: boolean;
    multiDeviceEnabled?: boolean;
    authyId?: string | undefined;
    countryCode?: string | undefined;
    errors?: string | undefined;
    locale?: string | undefined;
    phoneNumber?: string | undefined;
    multiDeviceUpdatedAt?: string | undefined;

    constructor(data?: IAuthyUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.banned = _data["banned"];
            this.multiDeviceEnabled = _data["multiDeviceEnabled"];
            this.authyId = _data["authyId"];
            this.countryCode = _data["countryCode"];
            this.errors = _data["errors"];
            this.locale = _data["locale"];
            this.phoneNumber = _data["phoneNumber"];
            this.multiDeviceUpdatedAt = _data["multiDeviceUpdatedAt"];
        }
    }

    static fromJS(data: any): AuthyUser {
        data = typeof data === 'object' ? data : {};
        let result = new AuthyUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banned"] = this.banned;
        data["multiDeviceEnabled"] = this.multiDeviceEnabled;
        data["authyId"] = this.authyId;
        data["countryCode"] = this.countryCode;
        data["errors"] = this.errors;
        data["locale"] = this.locale;
        data["phoneNumber"] = this.phoneNumber;
        data["multiDeviceUpdatedAt"] = this.multiDeviceUpdatedAt;
        return data;
    }
}

export interface IAuthyUser {
    banned?: boolean;
    multiDeviceEnabled?: boolean;
    authyId?: string | undefined;
    countryCode?: string | undefined;
    errors?: string | undefined;
    locale?: string | undefined;
    phoneNumber?: string | undefined;
    multiDeviceUpdatedAt?: string | undefined;
}

export class AuthyUserInputModel implements IAuthyUserInputModel {
    contactNumber?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthyUserInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactNumber = _data["contactNumber"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthyUserInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthyUserInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactNumber"] = this.contactNumber;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthyUserInputModel {
    contactNumber?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
}

export class BankAccountDisplayModel implements IBankAccountDisplayModel {
    id?: string;
    accountId?: string;
    accountInvestorId?: string | undefined;
    accountInvestorUserName?: string | undefined;
    bankAccountTypeId?: number;
    bankAccountTypeName?: string | undefined;
    name?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountHolderName?: string | undefined;
    accountNumber?: string | undefined;
    bankName?: string | undefined;
    swiftbic?: string | undefined;
  iban?: string | undefined;
    bankAddress?: string | undefined;
    createdOn?: Date;
    readonly hasBeenVerified?: boolean;
    verifiedOn?: Date | undefined;
    verificationDocumentLink?: string | undefined;

    constructor(data?: IBankAccountDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.accountInvestorId = _data["accountInvestorId"];
            this.accountInvestorUserName = _data["accountInvestorUserName"];
            this.bankAccountTypeId = _data["bankAccountTypeId"];
            this.bankAccountTypeName = _data["bankAccountTypeName"];
            this.name = _data["name"];
            this.accountInvestorCompanyName = _data["accountInvestorCompanyName"];
            this.accountInvestorUserFirstName = _data["accountInvestorUserFirstName"];
            this.accountInvestorUserLastName = _data["accountInvestorUserLastName"];
            this.accountHolderName = _data["accountHolderName"];
            this.accountNumber = _data["accountNumber"];
            this.bankName = _data["bankName"];
            this.swiftbic = _data["swiftbic"];
          this.iban = _data["iban"];
            this.bankAddress = _data["bankAddress"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            (<any>this).hasBeenVerified = _data["hasBeenVerified"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : <any>undefined;
            this.verificationDocumentLink = _data["verificationDocumentLink"];
        }
    }

    static fromJS(data: any): BankAccountDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["accountInvestorId"] = this.accountInvestorId;
        data["accountInvestorUserName"] = this.accountInvestorUserName;
        data["bankAccountTypeId"] = this.bankAccountTypeId;
        data["bankAccountTypeName"] = this.bankAccountTypeName;
        data["name"] = this.name;
        data["accountInvestorCompanyName"] = this.accountInvestorCompanyName;
        data["accountInvestorUserFirstName"] = this.accountInvestorUserFirstName;
        data["accountInvestorUserLastName"] = this.accountInvestorUserLastName;
        data["accountHolderName"] = this.accountHolderName;
        data["accountNumber"] = this.accountNumber;
        data["bankName"] = this.bankName;
        data["swiftbic"] = this.swiftbic;
      data["iban"] = this.iban;
        data["bankAddress"] = this.bankAddress;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["hasBeenVerified"] = this.hasBeenVerified;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : <any>undefined;
        data["verificationDocumentLink"] = this.verificationDocumentLink;
        return data;
    }
}

export interface IBankAccountDisplayModel {
    id?: string;
    accountId?: string;
    accountInvestorId?: string | undefined;
    accountInvestorUserName?: string | undefined;
    bankAccountTypeId?: number;
    bankAccountTypeName?: string | undefined;
    name?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountHolderName?: string | undefined;
    accountNumber?: string | undefined;
    bankName?: string | undefined;
    swiftbic?: string | undefined;
  iban?: string | undefined;
    bankAddress?: string | undefined;
    createdOn?: Date;
    hasBeenVerified?: boolean;
    verifiedOn?: Date | undefined;
    verificationDocumentLink?: string | undefined;
}

export class BankAccountDisplayModelPagedResult implements IBankAccountDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (BankAccountDisplayModel | undefined)[] | undefined;

    constructor(data?: IBankAccountDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BankAccountDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBankAccountDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (BankAccountDisplayModel | undefined)[] | undefined;
}

export class BankAccountInputModel implements IBankAccountInputModel {
    accountId?: string;
    bankAccountTypeId?: number;
    name?: string | undefined;
    accountHolderName?: string | undefined;
    accountNumber?: string | undefined;
    bankName?: string | undefined;
    swiftbic?: string | undefined;
  iban?: string | undefined;
    bankAddress?: string | undefined;
    verificationDocumentLink?: string | undefined;

    constructor(data?: IBankAccountInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.bankAccountTypeId = _data["bankAccountTypeId"];
            this.name = _data["name"];
            this.accountHolderName = _data["accountHolderName"];
            this.accountNumber = _data["accountNumber"];
            this.bankName = _data["bankName"];
            this.swiftbic = _data["swiftbic"];
          this.iban = _data["iban"];
            this.bankAddress = _data["bankAddress"];
            this.verificationDocumentLink = _data["verificationDocumentLink"];
        }
    }

    static fromJS(data: any): BankAccountInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["bankAccountTypeId"] = this.bankAccountTypeId;
        data["name"] = this.name;
        data["accountHolderName"] = this.accountHolderName;
        data["accountNumber"] = this.accountNumber;
        data["bankName"] = this.bankName;
        data["swiftbic"] = this.swiftbic;
      data["iban"] = this.iban;
        data["bankAddress"] = this.bankAddress;
        data["verificationDocumentLink"] = this.verificationDocumentLink;
        return data;
    }
}

export interface IBankAccountInputModel {
    accountId?: string;
    bankAccountTypeId?: number;
    name?: string | undefined;
    accountHolderName?: string | undefined;
    accountNumber?: string | undefined;
    bankName?: string | undefined;
    swiftbic?: string | undefined;
  iban?: string | undefined;
    bankAddress?: string | undefined;
    verificationDocumentLink?: string | undefined;
}

export class BankAccountSummaryModel implements IBankAccountSummaryModel {
    name?: string | undefined;
    total?: number;

    constructor(data?: IBankAccountSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BankAccountSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["total"] = this.total;
        return data;
    }
}

export interface IBankAccountSummaryModel {
    name?: string | undefined;
    total?: number;
}

export class BankAccountTransactionDisplayModel implements IBankAccountTransactionDisplayModel {
    id?: string;
    description?: string | undefined;
    amount?: number;
    effectiveDate?: Date;
    createdOn?: Date;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
    tokenName?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IBankAccountTransactionDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdByUserName = _data["createdByUserName"];
            this.createdByUserFirstName = _data["createdByUserFirstName"];
            this.createdByUserLastName = _data["createdByUserLastName"];
            this.tokenName = _data["tokenName"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): BankAccountTransactionDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByUserFirstName"] = this.createdByUserFirstName;
        data["createdByUserLastName"] = this.createdByUserLastName;
        data["tokenName"] = this.tokenName;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IBankAccountTransactionDisplayModel {
    id?: string;
    description?: string | undefined;
    amount?: number;
    effectiveDate?: Date;
    createdOn?: Date;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
    tokenName?: string | undefined;
    accountName?: string | undefined;
}

export class BankAccountTransactionDisplayModelPagedResult implements IBankAccountTransactionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (BankAccountTransactionDisplayModel | undefined)[] | undefined;

    constructor(data?: IBankAccountTransactionDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BankAccountTransactionDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransactionDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBankAccountTransactionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (BankAccountTransactionDisplayModel | undefined)[] | undefined;
}

export class BankAccountTransactionInputModel implements IBankAccountTransactionInputModel {
    description?: string | undefined;
    amount?: number;
    effectiveDate?: Date;
    tokenId?: string;
    transactionId?: string | undefined;
    accountId?: string | undefined;
    createdByUserId?: string;

    constructor(data?: IBankAccountTransactionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.tokenId = _data["tokenId"];
            this.transactionId = _data["transactionId"];
            this.accountId = _data["accountId"];
            this.createdByUserId = _data["createdByUserId"];
        }
    }

    static fromJS(data: any): BankAccountTransactionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["tokenId"] = this.tokenId;
        data["transactionId"] = this.transactionId;
        data["accountId"] = this.accountId;
        data["createdByUserId"] = this.createdByUserId;
        return data;
    }
}

export interface IBankAccountTransactionInputModel {
    description?: string | undefined;
    amount?: number;
    effectiveDate?: Date;
    tokenId?: string;
    transactionId?: string | undefined;
    accountId?: string | undefined;
    createdByUserId?: string;
}

export class BrokerDisplayModel implements IBrokerDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    advisoryNumber?: string | undefined;

    constructor(data?: IBrokerDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.advisoryNumber = _data["advisoryNumber"];
        }
    }

    static fromJS(data: any): BrokerDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["advisoryNumber"] = this.advisoryNumber;
        return data;
    }
}

export interface IBrokerDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    advisoryNumber?: string | undefined;
}

export class BulkUpdateWeeksInputModel implements IBulkUpdateWeeksInputModel {
    selectedTaskIds?: string[] | undefined;
    delayStart?: number;
    delayEnd?: number;

    constructor(data?: IBulkUpdateWeeksInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedTaskIds"])) {
                this.selectedTaskIds = [] as any;
                for (let item of _data["selectedTaskIds"])
                    this.selectedTaskIds!.push(item);
            }
            this.delayStart = _data["delayStart"];
            this.delayEnd = _data["delayEnd"];
        }
    }

    static fromJS(data: any): BulkUpdateWeeksInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateWeeksInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedTaskIds)) {
            data["selectedTaskIds"] = [];
            for (let item of this.selectedTaskIds)
                data["selectedTaskIds"].push(item);
        }
        data["delayStart"] = this.delayStart;
        data["delayEnd"] = this.delayEnd;
        return data;
    }
}

export interface IBulkUpdateWeeksInputModel {
    selectedTaskIds?: string[] | undefined;
    delayStart?: number;
    delayEnd?: number;
}

export class CancelTaskInputModel implements ICancelTaskInputModel {
    taskId?: string;
    cancellationComment?: string | undefined;

    constructor(data?: ICancelTaskInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.cancellationComment = _data["cancellationComment"];
        }
    }

    static fromJS(data: any): CancelTaskInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelTaskInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["cancellationComment"] = this.cancellationComment;
        return data;
    }
}

export interface ICancelTaskInputModel {
    taskId?: string;
    cancellationComment?: string | undefined;
}

export class ChatDisplayModel implements IChatDisplayModel {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IChatDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ChatDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IChatDisplayModel {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
}

export class ChatMessageDisplayModel implements IChatMessageDisplayModel {
    id?: string;
    fromUserId?: string;
    fromUserFirstName?: string | undefined;
    fromUserLastName?: string | undefined;
    from?: string | undefined;
    adminReply?: string | undefined;
    createdOn?: Date;
    body?: string | undefined;
    statusId?: number;
    fromUserIsAdmin?: boolean;
    toChatId?: string;

    constructor(data?: IChatMessageDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromUserId = _data["fromUserId"];
            this.fromUserFirstName = _data["fromUserFirstName"];
            this.fromUserLastName = _data["fromUserLastName"];
            this.from = _data["from"];
            this.adminReply = _data["adminReply"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.body = _data["body"];
            this.statusId = _data["statusId"];
            this.fromUserIsAdmin = _data["fromUserIsAdmin"];
            this.toChatId = _data["toChatId"];
        }
    }

    static fromJS(data: any): ChatMessageDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromUserId"] = this.fromUserId;
        data["fromUserFirstName"] = this.fromUserFirstName;
        data["fromUserLastName"] = this.fromUserLastName;
        data["from"] = this.from;
        data["adminReply"] = this.adminReply;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["body"] = this.body;
        data["statusId"] = this.statusId;
        data["fromUserIsAdmin"] = this.fromUserIsAdmin;
        data["toChatId"] = this.toChatId;
        return data;
    }
}

export interface IChatMessageDisplayModel {
    id?: string;
    fromUserId?: string;
    fromUserFirstName?: string | undefined;
    fromUserLastName?: string | undefined;
    from?: string | undefined;
    adminReply?: string | undefined;
    createdOn?: Date;
    body?: string | undefined;
    statusId?: number;
    fromUserIsAdmin?: boolean;
    toChatId?: string;
}

export class ChatMessageDisplayModelPagedResult implements IChatMessageDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ChatMessageDisplayModel | undefined)[] | undefined;

    constructor(data?: IChatMessageDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ChatMessageDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatMessageDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatMessageDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ChatMessageDisplayModel | undefined)[] | undefined;
}

export class ChatMessageInputModel implements IChatMessageInputModel {
    chatId?: string;
    fromUserId?: string;
    body?: string | undefined;

    constructor(data?: IChatMessageInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatId = _data["chatId"];
            this.fromUserId = _data["fromUserId"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): ChatMessageInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatId"] = this.chatId;
        data["fromUserId"] = this.fromUserId;
        data["body"] = this.body;
        return data;
    }
}

export interface IChatMessageInputModel {
    chatId?: string;
    fromUserId?: string;
    body?: string | undefined;
}

export class ClientOptions implements IClientOptions {
    googleApiKey?: string | undefined;
    googleAnalyticsTrackingId?: string | undefined;
    googleTagManagerTrackingId?: string | undefined;
    crossDomainGTMTrackingId?: string | undefined;
    twitterTrackingId?: string | undefined;
    facebookTrackingId?: string | undefined;
    linkedInTrackingId?: string | undefined;
    recaptchaSiteKey?: string | undefined;
    etherScanBaseUrl?: string | undefined;
    appInsightsInstrumentation?: string | undefined;
    maxFileUploadSize?: number;
    prodUrl?: string | undefined;
    sandboxUrl?: string | undefined;
    prospectusDocumentUrl?: string | undefined;
    imageKitUrl?: string | undefined;
    alternateProjectName?: string | undefined;
    alternateCompanyName?: string | undefined;
    alternateEmailAddress?: string | undefined;
    stripePublishableKey?: string | undefined;
    readonly projectName?: string | undefined;
    readonly companyName?: string | undefined;
    readonly emailAddress?: string | undefined;
    featureToggles?: FeatureToggleOptions | undefined;

    constructor(data?: IClientOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleApiKey = _data["googleApiKey"];
            this.googleAnalyticsTrackingId = _data["googleAnalyticsTrackingId"];
            this.googleTagManagerTrackingId = _data["googleTagManagerTrackingId"];
            this.crossDomainGTMTrackingId = _data["crossDomainGTMTrackingId"];
            this.twitterTrackingId = _data["twitterTrackingId"];
            this.facebookTrackingId = _data["facebookTrackingId"];
            this.linkedInTrackingId = _data["linkedInTrackingId"];
            this.recaptchaSiteKey = _data["recaptchaSiteKey"];
            this.etherScanBaseUrl = _data["etherScanBaseUrl"];
            this.appInsightsInstrumentation = _data["appInsightsInstrumentation"];
            this.maxFileUploadSize = _data["maxFileUploadSize"];
            this.prodUrl = _data["prodUrl"];
            this.sandboxUrl = _data["sandboxUrl"];
            this.prospectusDocumentUrl = _data["prospectusDocumentUrl"];
            this.imageKitUrl = _data["imageKitUrl"];
            this.alternateProjectName = _data["alternateProjectName"];
            this.alternateCompanyName = _data["alternateCompanyName"];
            this.alternateEmailAddress = _data["alternateEmailAddress"];
            this.stripePublishableKey = _data["stripePublishableKey"];
            (<any>this).projectName = _data["projectName"];
            (<any>this).companyName = _data["companyName"];
            (<any>this).emailAddress = _data["emailAddress"];
            this.featureToggles = _data["featureToggles"] ? FeatureToggleOptions.fromJS(_data["featureToggles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ClientOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleApiKey"] = this.googleApiKey;
        data["googleAnalyticsTrackingId"] = this.googleAnalyticsTrackingId;
        data["googleTagManagerTrackingId"] = this.googleTagManagerTrackingId;
        data["crossDomainGTMTrackingId"] = this.crossDomainGTMTrackingId;
        data["twitterTrackingId"] = this.twitterTrackingId;
        data["facebookTrackingId"] = this.facebookTrackingId;
        data["linkedInTrackingId"] = this.linkedInTrackingId;
        data["recaptchaSiteKey"] = this.recaptchaSiteKey;
        data["etherScanBaseUrl"] = this.etherScanBaseUrl;
        data["appInsightsInstrumentation"] = this.appInsightsInstrumentation;
        data["maxFileUploadSize"] = this.maxFileUploadSize;
        data["prodUrl"] = this.prodUrl;
        data["sandboxUrl"] = this.sandboxUrl;
        data["prospectusDocumentUrl"] = this.prospectusDocumentUrl;
        data["imageKitUrl"] = this.imageKitUrl;
        data["alternateProjectName"] = this.alternateProjectName;
        data["alternateCompanyName"] = this.alternateCompanyName;
        data["alternateEmailAddress"] = this.alternateEmailAddress;
        data["stripePublishableKey"] = this.stripePublishableKey;
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["emailAddress"] = this.emailAddress;
        data["featureToggles"] = this.featureToggles ? this.featureToggles.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientOptions {
    googleApiKey?: string | undefined;
    googleAnalyticsTrackingId?: string | undefined;
    googleTagManagerTrackingId?: string | undefined;
    crossDomainGTMTrackingId?: string | undefined;
    twitterTrackingId?: string | undefined;
    facebookTrackingId?: string | undefined;
    linkedInTrackingId?: string | undefined;
    recaptchaSiteKey?: string | undefined;
    etherScanBaseUrl?: string | undefined;
    appInsightsInstrumentation?: string | undefined;
    maxFileUploadSize?: number;
    prodUrl?: string | undefined;
    sandboxUrl?: string | undefined;
    prospectusDocumentUrl?: string | undefined;
    imageKitUrl?: string | undefined;
    alternateProjectName?: string | undefined;
    alternateCompanyName?: string | undefined;
    alternateEmailAddress?: string | undefined;
    stripePublishableKey?: string | undefined;
    projectName?: string | undefined;
    companyName?: string | undefined;
    emailAddress?: string | undefined;
    featureToggles?: FeatureToggleOptions | undefined;
}

export class CollectContactDetailsInputModel implements ICollectContactDetailsInputModel {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    contactNumber?: string | undefined;
    countryId?: number;
    getProspectus?: boolean;
    wantInvest?: boolean;
    hasQuestion?: boolean;
    additionalComments?: string | undefined;

    constructor(data?: ICollectContactDetailsInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.contactNumber = _data["contactNumber"];
            this.countryId = _data["countryId"];
            this.getProspectus = _data["getProspectus"];
            this.wantInvest = _data["wantInvest"];
            this.hasQuestion = _data["hasQuestion"];
            this.additionalComments = _data["additionalComments"];
        }
    }

    static fromJS(data: any): CollectContactDetailsInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CollectContactDetailsInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["contactNumber"] = this.contactNumber;
        data["countryId"] = this.countryId;
        data["getProspectus"] = this.getProspectus;
        data["wantInvest"] = this.wantInvest;
        data["hasQuestion"] = this.hasQuestion;
        data["additionalComments"] = this.additionalComments;
        return data;
    }
}

export interface ICollectContactDetailsInputModel {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    contactNumber?: string | undefined;
    countryId?: number;
    getProspectus?: boolean;
    wantInvest?: boolean;
    hasQuestion?: boolean;
    additionalComments?: string | undefined;
}

export class ConfigureRolloverTokenInputModel implements IConfigureRolloverTokenInputModel {
    accountId?: string;
    tokenId?: string;
    rolloverTokenId?: string;

    constructor(data?: IConfigureRolloverTokenInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.tokenId = _data["tokenId"];
            this.rolloverTokenId = _data["rolloverTokenId"];
        }
    }

    static fromJS(data: any): ConfigureRolloverTokenInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureRolloverTokenInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["tokenId"] = this.tokenId;
        data["rolloverTokenId"] = this.rolloverTokenId;
        return data;
    }
}

export interface IConfigureRolloverTokenInputModel {
    accountId?: string;
    tokenId?: string;
    rolloverTokenId?: string;
}

export class ContactUsInputModel implements IContactUsInputModel {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    reasonForInterest?: string | undefined;
    recaptcha?: string | undefined;

    constructor(data?: IContactUsInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.reasonForInterest = _data["reasonForInterest"];
            this.recaptcha = _data["recaptcha"];
        }
    }

    static fromJS(data: any): ContactUsInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["reasonForInterest"] = this.reasonForInterest;
        data["recaptcha"] = this.recaptcha;
        return data;
    }
}

export interface IContactUsInputModel {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    reasonForInterest?: string | undefined;
    recaptcha?: string | undefined;
}

export class ContactUsResponse implements IContactUsResponse {
    message?: string | undefined;

    constructor(data?: IContactUsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactUsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IContactUsResponse {
    message?: string | undefined;
}

export class ContractDisplayModel implements IContractDisplayModel {
    id?: string;
    contractReference?: string | undefined;
    weekDue?: number;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    contractStatusId?: number;
    contractStatusName?: string | undefined;
    parentContractId?: string | undefined;
    description?: string | undefined;
    transactionId?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    quoteId?: string | undefined;
    originalQuotedAmount?: number;

    constructor(data?: IContractDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractReference = _data["contractReference"];
            this.weekDue = _data["weekDue"];
            this.supplierId = _data["supplierId"];
            this.supplierCode = _data["supplierCode"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.contractStatusId = _data["contractStatusId"];
            this.contractStatusName = _data["contractStatusName"];
            this.parentContractId = _data["parentContractId"];
            this.description = _data["description"];
            this.transactionId = _data["transactionId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.quoteId = _data["quoteId"];
            this.originalQuotedAmount = _data["originalQuotedAmount"];
        }
    }

    static fromJS(data: any): ContractDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractReference"] = this.contractReference;
        data["weekDue"] = this.weekDue;
        data["supplierId"] = this.supplierId;
        data["supplierCode"] = this.supplierCode;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["contractStatusId"] = this.contractStatusId;
        data["contractStatusName"] = this.contractStatusName;
        data["parentContractId"] = this.parentContractId;
        data["description"] = this.description;
        data["transactionId"] = this.transactionId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["quoteId"] = this.quoteId;
        data["originalQuotedAmount"] = this.originalQuotedAmount;
        return data;
    }
}

export interface IContractDisplayModel {
    id?: string;
    contractReference?: string | undefined;
    weekDue?: number;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    contractStatusId?: number;
    contractStatusName?: string | undefined;
    parentContractId?: string | undefined;
    description?: string | undefined;
    transactionId?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    quoteId?: string | undefined;
    originalQuotedAmount?: number;
}

export class ContractDisplayModelPagedResult implements IContractDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ContractDisplayModel | undefined)[] | undefined;

    constructor(data?: IContractDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ContractDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ContractDisplayModel | undefined)[] | undefined;
}

export class ContractMaterialDisplayModel implements IContractMaterialDisplayModel {
    id?: string;
    code?: string | undefined;
    quantity?: number;
    materialStatusId?: number;
    materialStatusName?: string | undefined;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    details?: string | undefined;
    contractStatusId?: number;
    pricePerUnit?: number;

    constructor(data?: IContractMaterialDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.materialStatusId = _data["materialStatusId"];
            this.materialStatusName = _data["materialStatusName"];
            this.weekDue = _data["weekDue"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.details = _data["details"];
            this.contractStatusId = _data["contractStatusId"];
            this.pricePerUnit = _data["pricePerUnit"];
        }
    }

    static fromJS(data: any): ContractMaterialDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractMaterialDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["materialStatusId"] = this.materialStatusId;
        data["materialStatusName"] = this.materialStatusName;
        data["weekDue"] = this.weekDue;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["details"] = this.details;
        data["contractStatusId"] = this.contractStatusId;
        data["pricePerUnit"] = this.pricePerUnit;
        return data;
    }
}

export interface IContractMaterialDisplayModel {
    id?: string;
    code?: string | undefined;
    quantity?: number;
    materialStatusId?: number;
    materialStatusName?: string | undefined;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    details?: string | undefined;
    contractStatusId?: number;
    pricePerUnit?: number;
}

export class ContractTaskDisplayModel implements IContractTaskDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    details?: string | undefined;
    cancellationComment?: string | undefined;
    contractStatusId?: number;
    taskQuoteAmount?: number | undefined;
    taskQuoteStaffRequired?: string | undefined;
    taskQuoteDuration?: string | undefined;
    taskQuoteComments?: string | undefined;
    activatedPenaltiesAmount?: number | undefined;
    taskConstraints?: (TaskConstraintDisplayModel | undefined)[] | undefined;

    constructor(data?: IContractTaskDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.taskStatusId = _data["taskStatusId"];
            this.taskStatusName = _data["taskStatusName"];
            this.weekStart = _data["weekStart"];
            this.weekDue = _data["weekDue"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.details = _data["details"];
            this.cancellationComment = _data["cancellationComment"];
            this.contractStatusId = _data["contractStatusId"];
            this.taskQuoteAmount = _data["taskQuoteAmount"];
            this.taskQuoteStaffRequired = _data["taskQuoteStaffRequired"];
            this.taskQuoteDuration = _data["taskQuoteDuration"];
            this.taskQuoteComments = _data["taskQuoteComments"];
            this.activatedPenaltiesAmount = _data["activatedPenaltiesAmount"];
            if (Array.isArray(_data["taskConstraints"])) {
                this.taskConstraints = [] as any;
                for (let item of _data["taskConstraints"])
                    this.taskConstraints!.push(TaskConstraintDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractTaskDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTaskDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["taskStatusId"] = this.taskStatusId;
        data["taskStatusName"] = this.taskStatusName;
        data["weekStart"] = this.weekStart;
        data["weekDue"] = this.weekDue;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["details"] = this.details;
        data["cancellationComment"] = this.cancellationComment;
        data["contractStatusId"] = this.contractStatusId;
        data["taskQuoteAmount"] = this.taskQuoteAmount;
        data["taskQuoteStaffRequired"] = this.taskQuoteStaffRequired;
        data["taskQuoteDuration"] = this.taskQuoteDuration;
        data["taskQuoteComments"] = this.taskQuoteComments;
        data["activatedPenaltiesAmount"] = this.activatedPenaltiesAmount;
        if (Array.isArray(this.taskConstraints)) {
            data["taskConstraints"] = [];
            for (let item of this.taskConstraints)
                data["taskConstraints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractTaskDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    details?: string | undefined;
    cancellationComment?: string | undefined;
    contractStatusId?: number;
    taskQuoteAmount?: number | undefined;
    taskQuoteStaffRequired?: string | undefined;
    taskQuoteDuration?: string | undefined;
    taskQuoteComments?: string | undefined;
    activatedPenaltiesAmount?: number | undefined;
    taskConstraints?: (TaskConstraintDisplayModel | undefined)[] | undefined;
}

export class DateValueModel implements IDateValueModel {
    date?: Date;
    value?: number;

    constructor(data?: IDateValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DateValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IDateValueModel {
    date?: Date;
    value?: number;
}

export class DebtConfigModel implements IDebtConfigModel {
    accountId?: string | undefined;
    accountName?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountInvestorUserEmailAddress?: string | undefined;
    brokerName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    tokenCanReinvestInterest?: boolean;
    rolloverTokenId?: string;
    rolloverTokenSymbol?: string | undefined;
    rolloverTokenName?: string | undefined;
    rolloverTokenTokenTypeName?: string | undefined;
    rolloverTokenProjectId?: string | undefined;
    rolloverTokenProjectName?: string | undefined;
    reinvestInterest?: boolean | undefined;
    scheduledPayoutDate?: Date | undefined;

    constructor(data?: IDebtConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.accountInvestorCompanyName = _data["accountInvestorCompanyName"];
            this.accountInvestorUserFirstName = _data["accountInvestorUserFirstName"];
            this.accountInvestorUserLastName = _data["accountInvestorUserLastName"];
            this.accountInvestorUserEmailAddress = _data["accountInvestorUserEmailAddress"];
            this.brokerName = _data["brokerName"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.tokenProjectId = _data["tokenProjectId"];
            this.tokenProjectName = _data["tokenProjectName"];
            this.balance = _data["balance"];
            this.currentValue = _data["currentValue"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.currentOutstandingValue = _data["currentOutstandingValue"];
            this.tokenCanReinvestInterest = _data["tokenCanReinvestInterest"];
            this.rolloverTokenId = _data["rolloverTokenId"];
            this.rolloverTokenSymbol = _data["rolloverTokenSymbol"];
            this.rolloverTokenName = _data["rolloverTokenName"];
            this.rolloverTokenTokenTypeName = _data["rolloverTokenTokenTypeName"];
            this.rolloverTokenProjectId = _data["rolloverTokenProjectId"];
            this.rolloverTokenProjectName = _data["rolloverTokenProjectName"];
            this.reinvestInterest = _data["reinvestInterest"];
            this.scheduledPayoutDate = _data["scheduledPayoutDate"] ? new Date(_data["scheduledPayoutDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DebtConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new DebtConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["accountInvestorCompanyName"] = this.accountInvestorCompanyName;
        data["accountInvestorUserFirstName"] = this.accountInvestorUserFirstName;
        data["accountInvestorUserLastName"] = this.accountInvestorUserLastName;
        data["accountInvestorUserEmailAddress"] = this.accountInvestorUserEmailAddress;
        data["brokerName"] = this.brokerName;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["tokenProjectId"] = this.tokenProjectId;
        data["tokenProjectName"] = this.tokenProjectName;
        data["balance"] = this.balance;
        data["currentValue"] = this.currentValue;
        data["outstandingBalance"] = this.outstandingBalance;
        data["currentOutstandingValue"] = this.currentOutstandingValue;
        data["tokenCanReinvestInterest"] = this.tokenCanReinvestInterest;
        data["rolloverTokenId"] = this.rolloverTokenId;
        data["rolloverTokenSymbol"] = this.rolloverTokenSymbol;
        data["rolloverTokenName"] = this.rolloverTokenName;
        data["rolloverTokenTokenTypeName"] = this.rolloverTokenTokenTypeName;
        data["rolloverTokenProjectId"] = this.rolloverTokenProjectId;
        data["rolloverTokenProjectName"] = this.rolloverTokenProjectName;
        data["reinvestInterest"] = this.reinvestInterest;
        data["scheduledPayoutDate"] = this.scheduledPayoutDate ? this.scheduledPayoutDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDebtConfigModel {
    accountId?: string | undefined;
    accountName?: string | undefined;
    accountInvestorCompanyName?: string | undefined;
    accountInvestorUserFirstName?: string | undefined;
    accountInvestorUserLastName?: string | undefined;
    accountInvestorUserEmailAddress?: string | undefined;
    brokerName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    tokenCanReinvestInterest?: boolean;
    rolloverTokenId?: string;
    rolloverTokenSymbol?: string | undefined;
    rolloverTokenName?: string | undefined;
    rolloverTokenTokenTypeName?: string | undefined;
    rolloverTokenProjectId?: string | undefined;
    rolloverTokenProjectName?: string | undefined;
    reinvestInterest?: boolean | undefined;
    scheduledPayoutDate?: Date | undefined;
}

export class DebtConfigModelPagedResult implements IDebtConfigModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (DebtConfigModel | undefined)[] | undefined;

    constructor(data?: IDebtConfigModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DebtConfigModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DebtConfigModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DebtConfigModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDebtConfigModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (DebtConfigModel | undefined)[] | undefined;
}

export class DecimalEthereumResponse implements IDecimalEthereumResponse {
    value?: number;
    hasErrors?: boolean;
    message?: string | undefined;

    constructor(data?: IDecimalEthereumResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hasErrors = _data["hasErrors"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DecimalEthereumResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalEthereumResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasErrors"] = this.hasErrors;
        data["message"] = this.message;
        return data;
    }
}

export interface IDecimalEthereumResponse {
    value?: number;
    hasErrors?: boolean;
    message?: string | undefined;
}

export class DepositDisplayModel implements IDepositDisplayModel {
    id?: string;
    createdOn?: Date;
    processedOn?: Date | undefined;
    amount?: number;
    investorId?: string;
    investorName?: string | undefined;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorReferenceNumber?: string | undefined;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    transactionId?: string;
    transactionHasBeenSynced?: boolean;
    transactionSubmittedToBlockchainOn?: Date | undefined;
    transactionEthereumTransactionHash?: string | undefined;
    depositTypeId?: number;
    depositTypeName?: string | undefined;
  purchasePurchaseStatusId?: number | undefined;
  purchaseProductProjectId?: string;
  purchaseProductProjectName?: string | undefined;
  transactionTransactionStatusId?: number | undefined;
  transactionTransactionStatusName?: string | undefined;


    constructor(data?: IDepositDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.processedOn = _data["processedOn"] ? new Date(_data["processedOn"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.investorCompanyName = _data["investorCompanyName"];
            this.investorUserFirstName = _data["investorUserFirstName"];
            this.investorUserLastName = _data["investorUserLastName"];
            this.investorReferenceNumber = _data["investorReferenceNumber"];
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.transactionId = _data["transactionId"];
            this.transactionHasBeenSynced = _data["transactionHasBeenSynced"];
            this.transactionSubmittedToBlockchainOn = _data["transactionSubmittedToBlockchainOn"] ? new Date(_data["transactionSubmittedToBlockchainOn"].toString()) : <any>undefined;
            this.transactionEthereumTransactionHash = _data["transactionEthereumTransactionHash"];
            this.depositTypeId = _data["depositTypeId"];
            this.depositTypeName = _data["depositTypeName"];
          this.purchasePurchaseStatusId = _data["purchasePurchaseStatusId"];
          this.transactionTransactionStatusId = _data["transactionTransactionStatusId"];
          this.transactionTransactionStatusName = _data["transactionTransactionStatusName"];
        }
    }

    static fromJS(data: any): DepositDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepositDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["processedOn"] = this.processedOn ? this.processedOn.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["investorCompanyName"] = this.investorCompanyName;
        data["investorUserFirstName"] = this.investorUserFirstName;
        data["investorUserLastName"] = this.investorUserLastName;
        data["investorReferenceNumber"] = this.investorReferenceNumber;
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["transactionId"] = this.transactionId;
        data["transactionHasBeenSynced"] = this.transactionHasBeenSynced;
        data["transactionSubmittedToBlockchainOn"] = this.transactionSubmittedToBlockchainOn ? this.transactionSubmittedToBlockchainOn.toISOString() : <any>undefined;
        data["transactionEthereumTransactionHash"] = this.transactionEthereumTransactionHash;
        data["depositTypeId"] = this.depositTypeId;
        data["depositTypeName"] = this.depositTypeName;
        data["purchasePurchaseStatusId"] = this.purchasePurchaseStatusId;
      data["transactionTransactionStatusId"] = this.transactionTransactionStatusId;
      data["transactionTransactionStatusName"] = this.transactionTransactionStatusName;
        return data;
    }
}

export interface IDepositDisplayModel {
    id?: string;
    createdOn?: Date;
    processedOn?: Date | undefined;
    amount?: number;
    investorId?: string;
    investorName?: string | undefined;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorReferenceNumber?: string | undefined;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    transactionId?: string;
    transactionHasBeenSynced?: boolean;
    transactionSubmittedToBlockchainOn?: Date | undefined;
    transactionEthereumTransactionHash?: string | undefined;
    depositTypeId?: number;
    depositTypeName?: string | undefined;
  purchasePurchaseStatusId?: number | undefined;
  transactionTransactionStatusId?: number | undefined;
  transactionTransactionStatusName?: string | undefined;
}

export class DepositDisplayModelPagedResult implements IDepositDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (DepositDisplayModel | undefined)[] | undefined;

    constructor(data?: IDepositDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DepositDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepositDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DepositDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDepositDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (DepositDisplayModel | undefined)[] | undefined;
}

export class DepositInputModel implements IDepositInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    depositTypeId?: number;

    constructor(data?: IDepositInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.tokenId = _data["tokenId"];
            this.amount = _data["amount"];
            this.depositTypeId = _data["depositTypeId"];
        }
    }

    static fromJS(data: any): DepositInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepositInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["tokenId"] = this.tokenId;
        data["amount"] = this.amount;
        data["depositTypeId"] = this.depositTypeId;
        return data;
    }
}

export interface IDepositInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    depositTypeId?: number;
}

export class DisableMFARequest implements IDisableMFARequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    recaptcha?: string | undefined;

    constructor(data?: IDisableMFARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.recaptcha = _data["recaptcha"];
        }
    }

    static fromJS(data: any): DisableMFARequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableMFARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["recaptcha"] = this.recaptcha;
        return data;
    }
}

export interface IDisableMFARequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    recaptcha?: string | undefined;
}

export class DispRegistrationModel implements IDispRegistrationModel {
    userTypeId?: number;
    investorTypeId?: number;
    emailAddress?: string | undefined;
    referralCode?: string | undefined;
    companyName?: string | undefined;
    recaptcha?: string | undefined;
    advisoryNumber?: string | undefined;
    acceptTermsOfUse?: boolean;

    constructor(data?: IDispRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypeId = _data["userTypeId"];
            this.investorTypeId = _data["investorTypeId"];
            this.emailAddress = _data["emailAddress"];
            this.referralCode = _data["referralCode"];
            this.companyName = _data["companyName"];
            this.recaptcha = _data["recaptcha"];
            this.advisoryNumber = _data["advisoryNumber"];
            this.acceptTermsOfUse = _data["acceptTermsOfUse"];
        }
    }

    static fromJS(data: any): DispRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DispRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypeId"] = this.userTypeId;
        data["investorTypeId"] = this.investorTypeId;
        data["emailAddress"] = this.emailAddress;
        data["referralCode"] = this.referralCode;
        data["companyName"] = this.companyName;
        data["recaptcha"] = this.recaptcha;
        data["advisoryNumber"] = this.advisoryNumber;
        data["acceptTermsOfUse"] = this.acceptTermsOfUse;
        return data;
    }
}

export interface IDispRegistrationModel {
    userTypeId?: number;
    investorTypeId?: number;
    emailAddress?: string | undefined;
    referralCode?: string | undefined;
    companyName?: string | undefined;
    recaptcha?: string | undefined;
    advisoryNumber?: string | undefined;
    acceptTermsOfUse?: boolean;
}

export class EmailAttachmentDisplayModel implements IEmailAttachmentDisplayModel {
    id?: string;
    emailId?: string;
    fileName?: string | undefined;
    fileMimeType?: string | undefined;
    fileUrl?: string | undefined;

    constructor(data?: IEmailAttachmentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailId = _data["emailId"];
            this.fileName = _data["fileName"];
            this.fileMimeType = _data["fileMimeType"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): EmailAttachmentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailId"] = this.emailId;
        data["fileName"] = this.fileName;
        data["fileMimeType"] = this.fileMimeType;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}

export interface IEmailAttachmentDisplayModel {
    id?: string;
    emailId?: string;
    fileName?: string | undefined;
    fileMimeType?: string | undefined;
    fileUrl?: string | undefined;
}

export class EmailAttachmentInputModel implements IEmailAttachmentInputModel {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    fileMimeType?: string | undefined;

    constructor(data?: IEmailAttachmentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.fileMimeType = _data["fileMimeType"];
        }
    }

    static fromJS(data: any): EmailAttachmentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["fileMimeType"] = this.fileMimeType;
        return data;
    }
}

export interface IEmailAttachmentInputModel {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    fileMimeType?: string | undefined;
}

export class EmailDisplayModel implements IEmailDisplayModel {
    id?: string;
    receiverId?: string;
    subject?: string | undefined;
    sentAt?: Date;
    url?: string | undefined;
    attachments?: (EmailAttachmentDisplayModel | undefined)[] | undefined;

    constructor(data?: IEmailDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiverId = _data["receiverId"];
            this.subject = _data["subject"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>undefined;
            this.url = _data["url"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiverId"] = this.receiverId;
        data["subject"] = this.subject;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>undefined;
        data["url"] = this.url;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailDisplayModel {
    id?: string;
    receiverId?: string;
    subject?: string | undefined;
    sentAt?: Date;
    url?: string | undefined;
    attachments?: (EmailAttachmentDisplayModel | undefined)[] | undefined;
}

export class EmailDisplayModelPagedResult implements IEmailDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (EmailDisplayModel | undefined)[] | undefined;

    constructor(data?: IEmailDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EmailDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (EmailDisplayModel | undefined)[] | undefined;
}

export class EmailMessageInputModel implements IEmailMessageInputModel {
    subject?: string | undefined;
    html?: string | undefined;
    mailingList?: string[] | undefined;
    attachments?: (EmailAttachmentInputModel | undefined)[] | undefined;

    constructor(data?: IEmailMessageInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.html = _data["html"];
            if (Array.isArray(_data["mailingList"])) {
                this.mailingList = [] as any;
                for (let item of _data["mailingList"])
                    this.mailingList!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailMessageInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessageInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["html"] = this.html;
        if (Array.isArray(this.mailingList)) {
            data["mailingList"] = [];
            for (let item of this.mailingList)
                data["mailingList"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailMessageInputModel {
    subject?: string | undefined;
    html?: string | undefined;
    mailingList?: string[] | undefined;
    attachments?: (EmailAttachmentInputModel | undefined)[] | undefined;
}

export class EmailVerificationRequestModel implements IEmailVerificationRequestModel {
    emailAddress?: string | undefined;
    recaptcha?: string | undefined;

    constructor(data?: IEmailVerificationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.recaptcha = _data["recaptcha"];
        }
    }

    static fromJS(data: any): EmailVerificationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailVerificationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["recaptcha"] = this.recaptcha;
        return data;
    }
}

export interface IEmailVerificationRequestModel {
    emailAddress?: string | undefined;
    recaptcha?: string | undefined;
}

export class EnableMfaRequest implements IEnableMfaRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    verificationToken?: string | undefined;
    mfaTypeId?: number;

    constructor(data?: IEnableMfaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.verificationToken = _data["verificationToken"];
            this.mfaTypeId = _data["mfaTypeId"];
        }
    }

    static fromJS(data: any): EnableMfaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableMfaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["verificationToken"] = this.verificationToken;
        data["mfaTypeId"] = this.mfaTypeId;
        return data;
    }
}

export interface IEnableMfaRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    verificationToken?: string | undefined;
    mfaTypeId?: number;
}

export class EventObject implements IEventObject {
    app?: App | undefined;
    token?: AuthyToken | undefined;
    user?: AuthyUser | undefined;

    constructor(data?: IEventObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.app = _data["app"] ? App.fromJS(_data["app"]) : <any>undefined;
            this.token = _data["token"] ? AuthyToken.fromJS(_data["token"]) : <any>undefined;
            this.user = _data["user"] ? AuthyUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventObject {
        data = typeof data === 'object' ? data : {};
        let result = new EventObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["app"] = this.app ? this.app.toJSON() : <any>undefined;
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventObject {
    app?: App | undefined;
    token?: AuthyToken | undefined;
    user?: AuthyUser | undefined;
}

export class ExternalDepositInputModel implements IExternalDepositInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    depositTypeId?: number;

    constructor(data?: IExternalDepositInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.tokenId = _data["tokenId"];
            this.amount = _data["amount"];
            this.depositTypeId = _data["depositTypeId"];
        }
    }

    static fromJS(data: any): ExternalDepositInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDepositInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["tokenId"] = this.tokenId;
        data["amount"] = this.amount;
        data["depositTypeId"] = this.depositTypeId;
        return data;
    }
}

export interface IExternalDepositInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    depositTypeId?: number;
}

export class ExternalDocumentInputModel implements IExternalDocumentInputModel {
    investorId?: string;
    url?: string | undefined;
    contentType?: string | undefined;
    showToInvestor?: boolean;
    description?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycInputModel | undefined;

    constructor(data?: IExternalDocumentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.url = _data["url"];
            this.contentType = _data["contentType"];
            this.showToInvestor = _data["showToInvestor"];
            this.description = _data["description"];
            this.investorDocumentKyc = _data["investorDocumentKyc"] ? InvestorDocumentKycInputModel.fromJS(_data["investorDocumentKyc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalDocumentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDocumentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        data["showToInvestor"] = this.showToInvestor;
        data["description"] = this.description;
        data["investorDocumentKyc"] = this.investorDocumentKyc ? this.investorDocumentKyc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExternalDocumentInputModel {
    investorId?: string;
    url?: string | undefined;
    contentType?: string | undefined;
    showToInvestor?: boolean;
    description?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycInputModel | undefined;
}

export class ExternalPurchaseInputModel implements IExternalPurchaseInputModel {
    investorId?: string;
    paymentTokenId?: string;
    amount?: number;
    productId?: string;
    productPaymentOptionId?: string;

    constructor(data?: IExternalPurchaseInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.amount = _data["amount"];
            this.productId = _data["productId"];
            this.productPaymentOptionId = _data["productPaymentOptionId"];
        }
    }

    static fromJS(data: any): ExternalPurchaseInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPurchaseInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["paymentTokenId"] = this.paymentTokenId;
        data["amount"] = this.amount;
        data["productId"] = this.productId;
        data["productPaymentOptionId"] = this.productPaymentOptionId;
        return data;
    }
}

export interface IExternalPurchaseInputModel {
    investorId?: string;
    paymentTokenId?: string;
    amount?: number;
    productId?: string;
    productPaymentOptionId?: string;
}

export class ExternalUserRegistrationModel implements IExternalUserRegistrationModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    countryId?: number;
    referenceNumber?: string | undefined;
    defaultCurrencyTokenId?: string;

    constructor(data?: IExternalUserRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.referenceNumber = _data["referenceNumber"];
            this.defaultCurrencyTokenId = _data["defaultCurrencyTokenId"];
        }
    }

    static fromJS(data: any): ExternalUserRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["referenceNumber"] = this.referenceNumber;
        data["defaultCurrencyTokenId"] = this.defaultCurrencyTokenId;
        return data;
    }
}

export interface IExternalUserRegistrationModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    countryId?: number;
    referenceNumber?: string | undefined;
    defaultCurrencyTokenId?: string;
}

export class FeatureToggleOptions implements IFeatureToggleOptions {
    sandbox?: boolean;
    enableMfa?: boolean;
    showProjectProgress?: boolean;
    showChat?: boolean;
    useAlternateProjectName?: boolean;
    alternateProjectLogoId?: number;
    showAllProjects?: boolean;
    showMessages?: boolean;
    showWeeks?: boolean;
    showMarketplace?: boolean;
    translateToNorwegian?: boolean;

    constructor(data?: IFeatureToggleOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sandbox = _data["sandbox"];
            this.enableMfa = _data["enableMfa"];
            this.showProjectProgress = _data["showProjectProgress"];
            this.showChat = _data["showChat"];
            this.useAlternateProjectName = _data["useAlternateProjectName"];
            this.alternateProjectLogoId = _data["alternateProjectLogoId"];
            this.showAllProjects = _data["showAllProjects"];
            this.showMessages = _data["showMessages"];
            this.showWeeks = _data["showWeeks"];
            this.showMarketplace = _data["showMarketplace"];
            this.translateToNorwegian = _data["translateToNorwegian"];
        }
    }

    static fromJS(data: any): FeatureToggleOptions {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureToggleOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sandbox"] = this.sandbox;
        data["enableMfa"] = this.enableMfa;
        data["showProjectProgress"] = this.showProjectProgress;
        data["showChat"] = this.showChat;
        data["useAlternateProjectName"] = this.useAlternateProjectName;
        data["alternateProjectLogoId"] = this.alternateProjectLogoId;
        data["showAllProjects"] = this.showAllProjects;
        data["showMessages"] = this.showMessages;
        data["showWeeks"] = this.showWeeks;
        data["showMarketplace"] = this.showMarketplace;
        data["translateToNorwegian"] = this.translateToNorwegian;
        return data;
    }
}

export interface IFeatureToggleOptions {
    sandbox?: boolean;
    enableMfa?: boolean;
    showProjectProgress?: boolean;
    showChat?: boolean;
    useAlternateProjectName?: boolean;
    alternateProjectLogoId?: number;
    showAllProjects?: boolean;
    showMessages?: boolean;
    showWeeks?: boolean;
    showMarketplace?: boolean;
    translateToNorwegian?: boolean;
}

export class FileModel implements IFileModel {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    contents?: string | undefined;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.contents = _data["contents"];
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["contents"] = this.contents;
        return data;
    }
}

export interface IFileModel {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    contents?: string | undefined;
}

export class FulfillmentHistoryEntry implements IFulfillmentHistoryEntry {
    date?: Date;
    averagePrice?: number;
    totalVolume?: number;

    constructor(data?: IFulfillmentHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.averagePrice = _data["averagePrice"];
            this.totalVolume = _data["totalVolume"];
        }
    }

    static fromJS(data: any): FulfillmentHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new FulfillmentHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["averagePrice"] = this.averagePrice;
        data["totalVolume"] = this.totalVolume;
        return data;
    }
}

export interface IFulfillmentHistoryEntry {
    date?: Date;
    averagePrice?: number;
    totalVolume?: number;
}

export class GuidLookupModel implements IGuidLookupModel {
    id!: string;
    name!: string;

    constructor(data?: IGuidLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GuidLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuidLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGuidLookupModel {
    id: string;
    name: string;
}

export class Int32LookupModel implements IInt32LookupModel {
    id!: number;
    name!: string;

    constructor(data?: IInt32LookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Int32LookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new Int32LookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IInt32LookupModel {
    id: number;
    name: string;
}

export class InterestCalculationInfoModel implements IInterestCalculationInfoModel {
    showReinvestmentOption?: boolean;
    existingReinvestmentSelection?: boolean | undefined;
    reinvestMultiplier?: number;
    cashOutMultiplier?: number;

    constructor(data?: IInterestCalculationInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showReinvestmentOption = _data["showReinvestmentOption"];
            this.existingReinvestmentSelection = _data["existingReinvestmentSelection"];
            this.reinvestMultiplier = _data["reinvestMultiplier"];
            this.cashOutMultiplier = _data["cashOutMultiplier"];
        }
    }

    static fromJS(data: any): InterestCalculationInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new InterestCalculationInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showReinvestmentOption"] = this.showReinvestmentOption;
        data["existingReinvestmentSelection"] = this.existingReinvestmentSelection;
        data["reinvestMultiplier"] = this.reinvestMultiplier;
        data["cashOutMultiplier"] = this.cashOutMultiplier;
        return data;
    }
}

export interface IInterestCalculationInfoModel {
    showReinvestmentOption?: boolean;
    existingReinvestmentSelection?: boolean | undefined;
    reinvestMultiplier?: number;
    cashOutMultiplier?: number;
}

export class InvestorAddressInputModel implements IInvestorAddressInputModel {
    countryId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IInvestorAddressInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): InvestorAddressInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorAddressInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IInvestorAddressInputModel {
    countryId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
}

export class InvestorDisplayModel implements IInvestorDisplayModel {
    id?: string;
    userId?: string;
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userEmailAddress?: string | undefined;
    createdOn?: Date | undefined;
    userUserSessionLastLoginDate?: Date | undefined;
    profileImageUrl?: string | undefined;
    userHasBeenActivated?: boolean | undefined;
    hasBeenVerifiedByBankID?: boolean;
    documentsUploaded?: boolean | undefined;
    documentsVerified?: boolean | undefined;
    investorStatusId?: number;
    investorStatusName?: string | undefined;
    referenceNumber?: string | undefined;
    account?: AccountDisplayModel | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    countryId?: number | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    userTypeId?: number;
    userMfaTypeId?: number | undefined;
    userTypeName?: string | undefined;
    investorTypeId?: number;
    investorTypeName?: string | undefined;
    brokerId?: string | undefined;
    brokerName?: string | undefined;
    classification?: string | undefined;
    defaultCurrencyTokenId?: string;
    defaultCurrencyTokenSymbol?: string | undefined;
    defaultCurrencyTokenName?: string | undefined;
    referralCode?: string | undefined;
    advisoryNumber?: string | undefined;
    supplierCode?: string | undefined;
    supplierTaxNumber?: string | undefined;
    qualityAssessorCode?: string | undefined;
    referrerUserName?: string | undefined;
    referrerUserFirstName?: string | undefined;
    referrerUserLastName?: string | undefined;

    constructor(data?: IInvestorDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.accountName = _data["accountName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.userUserSessionLastLoginDate = _data["userUserSessionLastLoginDate"] ? new Date(_data["userUserSessionLastLoginDate"].toString()) : <any>undefined;
            this.profileImageUrl = _data["profileImageUrl"];
            this.userHasBeenActivated = _data["userHasBeenActivated"];
            this.hasBeenVerifiedByBankID = _data["hasBeenVerifiedByBankID"];
            this.documentsUploaded = _data["documentsUploaded"];
            this.documentsVerified = _data["documentsVerified"];
            this.investorStatusId = _data["investorStatusId"];
            this.investorStatusName = _data["investorStatusName"];
            this.referenceNumber = _data["referenceNumber"];
            this.account = _data["account"] ? AccountDisplayModel.fromJS(_data["account"]) : <any>undefined;
            this.contactNumber = _data["contactNumber"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyOwner = _data["companyOwner"];
            this.userTypeId = _data["userTypeId"];
            this.userMfaTypeId = _data["userMfaTypeId"];
            this.userTypeName = _data["userTypeName"];
            this.investorTypeId = _data["investorTypeId"];
            this.investorTypeName = _data["investorTypeName"];
            this.brokerId = _data["brokerId"];
            this.brokerName = _data["brokerName"];
            this.classification = _data["classification"];
            this.defaultCurrencyTokenId = _data["defaultCurrencyTokenId"];
            this.defaultCurrencyTokenSymbol = _data["defaultCurrencyTokenSymbol"];
            this.defaultCurrencyTokenName = _data["defaultCurrencyTokenName"];
            this.referralCode = _data["referralCode"];
            this.advisoryNumber = _data["advisoryNumber"];
            this.supplierCode = _data["supplierCode"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.qualityAssessorCode = _data["qualityAssessorCode"];
            this.referrerUserName = _data["referrerUserName"];
            this.referrerUserFirstName = _data["referrerUserFirstName"];
            this.referrerUserLastName = _data["referrerUserLastName"];
        }
    }

    static fromJS(data: any): InvestorDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["accountName"] = this.accountName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["userUserSessionLastLoginDate"] = this.userUserSessionLastLoginDate ? this.userUserSessionLastLoginDate.toISOString() : <any>undefined;
        data["profileImageUrl"] = this.profileImageUrl;
        data["userHasBeenActivated"] = this.userHasBeenActivated;
        data["hasBeenVerifiedByBankID"] = this.hasBeenVerifiedByBankID;
        data["documentsUploaded"] = this.documentsUploaded;
        data["documentsVerified"] = this.documentsVerified;
        data["investorStatusId"] = this.investorStatusId;
        data["investorStatusName"] = this.investorStatusName;
        data["referenceNumber"] = this.referenceNumber;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["contactNumber"] = this.contactNumber;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyOwner"] = this.companyOwner;
        data["userTypeId"] = this.userTypeId;
        data["userMfaTypeId"] = this.userMfaTypeId;
        data["userTypeName"] = this.userTypeName;
        data["investorTypeId"] = this.investorTypeId;
        data["investorTypeName"] = this.investorTypeName;
        data["brokerId"] = this.brokerId;
        data["brokerName"] = this.brokerName;
        data["classification"] = this.classification;
        data["defaultCurrencyTokenId"] = this.defaultCurrencyTokenId;
        data["defaultCurrencyTokenSymbol"] = this.defaultCurrencyTokenSymbol;
        data["defaultCurrencyTokenName"] = this.defaultCurrencyTokenName;
        data["referralCode"] = this.referralCode;
        data["advisoryNumber"] = this.advisoryNumber;
        data["supplierCode"] = this.supplierCode;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["qualityAssessorCode"] = this.qualityAssessorCode;
        data["referrerUserName"] = this.referrerUserName;
        data["referrerUserFirstName"] = this.referrerUserFirstName;
        data["referrerUserLastName"] = this.referrerUserLastName;
        return data;
    }
}

export interface IInvestorDisplayModel {
    id?: string;
    userId?: string;
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userEmailAddress?: string | undefined;
    createdOn?: Date | undefined;
    userUserSessionLastLoginDate?: Date | undefined;
    profileImageUrl?: string | undefined;
    userHasBeenActivated?: boolean | undefined;
    hasBeenVerifiedByBankID?: boolean;
    documentsUploaded?: boolean | undefined;
    documentsVerified?: boolean | undefined;
    investorStatusId?: number;
    investorStatusName?: string | undefined;
    referenceNumber?: string | undefined;
    account?: AccountDisplayModel | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    countryId?: number | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    userTypeId?: number;
    userMfaTypeId?: number | undefined;
    userTypeName?: string | undefined;
    investorTypeId?: number;
    investorTypeName?: string | undefined;
    brokerId?: string | undefined;
    brokerName?: string | undefined;
    classification?: string | undefined;
    defaultCurrencyTokenId?: string;
    defaultCurrencyTokenSymbol?: string | undefined;
    defaultCurrencyTokenName?: string | undefined;
    referralCode?: string | undefined;
    advisoryNumber?: string | undefined;
    supplierCode?: string | undefined;
    supplierTaxNumber?: string | undefined;
    qualityAssessorCode?: string | undefined;
    referrerUserName?: string | undefined;
    referrerUserFirstName?: string | undefined;
    referrerUserLastName?: string | undefined;
}

export class InvestorDisplayModelPagedResult implements IInvestorDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (InvestorDisplayModel | undefined)[] | undefined;

    constructor(data?: IInvestorDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvestorDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestorDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestorDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (InvestorDisplayModel | undefined)[] | undefined;
}

export class InvestorDocumentDisplayModel implements IInvestorDocumentDisplayModel {
    id?: string;
    investorId?: string;
    url?: string | undefined;
    contentType?: string | undefined;
    createdOn?: Date;
    showToInvestor?: boolean;
    description?: string | undefined;
    investorDocumentTypeName?: string | undefined;
    investorName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorUserEmailAddress?: string | undefined;
    hasBeenVerified?: boolean | undefined;
    verifiedOn?: Date | undefined;
    verifiedByUserFirstName?: string | undefined;
    verifiedByUserLastName?: string | undefined;
    verifiedByUserName?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycDisplayModel | undefined;

    constructor(data?: IInvestorDocumentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investorId = _data["investorId"];
            this.url = _data["url"];
            this.contentType = _data["contentType"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.showToInvestor = _data["showToInvestor"];
            this.description = _data["description"];
            this.investorDocumentTypeName = _data["investorDocumentTypeName"];
            this.investorName = _data["investorName"];
            this.investorUserFirstName = _data["investorUserFirstName"];
            this.investorUserLastName = _data["investorUserLastName"];
            this.investorUserEmailAddress = _data["investorUserEmailAddress"];
            this.hasBeenVerified = _data["hasBeenVerified"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : <any>undefined;
            this.verifiedByUserFirstName = _data["verifiedByUserFirstName"];
            this.verifiedByUserLastName = _data["verifiedByUserLastName"];
            this.verifiedByUserName = _data["verifiedByUserName"];
            this.investorDocumentKyc = _data["investorDocumentKyc"] ? InvestorDocumentKycDisplayModel.fromJS(_data["investorDocumentKyc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestorDocumentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDocumentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investorId"] = this.investorId;
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["showToInvestor"] = this.showToInvestor;
        data["description"] = this.description;
        data["investorDocumentTypeName"] = this.investorDocumentTypeName;
        data["investorName"] = this.investorName;
        data["investorUserFirstName"] = this.investorUserFirstName;
        data["investorUserLastName"] = this.investorUserLastName;
        data["investorUserEmailAddress"] = this.investorUserEmailAddress;
        data["hasBeenVerified"] = this.hasBeenVerified;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : <any>undefined;
        data["verifiedByUserFirstName"] = this.verifiedByUserFirstName;
        data["verifiedByUserLastName"] = this.verifiedByUserLastName;
        data["verifiedByUserName"] = this.verifiedByUserName;
        data["investorDocumentKyc"] = this.investorDocumentKyc ? this.investorDocumentKyc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestorDocumentDisplayModel {
    id?: string;
    investorId?: string;
    url?: string | undefined;
    contentType?: string | undefined;
    createdOn?: Date;
    showToInvestor?: boolean;
    description?: string | undefined;
    investorDocumentTypeName?: string | undefined;
    investorName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorUserEmailAddress?: string | undefined;
    hasBeenVerified?: boolean | undefined;
    verifiedOn?: Date | undefined;
    verifiedByUserFirstName?: string | undefined;
    verifiedByUserLastName?: string | undefined;
    verifiedByUserName?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycDisplayModel | undefined;
}

export class InvestorDocumentDisplayModelPagedResult implements IInvestorDocumentDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (InvestorDocumentDisplayModel | undefined)[] | undefined;

    constructor(data?: IInvestorDocumentDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvestorDocumentDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestorDocumentDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDocumentDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestorDocumentDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (InvestorDocumentDisplayModel | undefined)[] | undefined;
}

export class InvestorDocumentInputModel implements IInvestorDocumentInputModel {
    url?: string | undefined;
    contentType?: string | undefined;
    showToInvestor?: boolean | undefined;
    description?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycInputModel | undefined;

    constructor(data?: IInvestorDocumentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.contentType = _data["contentType"];
            this.showToInvestor = _data["showToInvestor"];
            this.description = _data["description"];
            this.investorDocumentKyc = _data["investorDocumentKyc"] ? InvestorDocumentKycInputModel.fromJS(_data["investorDocumentKyc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestorDocumentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDocumentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        data["showToInvestor"] = this.showToInvestor;
        data["description"] = this.description;
        data["investorDocumentKyc"] = this.investorDocumentKyc ? this.investorDocumentKyc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestorDocumentInputModel {
    url?: string | undefined;
    contentType?: string | undefined;
    showToInvestor?: boolean | undefined;
    description?: string | undefined;
    investorDocumentKyc?: InvestorDocumentKycInputModel | undefined;
}

export class InvestorDocumentKycDisplayModel implements IInvestorDocumentKycDisplayModel {
    kycDocumentId?: number;
    kycDocumentName?: string | undefined;

    constructor(data?: IInvestorDocumentKycDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kycDocumentId = _data["kycDocumentId"];
            this.kycDocumentName = _data["kycDocumentName"];
        }
    }

    static fromJS(data: any): InvestorDocumentKycDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDocumentKycDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kycDocumentId"] = this.kycDocumentId;
        data["kycDocumentName"] = this.kycDocumentName;
        return data;
    }
}

export interface IInvestorDocumentKycDisplayModel {
    kycDocumentId?: number;
    kycDocumentName?: string | undefined;
}

export class InvestorDocumentKycInputModel implements IInvestorDocumentKycInputModel {
    kycDocumentId?: number;

    constructor(data?: IInvestorDocumentKycInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kycDocumentId = _data["kycDocumentId"];
        }
    }

    static fromJS(data: any): InvestorDocumentKycInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDocumentKycInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kycDocumentId"] = this.kycDocumentId;
        return data;
    }
}

export interface IInvestorDocumentKycInputModel {
    kycDocumentId?: number;
}

export class InvestorInputModel implements IInvestorInputModel {
    investorTypeId?: number;
    brokerId?: string | undefined;
    userEmailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    countryId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    defaultCurrencyTokenId?: string;
    userTypeId?: number;
    advisoryNumber?: string | undefined;
    supplierCode?: string | undefined;
    supplierTaxNumber?: string | undefined;
    qualityAssessorCode?: string | undefined;

    constructor(data?: IInvestorInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorTypeId = _data["investorTypeId"];
            this.brokerId = _data["brokerId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyOwner = _data["companyOwner"];
            this.countryId = _data["countryId"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.defaultCurrencyTokenId = _data["defaultCurrencyTokenId"];
            this.userTypeId = _data["userTypeId"];
            this.advisoryNumber = _data["advisoryNumber"];
            this.supplierCode = _data["supplierCode"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.qualityAssessorCode = _data["qualityAssessorCode"];
        }
    }

    static fromJS(data: any): InvestorInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorTypeId"] = this.investorTypeId;
        data["brokerId"] = this.brokerId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyOwner"] = this.companyOwner;
        data["countryId"] = this.countryId;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["defaultCurrencyTokenId"] = this.defaultCurrencyTokenId;
        data["userTypeId"] = this.userTypeId;
        data["advisoryNumber"] = this.advisoryNumber;
        data["supplierCode"] = this.supplierCode;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["qualityAssessorCode"] = this.qualityAssessorCode;
        return data;
    }
}

export interface IInvestorInputModel {
    investorTypeId?: number;
    brokerId?: string | undefined;
    userEmailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    countryId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    defaultCurrencyTokenId?: string;
    userTypeId?: number;
    advisoryNumber?: string | undefined;
    supplierCode?: string | undefined;
    supplierTaxNumber?: string | undefined;
    qualityAssessorCode?: string | undefined;
}

export class InvestorQualifyingCriteriaDisplayModel implements IInvestorQualifyingCriteriaDisplayModel {
  sourceOfFundsId?: number;
  employmentStatusId?: number;
  yearlyNetIncomeId?: number;
  netWorthId?: number;
  excpectedYearlyInvestmentId?: number;

  constructor(data?: IInvestorQualifyingCriteriaDisplayModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sourceOfFundsId = _data["sourceOfFundsId"];
      this.employmentStatusId = _data["employmentStatusId"];
      this.yearlyNetIncomeId = _data["yearlyNetIncomeId"];
      this.netWorthId = _data["netWorthId"];
      this.excpectedYearlyInvestmentId = _data["excpectedYearlyInvestmentId"];
    }
  }

  static fromJS(data: any): InvestorQualifyingCriteriaDisplayModel {
    data = typeof data === 'object' ? data : {};
    let result = new InvestorQualifyingCriteriaDisplayModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sourceOfFundsId"] = this.sourceOfFundsId;
    data["employmentStatusId"] = this.employmentStatusId;
    data["yearlyNetIncomeId"] = this.yearlyNetIncomeId;
    data["netWorthId"] = this.netWorthId;
    data["excpectedYearlyInvestmentId"] = this.excpectedYearlyInvestmentId;
    return data;
  }
}

export interface IInvestorQualifyingCriteriaDisplayModel {
  sourceOfFundsId?: number;
  employmentStatusId?: number;
  yearlyNetIncomeId?: number;
  netWorthId?: number;
  excpectedYearlyInvestmentId?: number;
}

export class InvestorQualifyingCriteriaInputModel implements IInvestorQualifyingCriteriaInputModel {
    sourceOfFundsId?: number;
    employmentStatusId?: number;
    yearlyNetIncomeId?: number;
    netWorthId?: number;
    excpectedYearlyInvestmentId?: number;

    constructor(data?: IInvestorQualifyingCriteriaInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceOfFundsId = _data["sourceOfFundsId"];
            this.employmentStatusId = _data["employmentStatusId"];
            this.yearlyNetIncomeId = _data["yearlyNetIncomeId"];
            this.netWorthId = _data["netWorthId"];
            this.excpectedYearlyInvestmentId = _data["excpectedYearlyInvestmentId"];
        }
    }

    static fromJS(data: any): InvestorQualifyingCriteriaInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorQualifyingCriteriaInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceOfFundsId"] = this.sourceOfFundsId;
        data["employmentStatusId"] = this.employmentStatusId;
        data["yearlyNetIncomeId"] = this.yearlyNetIncomeId;
        data["netWorthId"] = this.netWorthId;
        data["excpectedYearlyInvestmentId"] = this.excpectedYearlyInvestmentId;
        return data;
    }
}

export interface IInvestorQualifyingCriteriaInputModel {
    sourceOfFundsId?: number;
    employmentStatusId?: number;
    yearlyNetIncomeId?: number;
    netWorthId?: number;
    excpectedYearlyInvestmentId?: number;
}

export class InvestorTokenConfigurationInputModel implements IInvestorTokenConfigurationInputModel {
    accountId?: string;
    tokenId?: string;
    reinvestInterest?: boolean;

    constructor(data?: IInvestorTokenConfigurationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.tokenId = _data["tokenId"];
            this.reinvestInterest = _data["reinvestInterest"];
        }
    }

    static fromJS(data: any): InvestorTokenConfigurationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorTokenConfigurationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["tokenId"] = this.tokenId;
        data["reinvestInterest"] = this.reinvestInterest;
        return data;
    }
}

export interface IInvestorTokenConfigurationInputModel {
    accountId?: string;
    tokenId?: string;
    reinvestInterest?: boolean;
}

export class KycDocumentStatusModel implements IKycDocumentStatusModel {
    kycDocumentId?: number;
    name?: string | undefined;
    description?: string | undefined;
    hasBeenUploaded?: boolean;
    investorDocumentId?: string | undefined;
    uploadedOn?: Date | undefined;
    url?: string | undefined;
    hasBeenVerified?: boolean;
    verifiedOn?: Date | undefined;

    constructor(data?: IKycDocumentStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kycDocumentId = _data["kycDocumentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.hasBeenUploaded = _data["hasBeenUploaded"];
            this.investorDocumentId = _data["investorDocumentId"];
            this.uploadedOn = _data["uploadedOn"] ? new Date(_data["uploadedOn"].toString()) : <any>undefined;
            this.url = _data["url"];
            this.hasBeenVerified = _data["hasBeenVerified"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KycDocumentStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new KycDocumentStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kycDocumentId"] = this.kycDocumentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["hasBeenUploaded"] = this.hasBeenUploaded;
        data["investorDocumentId"] = this.investorDocumentId;
        data["uploadedOn"] = this.uploadedOn ? this.uploadedOn.toISOString() : <any>undefined;
        data["url"] = this.url;
        data["hasBeenVerified"] = this.hasBeenVerified;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IKycDocumentStatusModel {
    kycDocumentId?: number;
    name?: string | undefined;
    description?: string | undefined;
    hasBeenUploaded?: boolean;
    investorDocumentId?: string | undefined;
    uploadedOn?: Date | undefined;
    url?: string | undefined;
    hasBeenVerified?: boolean;
    verifiedOn?: Date | undefined;
}

export class LabourTaskInputModel implements ILabourTaskInputModel {
    projectId?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    weekStart?: number;
    weekDue?: number;
    details?: string | undefined;
    parentTaskId?: string | undefined;

    constructor(data?: ILabourTaskInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.summary = _data["summary"];
            this.taskStatusId = _data["taskStatusId"];
            this.weekStart = _data["weekStart"];
            this.weekDue = _data["weekDue"];
            this.details = _data["details"];
            this.parentTaskId = _data["parentTaskId"];
        }
    }

    static fromJS(data: any): LabourTaskInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new LabourTaskInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["summary"] = this.summary;
        data["taskStatusId"] = this.taskStatusId;
        data["weekStart"] = this.weekStart;
        data["weekDue"] = this.weekDue;
        data["details"] = this.details;
        data["parentTaskId"] = this.parentTaskId;
        return data;
    }
}

export interface ILabourTaskInputModel {
    projectId?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    weekStart?: number;
    weekDue?: number;
    details?: string | undefined;
    parentTaskId?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    verificationToken?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.verificationToken = _data["verificationToken"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["verificationToken"] = this.verificationToken;
        return data;
    }
}

export interface ILoginRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    verificationToken?: string | undefined;
}

export class LoginResponse implements ILoginResponse {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    token?: string | undefined;
    roles?: string[] | undefined;
    permissions?: string[] | undefined;
    shouldDeactivatePassword?: boolean;
    showEnableMfaDialog?: boolean;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.token = _data["token"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.shouldDeactivatePassword = _data["shouldDeactivatePassword"];
            this.showEnableMfaDialog = _data["showEnableMfaDialog"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["token"] = this.token;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["shouldDeactivatePassword"] = this.shouldDeactivatePassword;
        data["showEnableMfaDialog"] = this.showEnableMfaDialog;
        return data;
    }
}

export interface ILoginResponse {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    token?: string | undefined;
    roles?: string[] | undefined;
    permissions?: string[] | undefined;
    shouldDeactivatePassword?: boolean;
    showEnableMfaDialog?: boolean;
}

export class MarketplaceListingAdminDisplayModel implements IMarketplaceListingAdminDisplayModel {
    id?: string;
    typeId?: number;
    typeName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    amount?: number;
    investorId?: string;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    pricePerToken?: number;
    fulfilledAmount?: number;
    remainingAmount?: number;
    statusId?: number;
    statusName?: string | undefined;
    statusIsAvailable?: boolean;
    createdOn?: Date;
    investorName?: string | undefined;

    constructor(data?: IMarketplaceListingAdminDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.amount = _data["amount"];
            this.investorId = _data["investorId"];
            this.investorCompanyName = _data["investorCompanyName"];
            this.investorUserFirstName = _data["investorUserFirstName"];
            this.investorUserLastName = _data["investorUserLastName"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.paymentTokenSymbol = _data["paymentTokenSymbol"];
            this.paymentTokenName = _data["paymentTokenName"];
            this.pricePerToken = _data["pricePerToken"];
            this.fulfilledAmount = _data["fulfilledAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.statusIsAvailable = _data["statusIsAvailable"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.investorName = _data["investorName"];
        }
    }

    static fromJS(data: any): MarketplaceListingAdminDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceListingAdminDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["amount"] = this.amount;
        data["investorId"] = this.investorId;
        data["investorCompanyName"] = this.investorCompanyName;
        data["investorUserFirstName"] = this.investorUserFirstName;
        data["investorUserLastName"] = this.investorUserLastName;
        data["paymentTokenId"] = this.paymentTokenId;
        data["paymentTokenSymbol"] = this.paymentTokenSymbol;
        data["paymentTokenName"] = this.paymentTokenName;
        data["pricePerToken"] = this.pricePerToken;
        data["fulfilledAmount"] = this.fulfilledAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["statusIsAvailable"] = this.statusIsAvailable;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["investorName"] = this.investorName;
        return data;
    }
}

export interface IMarketplaceListingAdminDisplayModel {
    id?: string;
    typeId?: number;
    typeName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    amount?: number;
    investorId?: string;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    pricePerToken?: number;
    fulfilledAmount?: number;
    remainingAmount?: number;
    statusId?: number;
    statusName?: string | undefined;
    statusIsAvailable?: boolean;
    createdOn?: Date;
    investorName?: string | undefined;
}

export class MarketplaceListingAdminDisplayModelPagedResult implements IMarketplaceListingAdminDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (MarketplaceListingAdminDisplayModel | undefined)[] | undefined;

    constructor(data?: IMarketplaceListingAdminDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MarketplaceListingAdminDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketplaceListingAdminDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceListingAdminDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketplaceListingAdminDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (MarketplaceListingAdminDisplayModel | undefined)[] | undefined;
}

export class MarketplaceListingDisplayModel implements IMarketplaceListingDisplayModel {
    id?: string;
    typeId?: number;
    typeName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    amount?: number;
    investorId?: string;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    pricePerToken?: number;
    fulfilledAmount?: number;
    remainingAmount?: number;
    statusId?: number;
    statusName?: string | undefined;
    statusIsAvailable?: boolean;
    createdOn?: Date;

    constructor(data?: IMarketplaceListingDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.amount = _data["amount"];
            this.investorId = _data["investorId"];
            this.investorCompanyName = _data["investorCompanyName"];
            this.investorUserFirstName = _data["investorUserFirstName"];
            this.investorUserLastName = _data["investorUserLastName"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.paymentTokenSymbol = _data["paymentTokenSymbol"];
            this.paymentTokenName = _data["paymentTokenName"];
            this.pricePerToken = _data["pricePerToken"];
            this.fulfilledAmount = _data["fulfilledAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.statusIsAvailable = _data["statusIsAvailable"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketplaceListingDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceListingDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["amount"] = this.amount;
        data["investorId"] = this.investorId;
        data["investorCompanyName"] = this.investorCompanyName;
        data["investorUserFirstName"] = this.investorUserFirstName;
        data["investorUserLastName"] = this.investorUserLastName;
        data["paymentTokenId"] = this.paymentTokenId;
        data["paymentTokenSymbol"] = this.paymentTokenSymbol;
        data["paymentTokenName"] = this.paymentTokenName;
        data["pricePerToken"] = this.pricePerToken;
        data["fulfilledAmount"] = this.fulfilledAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["statusIsAvailable"] = this.statusIsAvailable;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMarketplaceListingDisplayModel {
    id?: string;
    typeId?: number;
    typeName?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeName?: string | undefined;
    amount?: number;
    investorId?: string;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    pricePerToken?: number;
    fulfilledAmount?: number;
    remainingAmount?: number;
    statusId?: number;
    statusName?: string | undefined;
    statusIsAvailable?: boolean;
    createdOn?: Date;
}

export class MarketplaceListingDisplayModelPagedResult implements IMarketplaceListingDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (MarketplaceListingDisplayModel | undefined)[] | undefined;

    constructor(data?: IMarketplaceListingDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MarketplaceListingDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketplaceListingDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceListingDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketplaceListingDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (MarketplaceListingDisplayModel | undefined)[] | undefined;
}

export class MarketplaceListingInputModel implements IMarketplaceListingInputModel {
    marketplaceListingTypeId?: number;
    tokenId?: string;
    amount?: number;
    paymentTokenId?: string;
    pricePerToken?: number;

    constructor(data?: IMarketplaceListingInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketplaceListingTypeId = _data["marketplaceListingTypeId"];
            this.tokenId = _data["tokenId"];
            this.amount = _data["amount"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.pricePerToken = _data["pricePerToken"];
        }
    }

    static fromJS(data: any): MarketplaceListingInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceListingInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketplaceListingTypeId"] = this.marketplaceListingTypeId;
        data["tokenId"] = this.tokenId;
        data["amount"] = this.amount;
        data["paymentTokenId"] = this.paymentTokenId;
        data["pricePerToken"] = this.pricePerToken;
        return data;
    }
}

export interface IMarketplaceListingInputModel {
    marketplaceListingTypeId?: number;
    tokenId?: string;
    amount?: number;
    paymentTokenId?: string;
    pricePerToken?: number;
}

export class MaterialCatalogDisplayModel implements IMaterialCatalogDisplayModel {
    id?: string;
    supplierId?: string;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    code?: string | undefined;
    pricePerUnit?: number;
    validToDate?: Date;
    minQuantity?: number;
    isAvailable?: boolean;
    createdOn?: Date;
    lastUpdated?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    updatedBy?: string;
    updatedByUserName?: string | undefined;
    supplier?: SupplierDisplayModel | undefined;

    constructor(data?: IMaterialCatalogDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.code = _data["code"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.validToDate = _data["validToDate"] ? new Date(_data["validToDate"].toString()) : <any>undefined;
            this.minQuantity = _data["minQuantity"];
            this.isAvailable = _data["isAvailable"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByUserName = _data["createdByUserName"];
            this.updatedBy = _data["updatedBy"];
            this.updatedByUserName = _data["updatedByUserName"];
            this.supplier = _data["supplier"] ? SupplierDisplayModel.fromJS(_data["supplier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialCatalogDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCatalogDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["code"] = this.code;
        data["pricePerUnit"] = this.pricePerUnit;
        data["validToDate"] = this.validToDate ? this.validToDate.toISOString() : <any>undefined;
        data["minQuantity"] = this.minQuantity;
        data["isAvailable"] = this.isAvailable;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByUserName"] = this.createdByUserName;
        data["updatedBy"] = this.updatedBy;
        data["updatedByUserName"] = this.updatedByUserName;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaterialCatalogDisplayModel {
    id?: string;
    supplierId?: string;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    code?: string | undefined;
    pricePerUnit?: number;
    validToDate?: Date;
    minQuantity?: number;
    isAvailable?: boolean;
    createdOn?: Date;
    lastUpdated?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    updatedBy?: string;
    updatedByUserName?: string | undefined;
    supplier?: SupplierDisplayModel | undefined;
}

export class MaterialCatalogDisplayModelPagedResult implements IMaterialCatalogDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (MaterialCatalogDisplayModel | undefined)[] | undefined;

    constructor(data?: IMaterialCatalogDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MaterialCatalogDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialCatalogDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCatalogDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialCatalogDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (MaterialCatalogDisplayModel | undefined)[] | undefined;
}

export class MaterialCatalogInputModel implements IMaterialCatalogInputModel {
    supplierId?: string;
    code?: string | undefined;
    pricePerUnit?: number;
    validToDate?: Date;
    minQuantity?: number;

    constructor(data?: IMaterialCatalogInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.code = _data["code"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.validToDate = _data["validToDate"] ? new Date(_data["validToDate"].toString()) : <any>undefined;
            this.minQuantity = _data["minQuantity"];
        }
    }

    static fromJS(data: any): MaterialCatalogInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCatalogInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["code"] = this.code;
        data["pricePerUnit"] = this.pricePerUnit;
        data["validToDate"] = this.validToDate ? this.validToDate.toISOString() : <any>undefined;
        data["minQuantity"] = this.minQuantity;
        return data;
    }
}

export interface IMaterialCatalogInputModel {
    supplierId?: string;
    code?: string | undefined;
    pricePerUnit?: number;
    validToDate?: Date;
    minQuantity?: number;
}

export class MaterialDisplayModel implements IMaterialDisplayModel {
    id?: string;
    code?: string | undefined;
    details?: string | undefined;
    materialStatusId?: number;
    materialStatusName?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    weekDue?: number;
    quantity?: number;
    createdOn?: Date;
    lastUpdated?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    updatedByUserName?: string | undefined;
    acceptedQuoteId?: string | undefined;
    contractId?: string | undefined;
    dueWeekDate?: Date | undefined;

    constructor(data?: IMaterialDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.details = _data["details"];
            this.materialStatusId = _data["materialStatusId"];
            this.materialStatusName = _data["materialStatusName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectAddress = _data["projectAddress"];
            this.projectEstimatedStartDate = _data["projectEstimatedStartDate"] ? new Date(_data["projectEstimatedStartDate"].toString()) : <any>undefined;
            this.projectEstimatedEndDate = _data["projectEstimatedEndDate"] ? new Date(_data["projectEstimatedEndDate"].toString()) : <any>undefined;
            this.weekDue = _data["weekDue"];
            this.quantity = _data["quantity"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByUserName = _data["createdByUserName"];
            this.updatedByUserName = _data["updatedByUserName"];
            this.acceptedQuoteId = _data["acceptedQuoteId"];
            this.contractId = _data["contractId"];
            this.dueWeekDate = _data["dueWeekDate"] ? new Date(_data["dueWeekDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["details"] = this.details;
        data["materialStatusId"] = this.materialStatusId;
        data["materialStatusName"] = this.materialStatusName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectAddress"] = this.projectAddress;
        data["projectEstimatedStartDate"] = this.projectEstimatedStartDate ? this.projectEstimatedStartDate.toISOString() : <any>undefined;
        data["projectEstimatedEndDate"] = this.projectEstimatedEndDate ? this.projectEstimatedEndDate.toISOString() : <any>undefined;
        data["weekDue"] = this.weekDue;
        data["quantity"] = this.quantity;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByUserName"] = this.createdByUserName;
        data["updatedByUserName"] = this.updatedByUserName;
        data["acceptedQuoteId"] = this.acceptedQuoteId;
        data["contractId"] = this.contractId;
        data["dueWeekDate"] = this.dueWeekDate ? this.dueWeekDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMaterialDisplayModel {
    id?: string;
    code?: string | undefined;
    details?: string | undefined;
    materialStatusId?: number;
    materialStatusName?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    weekDue?: number;
    quantity?: number;
    createdOn?: Date;
    lastUpdated?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    updatedByUserName?: string | undefined;
    acceptedQuoteId?: string | undefined;
    contractId?: string | undefined;
    dueWeekDate?: Date | undefined;
}

export class MaterialDisplayModelPagedResult implements IMaterialDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (MaterialDisplayModel | undefined)[] | undefined;

    constructor(data?: IMaterialDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MaterialDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (MaterialDisplayModel | undefined)[] | undefined;
}

export class MaterialFulfillmentDisplayModel implements IMaterialFulfillmentDisplayModel {
    id?: string;
    materialId?: string;
    materialCode?: string | undefined;
    materialDetails?: string | undefined;
    materialWeekDue?: number;
    quantity?: number;
    comments?: string | undefined;
    fulfilledOn?: Date;
    createdOn?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    material?: MaterialDisplayModel | undefined;

    constructor(data?: IMaterialFulfillmentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.materialCode = _data["materialCode"];
            this.materialDetails = _data["materialDetails"];
            this.materialWeekDue = _data["materialWeekDue"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            this.fulfilledOn = _data["fulfilledOn"] ? new Date(_data["fulfilledOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByUserName = _data["createdByUserName"];
            this.material = _data["material"] ? MaterialDisplayModel.fromJS(_data["material"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialFulfillmentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialFulfillmentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialDetails"] = this.materialDetails;
        data["materialWeekDue"] = this.materialWeekDue;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        data["fulfilledOn"] = this.fulfilledOn ? this.fulfilledOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByUserName"] = this.createdByUserName;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaterialFulfillmentDisplayModel {
    id?: string;
    materialId?: string;
    materialCode?: string | undefined;
    materialDetails?: string | undefined;
    materialWeekDue?: number;
    quantity?: number;
    comments?: string | undefined;
    fulfilledOn?: Date;
    createdOn?: Date;
    createdBy?: string;
    createdByUserName?: string | undefined;
    material?: MaterialDisplayModel | undefined;
}

export class MaterialFulfillmentInputModel implements IMaterialFulfillmentInputModel {
    materialId?: string;
    quantity?: number;
    comments?: string | undefined;
    fulfilledOn?: Date;

    constructor(data?: IMaterialFulfillmentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.quantity = _data["quantity"];
            this.comments = _data["comments"];
            this.fulfilledOn = _data["fulfilledOn"] ? new Date(_data["fulfilledOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialFulfillmentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialFulfillmentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["quantity"] = this.quantity;
        data["comments"] = this.comments;
        data["fulfilledOn"] = this.fulfilledOn ? this.fulfilledOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMaterialFulfillmentInputModel {
    materialId?: string;
    quantity?: number;
    comments?: string | undefined;
    fulfilledOn?: Date;
}

export class MaterialInputModel implements IMaterialInputModel {
    code?: string | undefined;
    details?: string | undefined;
    projectId?: string;
    weekDue?: number;
    quantity?: number;

    constructor(data?: IMaterialInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.details = _data["details"];
            this.projectId = _data["projectId"];
            this.weekDue = _data["weekDue"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): MaterialInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["details"] = this.details;
        data["projectId"] = this.projectId;
        data["weekDue"] = this.weekDue;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IMaterialInputModel {
    code?: string | undefined;
    details?: string | undefined;
    projectId?: string;
    weekDue?: number;
    quantity?: number;
}

export class MaterialQuoteDisplayModel implements IMaterialQuoteDisplayModel {
    id?: string;
    supplierId?: string;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteId?: string;
    quoteQuoteStatusId?: number;
    quoteQuoteStatusName?: string | undefined;
    materialId?: string;
    materialCode?: string | undefined;
    materialDetails?: string | undefined;
    materialProjectId?: string;
    materialProjectName?: string | undefined;
    materialProjectAddress?: string | undefined;
    materialWeekDue?: number;
    materialQuantity?: number;
    pricePerUnit?: number;
    createdOn?: Date;
    lastUpdated?: Date;
    supplier?: SupplierDisplayModel | undefined;
    material?: MaterialDisplayModel | undefined;

    constructor(data?: IMaterialQuoteDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.quoteId = _data["quoteId"];
            this.quoteQuoteStatusId = _data["quoteQuoteStatusId"];
            this.quoteQuoteStatusName = _data["quoteQuoteStatusName"];
            this.materialId = _data["materialId"];
            this.materialCode = _data["materialCode"];
            this.materialDetails = _data["materialDetails"];
            this.materialProjectId = _data["materialProjectId"];
            this.materialProjectName = _data["materialProjectName"];
            this.materialProjectAddress = _data["materialProjectAddress"];
            this.materialWeekDue = _data["materialWeekDue"];
            this.materialQuantity = _data["materialQuantity"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.supplier = _data["supplier"] ? SupplierDisplayModel.fromJS(_data["supplier"]) : <any>undefined;
            this.material = _data["material"] ? MaterialDisplayModel.fromJS(_data["material"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialQuoteDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialQuoteDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["quoteId"] = this.quoteId;
        data["quoteQuoteStatusId"] = this.quoteQuoteStatusId;
        data["quoteQuoteStatusName"] = this.quoteQuoteStatusName;
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialDetails"] = this.materialDetails;
        data["materialProjectId"] = this.materialProjectId;
        data["materialProjectName"] = this.materialProjectName;
        data["materialProjectAddress"] = this.materialProjectAddress;
        data["materialWeekDue"] = this.materialWeekDue;
        data["materialQuantity"] = this.materialQuantity;
        data["pricePerUnit"] = this.pricePerUnit;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaterialQuoteDisplayModel {
    id?: string;
    supplierId?: string;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteId?: string;
    quoteQuoteStatusId?: number;
    quoteQuoteStatusName?: string | undefined;
    materialId?: string;
    materialCode?: string | undefined;
    materialDetails?: string | undefined;
    materialProjectId?: string;
    materialProjectName?: string | undefined;
    materialProjectAddress?: string | undefined;
    materialWeekDue?: number;
    materialQuantity?: number;
    pricePerUnit?: number;
    createdOn?: Date;
    lastUpdated?: Date;
    supplier?: SupplierDisplayModel | undefined;
    material?: MaterialDisplayModel | undefined;
}

export class MaterialQuoteInputModel implements IMaterialQuoteInputModel {
    supplierId?: string;
    quoteId?: string;
    materialId?: string;
    materialCatalogId?: string;
    pricePerUnit?: number;

    constructor(data?: IMaterialQuoteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.quoteId = _data["quoteId"];
            this.materialId = _data["materialId"];
            this.materialCatalogId = _data["materialCatalogId"];
            this.pricePerUnit = _data["pricePerUnit"];
        }
    }

    static fromJS(data: any): MaterialQuoteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialQuoteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["quoteId"] = this.quoteId;
        data["materialId"] = this.materialId;
        data["materialCatalogId"] = this.materialCatalogId;
        data["pricePerUnit"] = this.pricePerUnit;
        return data;
    }
}

export interface IMaterialQuoteInputModel {
    supplierId?: string;
    quoteId?: string;
    materialId?: string;
    materialCatalogId?: string;
    pricePerUnit?: number;
}

export class OrderBookEntryModel implements IOrderBookEntryModel {
    price?: number;
    buyAmount?: number;
    sellAmount?: number;

    constructor(data?: IOrderBookEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.buyAmount = _data["buyAmount"];
            this.sellAmount = _data["sellAmount"];
        }
    }

    static fromJS(data: any): OrderBookEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBookEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["buyAmount"] = this.buyAmount;
        data["sellAmount"] = this.sellAmount;
        return data;
    }
}

export interface IOrderBookEntryModel {
    price?: number;
    buyAmount?: number;
    sellAmount?: number;
}

export class OrderBookModel implements IOrderBookModel {
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    entries?: (OrderBookEntryModel | undefined)[] | undefined;
    readonly spread?: number;

    constructor(data?: IOrderBookModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.paymentTokenId = _data["paymentTokenId"];
            this.paymentTokenSymbol = _data["paymentTokenSymbol"];
            this.paymentTokenName = _data["paymentTokenName"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(OrderBookEntryModel.fromJS(item));
            }
            (<any>this).spread = _data["spread"];
        }
    }

    static fromJS(data: any): OrderBookModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBookModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["paymentTokenId"] = this.paymentTokenId;
        data["paymentTokenSymbol"] = this.paymentTokenSymbol;
        data["paymentTokenName"] = this.paymentTokenName;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["spread"] = this.spread;
        return data;
    }
}

export interface IOrderBookModel {
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    paymentTokenId?: string;
    paymentTokenSymbol?: string | undefined;
    paymentTokenName?: string | undefined;
    entries?: (OrderBookEntryModel | undefined)[] | undefined;
    spread?: number;
}

export class PasswordChangeWithCurrentPasswordInputModel implements IPasswordChangeWithCurrentPasswordInputModel {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IPasswordChangeWithCurrentPasswordInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): PasswordChangeWithCurrentPasswordInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordChangeWithCurrentPasswordInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IPasswordChangeWithCurrentPasswordInputModel {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class PasswordChangeWithTokenInputModel implements IPasswordChangeWithTokenInputModel {
    passwordResetToken?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IPasswordChangeWithTokenInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordResetToken = _data["passwordResetToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): PasswordChangeWithTokenInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordChangeWithTokenInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordResetToken"] = this.passwordResetToken;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IPasswordChangeWithTokenInputModel {
    passwordResetToken?: string | undefined;
    newPassword?: string | undefined;
}

export class PasswordResetRequestModel implements IPasswordResetRequestModel {
    emailAddress?: string | undefined;
    recaptcha?: string | undefined;

    constructor(data?: IPasswordResetRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.recaptcha = _data["recaptcha"];
        }
    }

    static fromJS(data: any): PasswordResetRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["recaptcha"] = this.recaptcha;
        return data;
    }
}

export interface IPasswordResetRequestModel {
    emailAddress?: string | undefined;
    recaptcha?: string | undefined;
}

export class PasswordResetResponse implements IPasswordResetResponse {
    success?: string | undefined;

    constructor(data?: IPasswordResetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IPasswordResetResponse {
    success?: string | undefined;
}

export class PaymentIntentDisplayModel implements IPaymentIntentDisplayModel {
    clientSecret?: string | undefined;
    currency?: string | undefined;
    paymentAmount?: number;

    constructor(data?: IPaymentIntentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
            this.currency = _data["currency"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): PaymentIntentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        data["currency"] = this.currency;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IPaymentIntentDisplayModel {
    clientSecret?: string | undefined;
    currency?: string | undefined;
    paymentAmount?: number;
}

export class PaymentIntentInputModel implements IPaymentIntentInputModel {
    investorId?: string;
    amount?: number;
    tokenId?: string;

    constructor(data?: IPaymentIntentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.amount = _data["amount"];
            this.tokenId = _data["tokenId"];
        }
    }

    static fromJS(data: any): PaymentIntentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["amount"] = this.amount;
        data["tokenId"] = this.tokenId;
        return data;
    }
}

export interface IPaymentIntentInputModel {
    investorId?: string;
    amount?: number;
    tokenId?: string;
}

export class PhoneNumber implements IPhoneNumber {
    countryCode?: string | undefined;
    dialCode?: string | undefined;
    internationalNumber?: string | undefined;
    nationalNumber?: string | undefined;
    number?: string | undefined;

    constructor(data?: IPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.dialCode = _data["dialCode"];
            this.internationalNumber = _data["internationalNumber"];
            this.nationalNumber = _data["nationalNumber"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): PhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["dialCode"] = this.dialCode;
        data["internationalNumber"] = this.internationalNumber;
        data["nationalNumber"] = this.nationalNumber;
        data["number"] = this.number;
        return data;
    }
}

export interface IPhoneNumber {
    countryCode?: string | undefined;
    dialCode?: string | undefined;
    internationalNumber?: string | undefined;
    nationalNumber?: string | undefined;
    number?: string | undefined;
}

export class PledgeDisplayModel implements IPledgeDisplayModel {
    id?: string;
    description?: string | undefined;
    accountId?: string;
    sourceAccountId?: string;
    sourceAccountName?: string | undefined;
    sourceAccountInvestorCompanyName?: string | undefined;
    sourceAccountInvestorUserFirstName?: string | undefined;
    sourceAccountInvestorUserLastName?: string | undefined;
    pledgeStatusId?: number;
    pledgeStatusName?: string | undefined;
    createdOn?: Date;

    constructor(data?: IPledgeDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.accountId = _data["accountId"];
            this.sourceAccountId = _data["sourceAccountId"];
            this.sourceAccountName = _data["sourceAccountName"];
            this.sourceAccountInvestorCompanyName = _data["sourceAccountInvestorCompanyName"];
            this.sourceAccountInvestorUserFirstName = _data["sourceAccountInvestorUserFirstName"];
            this.sourceAccountInvestorUserLastName = _data["sourceAccountInvestorUserLastName"];
            this.pledgeStatusId = _data["pledgeStatusId"];
            this.pledgeStatusName = _data["pledgeStatusName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PledgeDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["accountId"] = this.accountId;
        data["sourceAccountId"] = this.sourceAccountId;
        data["sourceAccountName"] = this.sourceAccountName;
        data["sourceAccountInvestorCompanyName"] = this.sourceAccountInvestorCompanyName;
        data["sourceAccountInvestorUserFirstName"] = this.sourceAccountInvestorUserFirstName;
        data["sourceAccountInvestorUserLastName"] = this.sourceAccountInvestorUserLastName;
        data["pledgeStatusId"] = this.pledgeStatusId;
        data["pledgeStatusName"] = this.pledgeStatusName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPledgeDisplayModel {
    id?: string;
    description?: string | undefined;
    accountId?: string;
    sourceAccountId?: string;
    sourceAccountName?: string | undefined;
    sourceAccountInvestorCompanyName?: string | undefined;
    sourceAccountInvestorUserFirstName?: string | undefined;
    sourceAccountInvestorUserLastName?: string | undefined;
    pledgeStatusId?: number;
    pledgeStatusName?: string | undefined;
    createdOn?: Date;
}

export class PledgeDisplayModelPagedResult implements IPledgeDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (PledgeDisplayModel | undefined)[] | undefined;

    constructor(data?: IPledgeDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PledgeDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PledgeDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPledgeDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (PledgeDisplayModel | undefined)[] | undefined;
}

export class PledgeInputModel implements IPledgeInputModel {
    id?: string;
    description?: string | undefined;
    sourceAccountId?: string;
    pledgedItems?: (PledgeItemInputModel | undefined)[] | undefined;

    constructor(data?: IPledgeInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.sourceAccountId = _data["sourceAccountId"];
            if (Array.isArray(_data["pledgedItems"])) {
                this.pledgedItems = [] as any;
                for (let item of _data["pledgedItems"])
                    this.pledgedItems!.push(PledgeItemInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PledgeInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["sourceAccountId"] = this.sourceAccountId;
        if (Array.isArray(this.pledgedItems)) {
            data["pledgedItems"] = [];
            for (let item of this.pledgedItems)
                data["pledgedItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPledgeInputModel {
    id?: string;
    description?: string | undefined;
    sourceAccountId?: string;
    pledgedItems?: (PledgeItemInputModel | undefined)[] | undefined;
}

export class PledgeItemInputModel implements IPledgeItemInputModel {
    tokenId?: string;
    amount?: number;

    constructor(data?: IPledgeItemInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PledgeItemInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PledgeItemInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPledgeItemInputModel {
    tokenId?: string;
    amount?: number;
}

export class PointModel implements IPointModel {
    x?: number;
    y?: number;

    constructor(data?: IPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): PointModel {
        data = typeof data === 'object' ? data : {};
        let result = new PointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface IPointModel {
    x?: number;
    y?: number;
}

export class PriceDisplayModel implements IPriceDisplayModel {
    id?: string;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    qty?: number;
    priceTypeId?: number;
    priceTypeName?: string | undefined;
    faceValueTokenId?: string | undefined;
    faceValueTokenName?: string | undefined;
    faceValueTokenSymbol?: string | undefined;
    tokenIsPrivate?: boolean;

    constructor(data?: IPriceDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenTokenTypeId = _data["tokenTokenTypeId"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.qty = _data["qty"];
            this.priceTypeId = _data["priceTypeId"];
            this.priceTypeName = _data["priceTypeName"];
            this.faceValueTokenId = _data["faceValueTokenId"];
            this.faceValueTokenName = _data["faceValueTokenName"];
            this.faceValueTokenSymbol = _data["faceValueTokenSymbol"];
            this.tokenIsPrivate = _data["tokenIsPrivate"];
        }
    }

    static fromJS(data: any): PriceDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenTokenTypeId"] = this.tokenTokenTypeId;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["qty"] = this.qty;
        data["priceTypeId"] = this.priceTypeId;
        data["priceTypeName"] = this.priceTypeName;
        data["faceValueTokenId"] = this.faceValueTokenId;
        data["faceValueTokenName"] = this.faceValueTokenName;
        data["faceValueTokenSymbol"] = this.faceValueTokenSymbol;
        data["tokenIsPrivate"] = this.tokenIsPrivate;
        return data;
    }
}

export interface IPriceDisplayModel {
    id?: string;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    qty?: number;
    priceTypeId?: number;
    priceTypeName?: string | undefined;
    faceValueTokenId?: string | undefined;
    faceValueTokenName?: string | undefined;
    faceValueTokenSymbol?: string | undefined;
    tokenIsPrivate?: boolean;
}

export class PriceInputModel implements IPriceInputModel {
    id?: string;
    tokenId?: string;
    qty?: number;
    priceTypeId?: number;
    faceValueTokenId?: string | undefined;

    constructor(data?: IPriceInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.qty = _data["qty"];
            this.priceTypeId = _data["priceTypeId"];
            this.faceValueTokenId = _data["faceValueTokenId"];
        }
    }

    static fromJS(data: any): PriceInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["qty"] = this.qty;
        data["priceTypeId"] = this.priceTypeId;
        data["faceValueTokenId"] = this.faceValueTokenId;
        return data;
    }
}

export interface IPriceInputModel {
    id?: string;
    tokenId?: string;
    qty?: number;
    priceTypeId?: number;
    faceValueTokenId?: string | undefined;
}

export class ProductComponentDisplayModel implements IProductComponentDisplayModel {
    id?: string;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    qty?: number;
    tokenInterestRate?: number | undefined;
    tokenExpiryDate?: Date | undefined;
    tokenPaymentFrequencyName?: string | undefined;

    constructor(data?: IProductComponentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenTokenTypeId = _data["tokenTokenTypeId"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.qty = _data["qty"];
            this.tokenInterestRate = _data["tokenInterestRate"];
            this.tokenExpiryDate = _data["tokenExpiryDate"] ? new Date(_data["tokenExpiryDate"].toString()) : <any>undefined;
            this.tokenPaymentFrequencyName = _data["tokenPaymentFrequencyName"];
        }
    }

    static fromJS(data: any): ProductComponentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductComponentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenTokenTypeId"] = this.tokenTokenTypeId;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["qty"] = this.qty;
        data["tokenInterestRate"] = this.tokenInterestRate;
        data["tokenExpiryDate"] = this.tokenExpiryDate ? this.tokenExpiryDate.toISOString() : <any>undefined;
        data["tokenPaymentFrequencyName"] = this.tokenPaymentFrequencyName;
        return data;
    }
}

export interface IProductComponentDisplayModel {
    id?: string;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    qty?: number;
    tokenInterestRate?: number | undefined;
    tokenExpiryDate?: Date | undefined;
    tokenPaymentFrequencyName?: string | undefined;
}

export class ProductComponentInputModel implements IProductComponentInputModel {
    tokenId?: string;
    qty?: number;

    constructor(data?: IProductComponentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.qty = _data["qty"];
        }
    }

    static fromJS(data: any): ProductComponentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductComponentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["qty"] = this.qty;
        return data;
    }
}

export interface IProductComponentInputModel {
    tokenId?: string;
    qty?: number;
}

export class ProductDisplayModel implements IProductDisplayModel {
    id?: string;
    projectId?: string;
    projectName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    totalQty?: number;
    soldQty?: number;
    readonly availableQty?: number;
    currentInvestorPurchaseQty?: number;
    minQty?: number;
    maxQty?: number;
    productStatusId?: number;
    productStatusName?: string | undefined;
    componentMintingOptionId?: number;
    componentMintingOptionName?: string | undefined;
    readonly componentTokenTypesString?: string | undefined;
    readonly startDate?: Date | undefined;
    readonly endDate?: Date | undefined;
    readonly canInvest?: boolean;
    readonly noInvestmentReason?: string | undefined;
    paymentOptions?: (ProductPaymentOptionDisplayModel | undefined)[] | undefined;
    components?: (ProductComponentDisplayModel | undefined)[] | undefined;

    constructor(data?: IProductDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.totalQty = _data["totalQty"];
            this.soldQty = _data["soldQty"];
            (<any>this).availableQty = _data["availableQty"];
            this.currentInvestorPurchaseQty = _data["currentInvestorPurchaseQty"];
            this.minQty = _data["minQty"];
            this.maxQty = _data["maxQty"];
            this.productStatusId = _data["productStatusId"];
            this.productStatusName = _data["productStatusName"];
            this.componentMintingOptionId = _data["componentMintingOptionId"];
            this.componentMintingOptionName = _data["componentMintingOptionName"];
            (<any>this).componentTokenTypesString = _data["componentTokenTypesString"];
            (<any>this).startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            (<any>this).endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            (<any>this).canInvest = _data["canInvest"];
            (<any>this).noInvestmentReason = _data["noInvestmentReason"];
            if (Array.isArray(_data["paymentOptions"])) {
                this.paymentOptions = [] as any;
                for (let item of _data["paymentOptions"])
                    this.paymentOptions!.push(ProductPaymentOptionDisplayModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ProductComponentDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["totalQty"] = this.totalQty;
        data["soldQty"] = this.soldQty;
        data["availableQty"] = this.availableQty;
        data["currentInvestorPurchaseQty"] = this.currentInvestorPurchaseQty;
        data["minQty"] = this.minQty;
        data["maxQty"] = this.maxQty;
        data["productStatusId"] = this.productStatusId;
        data["productStatusName"] = this.productStatusName;
        data["componentMintingOptionId"] = this.componentMintingOptionId;
        data["componentMintingOptionName"] = this.componentMintingOptionName;
        data["componentTokenTypesString"] = this.componentTokenTypesString;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["canInvest"] = this.canInvest;
        data["noInvestmentReason"] = this.noInvestmentReason;
        if (Array.isArray(this.paymentOptions)) {
            data["paymentOptions"] = [];
            for (let item of this.paymentOptions)
                data["paymentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductDisplayModel {
    id?: string;
    projectId?: string;
    projectName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    totalQty?: number;
    soldQty?: number;
    availableQty?: number;
    currentInvestorPurchaseQty?: number;
    minQty?: number;
    maxQty?: number;
    productStatusId?: number;
    productStatusName?: string | undefined;
    componentMintingOptionId?: number;
    componentMintingOptionName?: string | undefined;
    componentTokenTypesString?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    canInvest?: boolean;
    noInvestmentReason?: string | undefined;
    paymentOptions?: (ProductPaymentOptionDisplayModel | undefined)[] | undefined;
    components?: (ProductComponentDisplayModel | undefined)[] | undefined;
}

export class ProductDisplayModelPagedResult implements IProductDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ProductDisplayModel | undefined)[] | undefined;

    constructor(data?: IProductDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ProductDisplayModel | undefined)[] | undefined;
}

export class ProductInputModel implements IProductInputModel {
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    totalQty?: number;
    minQty?: number;
    maxQty?: number;
    productStatusId?: number;
    componentMintingOptionId?: number;

    constructor(data?: IProductInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.totalQty = _data["totalQty"];
            this.minQty = _data["minQty"];
            this.maxQty = _data["maxQty"];
            this.productStatusId = _data["productStatusId"];
            this.componentMintingOptionId = _data["componentMintingOptionId"];
        }
    }

    static fromJS(data: any): ProductInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["totalQty"] = this.totalQty;
        data["minQty"] = this.minQty;
        data["maxQty"] = this.maxQty;
        data["productStatusId"] = this.productStatusId;
        data["componentMintingOptionId"] = this.componentMintingOptionId;
        return data;
    }
}

export interface IProductInputModel {
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    totalQty?: number;
    minQty?: number;
    maxQty?: number;
    productStatusId?: number;
    componentMintingOptionId?: number;
}

export class ProductPaymentOptionDisplayModel implements IProductPaymentOptionDisplayModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    readonly priceString?: string | undefined;
    readonly canInvest?: boolean;
    readonly canInvestReason?: string | undefined;
    prices?: (PriceDisplayModel | undefined)[] | undefined;
    investorHasPriceTokens?: boolean;
    productId?: string;

    constructor(data?: IProductPaymentOptionDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            (<any>this).priceString = _data["priceString"];
            (<any>this).canInvest = _data["canInvest"];
            (<any>this).canInvestReason = _data["canInvestReason"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceDisplayModel.fromJS(item));
            }
            this.investorHasPriceTokens = _data["investorHasPriceTokens"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductPaymentOptionDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPaymentOptionDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["priceString"] = this.priceString;
        data["canInvest"] = this.canInvest;
        data["canInvestReason"] = this.canInvestReason;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        data["investorHasPriceTokens"] = this.investorHasPriceTokens;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IProductPaymentOptionDisplayModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    priceString?: string | undefined;
    canInvest?: boolean;
    canInvestReason?: string | undefined;
    prices?: (PriceDisplayModel | undefined)[] | undefined;
    investorHasPriceTokens?: boolean;
    productId?: string;
}

export class ProductPaymentOptionInputModel implements IProductPaymentOptionInputModel {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    prices?: (PriceInputModel | undefined)[] | undefined;

    constructor(data?: IProductPaymentOptionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPaymentOptionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPaymentOptionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductPaymentOptionInputModel {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    prices?: (PriceInputModel | undefined)[] | undefined;
}

export class ProfilePictureChangeInputModel implements IProfilePictureChangeInputModel {
    profileImageUrl?: string | undefined;

    constructor(data?: IProfilePictureChangeInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileImageUrl = _data["profileImageUrl"];
        }
    }

    static fromJS(data: any): ProfilePictureChangeInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePictureChangeInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileImageUrl"] = this.profileImageUrl;
        return data;
    }
}

export interface IProfilePictureChangeInputModel {
    profileImageUrl?: string | undefined;
}

export class ProjectDateDisplayModel implements IProjectDateDisplayModel {
    projectId?: string;
    week?: number;
    date?: Date;
    project?: ProjectDisplayModel | undefined;

    constructor(data?: IProjectDateDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.week = _data["week"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.project = _data["project"] ? ProjectDisplayModel.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDateDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDateDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["week"] = this.week;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectDateDisplayModel {
    projectId?: string;
    week?: number;
    date?: Date;
    project?: ProjectDisplayModel | undefined;
}

export class ProjectDateInputModel implements IProjectDateInputModel {
    projectId?: string;
    numberOfWeeks?: number;
    date?: Date;

    constructor(data?: IProjectDateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.numberOfWeeks = _data["numberOfWeeks"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["numberOfWeeks"] = this.numberOfWeeks;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectDateInputModel {
    projectId?: string;
    numberOfWeeks?: number;
    date?: Date;
}

export class ProjectDateOverviewDisplayModel implements IProjectDateOverviewDisplayModel {
    projectId?: string;
    projectName?: string | undefined;
    weeksTotal?: number;
    startDate?: Date;
    projectDates?: (ProjectDateDisplayModel | undefined)[] | undefined;

    constructor(data?: IProjectDateOverviewDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.weeksTotal = _data["weeksTotal"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["projectDates"])) {
                this.projectDates = [] as any;
                for (let item of _data["projectDates"])
                    this.projectDates!.push(ProjectDateDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDateOverviewDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDateOverviewDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["weeksTotal"] = this.weeksTotal;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.projectDates)) {
            data["projectDates"] = [];
            for (let item of this.projectDates)
                data["projectDates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDateOverviewDisplayModel {
    projectId?: string;
    projectName?: string | undefined;
    weeksTotal?: number;
    startDate?: Date;
    projectDates?: (ProjectDateDisplayModel | undefined)[] | undefined;
}

export class ProjectDateUpdateModel implements IProjectDateUpdateModel {
    projectId?: string;
    week?: number;
    date?: Date;

    constructor(data?: IProjectDateUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.week = _data["week"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDateUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDateUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["week"] = this.week;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectDateUpdateModel {
    projectId?: string;
    week?: number;
    date?: Date;
}

export class ProjectDisplayModel implements IProjectDisplayModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    typeName?: string | undefined;
    returnTypeId?: number;
    returnTypeName?: string | undefined;
    statusId?: number;
    statusName?: string | undefined;
    address?: string | undefined;
    geoLocation?: PointModel | undefined;
    estimatedStartDate?: Date | undefined;
    estimatedEndDate?: Date | undefined;
    budget?: number | undefined;
    estimatedSalesValue?: number | undefined;
    reserveValueOfDebt?: number | undefined;
    reserveValueOfEquity?: number | undefined;
    summary?: string | undefined;
    targetReturns?: string | undefined;
    coverImageLink?: string | undefined;
    coverImageName?: string | undefined;
    isFeatured?: boolean;
  preventView?: boolean;
    featuredOrder?: number;
    rating?: string | undefined;
    createdOn?: Date;
    account?: AccountDisplayModel | undefined;
    readonly canInvest?: boolean;
    canInvestInProject?: boolean;
    products?: (ProductDisplayModel | undefined)[] | undefined;
    equityToken?: TokenDisplayModel | undefined;
    readonly availableInvestmentOptions?: string | undefined;
    readonly minimumReturn?: number | undefined;
    readonly investmentStatus?: string | undefined;
    readonly investmentStartDate?: Date | undefined;
    readonly investmentEndDate?: Date | undefined;

    constructor(data?: IProjectDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.returnTypeId = _data["returnTypeId"];
            this.returnTypeName = _data["returnTypeName"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.address = _data["address"];
            this.geoLocation = _data["geoLocation"] ? PointModel.fromJS(_data["geoLocation"]) : <any>undefined;
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.estimatedEndDate = _data["estimatedEndDate"] ? new Date(_data["estimatedEndDate"].toString()) : <any>undefined;
            this.budget = _data["budget"];
            this.estimatedSalesValue = _data["estimatedSalesValue"];
            this.reserveValueOfDebt = _data["reserveValueOfDebt"];
            this.reserveValueOfEquity = _data["reserveValueOfEquity"];
            this.summary = _data["summary"];
            this.targetReturns = _data["targetReturns"];
            this.coverImageLink = _data["coverImageLink"];
            this.coverImageName = _data["coverImageName"];
            this.isFeatured = _data["isFeatured"];
          this.preventView = _data["preventView"];
            this.featuredOrder = _data["featuredOrder"];
            this.rating = _data["rating"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.account = _data["account"] ? AccountDisplayModel.fromJS(_data["account"]) : <any>undefined;
            (<any>this).canInvest = _data["canInvest"];
            this.canInvestInProject = _data["canInvestInProject"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDisplayModel.fromJS(item));
            }
            this.equityToken = _data["equityToken"] ? TokenDisplayModel.fromJS(_data["equityToken"]) : <any>undefined;
            (<any>this).availableInvestmentOptions = _data["availableInvestmentOptions"];
            (<any>this).minimumReturn = _data["minimumReturn"];
            (<any>this).investmentStatus = _data["investmentStatus"];
            (<any>this).investmentStartDate = _data["investmentStartDate"] ? new Date(_data["investmentStartDate"].toString()) : <any>undefined;
            (<any>this).investmentEndDate = _data["investmentEndDate"] ? new Date(_data["investmentEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["returnTypeId"] = this.returnTypeId;
        data["returnTypeName"] = this.returnTypeName;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["address"] = this.address;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["estimatedEndDate"] = this.estimatedEndDate ? this.estimatedEndDate.toISOString() : <any>undefined;
        data["budget"] = this.budget;
        data["estimatedSalesValue"] = this.estimatedSalesValue;
        data["reserveValueOfDebt"] = this.reserveValueOfDebt;
        data["reserveValueOfEquity"] = this.reserveValueOfEquity;
        data["summary"] = this.summary;
        data["targetReturns"] = this.targetReturns;
        data["coverImageLink"] = this.coverImageLink;
        data["coverImageName"] = this.coverImageName;
        data["isFeatured"] = this.isFeatured;
        data["preventView"] = this.preventView;
        data["featuredOrder"] = this.featuredOrder;
        data["rating"] = this.rating;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["canInvest"] = this.canInvest;
        data["canInvestInProject"] = this.canInvestInProject;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["equityToken"] = this.equityToken ? this.equityToken.toJSON() : <any>undefined;
        data["availableInvestmentOptions"] = this.availableInvestmentOptions;
        data["minimumReturn"] = this.minimumReturn;
        data["investmentStatus"] = this.investmentStatus;
        data["investmentStartDate"] = this.investmentStartDate ? this.investmentStartDate.toISOString() : <any>undefined;
        data["investmentEndDate"] = this.investmentEndDate ? this.investmentEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectDisplayModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    typeName?: string | undefined;
    returnTypeId?: number;
    returnTypeName?: string | undefined;
    statusId?: number;
    statusName?: string | undefined;
    address?: string | undefined;
    geoLocation?: PointModel | undefined;
    estimatedStartDate?: Date | undefined;
    estimatedEndDate?: Date | undefined;
    budget?: number | undefined;
    estimatedSalesValue?: number | undefined;
    reserveValueOfDebt?: number | undefined;
    reserveValueOfEquity?: number | undefined;
    summary?: string | undefined;
    targetReturns?: string | undefined;
    coverImageLink?: string | undefined;
    coverImageName?: string | undefined;
    isFeatured?: boolean;
  preventView?: boolean
    featuredOrder?: number;
    rating?: string | undefined;
    createdOn?: Date;
    account?: AccountDisplayModel | undefined;
    canInvest?: boolean;
    canInvestInProject?: boolean;
    products?: (ProductDisplayModel | undefined)[] | undefined;
    equityToken?: TokenDisplayModel | undefined;
    availableInvestmentOptions?: string | undefined;
    minimumReturn?: number | undefined;
    investmentStatus?: string | undefined;
    investmentStartDate?: Date | undefined;
    investmentEndDate?: Date | undefined;
}

export class ProjectOverviewModel implements IProjectOverviewModel {
  id?: string;
  name?: string | undefined;

  constructor(data?: IProjectOverviewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): ProjectOverviewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectOverviewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IProjectOverviewModel {
  id?: string;
  name?: string | undefined;
}


export class ProjectDisplayModelPagedResult implements IProjectDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ProjectDisplayModel | undefined)[] | undefined;

    constructor(data?: IProjectDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ProjectDisplayModel | undefined)[] | undefined;
}

export class ProjectDocumentDisplayModel implements IProjectDocumentDisplayModel {
    id?: string;
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    showInQuickDownloads?: boolean;
    projectName?: string | undefined;

    constructor(data?: IProjectDocumentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.showInQuickDownloads = _data["showInQuickDownloads"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ProjectDocumentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDocumentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["showInQuickDownloads"] = this.showInQuickDownloads;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IProjectDocumentDisplayModel {
    id?: string;
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    showInQuickDownloads?: boolean;
    projectName?: string | undefined;
}

export class ProjectDocumentInputModel implements IProjectDocumentInputModel {
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    showInQuickDownloads?: boolean;

    constructor(data?: IProjectDocumentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.showInQuickDownloads = _data["showInQuickDownloads"];
        }
    }

    static fromJS(data: any): ProjectDocumentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDocumentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["showInQuickDownloads"] = this.showInQuickDownloads;
        return data;
    }
}

export interface IProjectDocumentInputModel {
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    showInQuickDownloads?: boolean;
}

export class ProjectFundRaisingTotalModel implements IProjectFundRaisingTotalModel {
    projectId?: string;
    projectName?: string | undefined;
    totalInvested?: number;
    totalPledged?: number;

    constructor(data?: IProjectFundRaisingTotalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.totalInvested = _data["totalInvested"];
            this.totalPledged = _data["totalPledged"];
        }
    }

    static fromJS(data: any): ProjectFundRaisingTotalModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFundRaisingTotalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["totalInvested"] = this.totalInvested;
        data["totalPledged"] = this.totalPledged;
        return data;
    }
}

export interface IProjectFundRaisingTotalModel {
    projectId?: string;
    projectName?: string | undefined;
    totalInvested?: number;
    totalPledged?: number;
}

export class ProjectImageInputModel implements IProjectImageInputModel {
    url?: string | undefined;

    constructor(data?: IProjectImageInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ProjectImageInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectImageInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IProjectImageInputModel {
    url?: string | undefined;
}

export class ProjectImageModel implements IProjectImageModel {
    id?: string;
    projectId?: string;
    url?: string | undefined;
    imageName?: string | undefined;
    displayOrder?: number;

    constructor(data?: IProjectImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.url = _data["url"];
            this.imageName = _data["imageName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ProjectImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["url"] = this.url;
        data["imageName"] = this.imageName;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IProjectImageModel {
    id?: string;
    projectId?: string;
    url?: string | undefined;
    imageName?: string | undefined;
    displayOrder?: number;
}

export class ProjectInputModel implements IProjectInputModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    returnTypeId?: number;
    statusId?: number;
    address?: string | undefined;
    geoLocation?: PointModel | undefined;
    estimatedStartDate?: Date | undefined;
    estimatedEndDate?: Date | undefined;
    budget?: number | undefined;
    estimatedSalesValue?: number | undefined;
    reserveValueOfDebt?: number | undefined;
    reserveValueOfEquity?: number | undefined;
    summary?: string | undefined;
    targetReturns?: string | undefined;
    coverImageLink?: string | undefined;
    isFeatured?: boolean;
  preventView?: boolean
    featuredOrder?: number;
    rating?: string | undefined;

    constructor(data?: IProjectInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.returnTypeId = _data["returnTypeId"];
            this.statusId = _data["statusId"];
            this.address = _data["address"];
            this.geoLocation = _data["geoLocation"] ? PointModel.fromJS(_data["geoLocation"]) : <any>undefined;
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.estimatedEndDate = _data["estimatedEndDate"] ? new Date(_data["estimatedEndDate"].toString()) : <any>undefined;
            this.budget = _data["budget"];
            this.estimatedSalesValue = _data["estimatedSalesValue"];
            this.reserveValueOfDebt = _data["reserveValueOfDebt"];
            this.reserveValueOfEquity = _data["reserveValueOfEquity"];
            this.summary = _data["summary"];
            this.targetReturns = _data["targetReturns"];
            this.coverImageLink = _data["coverImageLink"];
            this.isFeatured = _data["isFeatured"];
          this.preventView = _data["preventView"];
            this.featuredOrder = _data["featuredOrder"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): ProjectInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["returnTypeId"] = this.returnTypeId;
        data["statusId"] = this.statusId;
        data["address"] = this.address;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["estimatedEndDate"] = this.estimatedEndDate ? this.estimatedEndDate.toISOString() : <any>undefined;
        data["budget"] = this.budget;
        data["estimatedSalesValue"] = this.estimatedSalesValue;
        data["reserveValueOfDebt"] = this.reserveValueOfDebt;
        data["reserveValueOfEquity"] = this.reserveValueOfEquity;
        data["summary"] = this.summary;
        data["targetReturns"] = this.targetReturns;
        data["coverImageLink"] = this.coverImageLink;
        data["isFeatured"] = this.isFeatured;
      data["preventView"] = this.preventView;
        data["featuredOrder"] = this.featuredOrder;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IProjectInputModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    returnTypeId?: number;
    statusId?: number;
    address?: string | undefined;
    geoLocation?: PointModel | undefined;
    estimatedStartDate?: Date | undefined;
    estimatedEndDate?: Date | undefined;
    budget?: number | undefined;
    estimatedSalesValue?: number | undefined;
    reserveValueOfDebt?: number | undefined;
    reserveValueOfEquity?: number | undefined;
    summary?: string | undefined;
    targetReturns?: string | undefined;
    coverImageLink?: string | undefined;
    isFeatured?: boolean;
    preventView?: boolean;
    featuredOrder?: number;
    rating?: string | undefined;
}

export class ProjectTokenModel implements IProjectTokenModel {
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    totalSupply?: number;
    sold?: number;
    investorBalance?: number;
    tokenEthereumContractAddress?: string | undefined;
    tokenContractDocumentUrl?: string | undefined;
    tokenValue?: number;
    tokenIsPrivate?: boolean;
    tokenBackingPledgeId?: string | undefined;

    constructor(data?: IProjectTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.totalSupply = _data["totalSupply"];
            this.sold = _data["sold"];
            this.investorBalance = _data["investorBalance"];
            this.tokenEthereumContractAddress = _data["tokenEthereumContractAddress"];
            this.tokenContractDocumentUrl = _data["tokenContractDocumentUrl"];
            this.tokenValue = _data["tokenValue"];
            this.tokenIsPrivate = _data["tokenIsPrivate"];
            this.tokenBackingPledgeId = _data["tokenBackingPledgeId"];
        }
    }

    static fromJS(data: any): ProjectTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["totalSupply"] = this.totalSupply;
        data["sold"] = this.sold;
        data["investorBalance"] = this.investorBalance;
        data["tokenEthereumContractAddress"] = this.tokenEthereumContractAddress;
        data["tokenContractDocumentUrl"] = this.tokenContractDocumentUrl;
        data["tokenValue"] = this.tokenValue;
        data["tokenIsPrivate"] = this.tokenIsPrivate;
        data["tokenBackingPledgeId"] = this.tokenBackingPledgeId;
        return data;
    }
}

export interface IProjectTokenModel {
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    totalSupply?: number;
    sold?: number;
    investorBalance?: number;
    tokenEthereumContractAddress?: string | undefined;
    tokenContractDocumentUrl?: string | undefined;
    tokenValue?: number;
    tokenIsPrivate?: boolean;
    tokenBackingPledgeId?: string | undefined;
}

export class ProjectVideoInputModel implements IProjectVideoInputModel {
    url?: string | undefined;

    constructor(data?: IProjectVideoInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ProjectVideoInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVideoInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IProjectVideoInputModel {
    url?: string | undefined;
}

export class ProjectVideoModel implements IProjectVideoModel {
    id?: string;
    projectId?: string;
    url?: string | undefined;
    displayOrder?: number;

    constructor(data?: IProjectVideoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.url = _data["url"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ProjectVideoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVideoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["url"] = this.url;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IProjectVideoModel {
    id?: string;
    projectId?: string;
    url?: string | undefined;
    displayOrder?: number;
}

export class PurchaseDisplayModel implements IPurchaseDisplayModel {
    id?: string;
    investorId?: string;
    investorUserName?: string | undefined;
    investorCompanyName?: string | undefined;
    productId?: string;
    productName?: string | undefined;
    productPaymentOptionId?: string;
    productProjectId?: string;
    productProjectName?: string | undefined;
    qty?: number;
    createdOn?: Date;
    effectiveDate?: Date;
    purchaseStatusId?: number;
    purchaseStatusName?: string | undefined;
    transactionIds?: string[] | undefined;
    createdByUserName?: string | undefined;

    constructor(data?: IPurchaseDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investorId = _data["investorId"];
            this.investorUserName = _data["investorUserName"];
            this.investorCompanyName = _data["investorCompanyName"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productPaymentOptionId = _data["productPaymentOptionId"];
            this.productProjectId = _data["productProjectId"];
            this.productProjectName = _data["productProjectName"];
            this.qty = _data["qty"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.purchaseStatusId = _data["purchaseStatusId"];
            this.purchaseStatusName = _data["purchaseStatusName"];
            if (Array.isArray(_data["transactionIds"])) {
                this.transactionIds = [] as any;
                for (let item of _data["transactionIds"])
                    this.transactionIds!.push(item);
            }
            this.createdByUserName = _data["createdByUserName"];
        }
    }

    static fromJS(data: any): PurchaseDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investorId"] = this.investorId;
        data["investorUserName"] = this.investorUserName;
        data["investorCompanyName"] = this.investorCompanyName;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productPaymentOptionId"] = this.productPaymentOptionId;
        data["productProjectId"] = this.productProjectId;
        data["productProjectName"] = this.productProjectName;
        data["qty"] = this.qty;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["purchaseStatusId"] = this.purchaseStatusId;
        data["purchaseStatusName"] = this.purchaseStatusName;
        if (Array.isArray(this.transactionIds)) {
            data["transactionIds"] = [];
            for (let item of this.transactionIds)
                data["transactionIds"].push(item);
        }
        data["createdByUserName"] = this.createdByUserName;
        return data;
    }
}

export interface IPurchaseDisplayModel {
    id?: string;
    investorId?: string;
    investorUserName?: string | undefined;
    investorCompanyName?: string | undefined;
    productId?: string;
    productName?: string | undefined;
    productPaymentOptionId?: string;
    productProjectId?: string;
    productProjectName?: string | undefined;
    qty?: number;
    createdOn?: Date;
    effectiveDate?: Date;
    purchaseStatusId?: number;
    purchaseStatusName?: string | undefined;
    transactionIds?: string[] | undefined;
    createdByUserName?: string | undefined;
}

export class PurchaseDisplayModelPagedResult implements IPurchaseDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (PurchaseDisplayModel | undefined)[] | undefined;

    constructor(data?: IPurchaseDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PurchaseDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (PurchaseDisplayModel | undefined)[] | undefined;
}

export class PurchaseTokenBalanceRowModel implements IPurchaseTokenBalanceRowModel {
    token?: TokenDisplayModel | undefined;
    qty?: number;
    currentBalance?: number;
    qtyIsTokenFaceValue?: boolean;

    constructor(data?: IPurchaseTokenBalanceRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? TokenDisplayModel.fromJS(_data["token"]) : <any>undefined;
            this.qty = _data["qty"];
            this.currentBalance = _data["currentBalance"];
            this.qtyIsTokenFaceValue = _data["qtyIsTokenFaceValue"];
        }
    }

    static fromJS(data: any): PurchaseTokenBalanceRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTokenBalanceRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        data["qty"] = this.qty;
        data["currentBalance"] = this.currentBalance;
        data["qtyIsTokenFaceValue"] = this.qtyIsTokenFaceValue;
        return data;
    }
}

export interface IPurchaseTokenBalanceRowModel {
    token?: TokenDisplayModel | undefined;
    qty?: number;
    currentBalance?: number;
    qtyIsTokenFaceValue?: boolean;
}

export class PurchaseTokenBalancesModel implements IPurchaseTokenBalancesModel {
    readonly maxAffordableQty?: number;
    readonly canReserve?: boolean;
    prices?: (PurchaseTokenBalanceRowModel | undefined)[] | undefined;
    components?: (PurchaseTokenBalanceRowModel | undefined)[] | undefined;

    constructor(data?: IPurchaseTokenBalancesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).maxAffordableQty = _data["maxAffordableQty"];
            (<any>this).canReserve = _data["canReserve"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PurchaseTokenBalanceRowModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(PurchaseTokenBalanceRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseTokenBalancesModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTokenBalancesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAffordableQty"] = this.maxAffordableQty;
        data["canReserve"] = this.canReserve;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseTokenBalancesModel {
    maxAffordableQty?: number;
    canReserve?: boolean;
    prices?: (PurchaseTokenBalanceRowModel | undefined)[] | undefined;
    components?: (PurchaseTokenBalanceRowModel | undefined)[] | undefined;
}

export class QualityAssessorDisplayModel implements IQualityAssessorDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    qualityAssessorCode?: string | undefined;

    constructor(data?: IQualityAssessorDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.companyName = _data["companyName"];
            this.qualityAssessorCode = _data["qualityAssessorCode"];
        }
    }

    static fromJS(data: any): QualityAssessorDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualityAssessorDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        data["qualityAssessorCode"] = this.qualityAssessorCode;
        return data;
    }
}

export interface IQualityAssessorDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    qualityAssessorCode?: string | undefined;
}

export class QuoteDisplayModel implements IQuoteDisplayModel {
    id?: string;
    quoteReference?: string | undefined;
    description?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteStatusId?: number;
    quoteStatusName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTasks?: (TaskQuoteDisplayModel | undefined)[] | undefined;
    materials?: (MaterialQuoteDisplayModel | undefined)[] | undefined;

    constructor(data?: IQuoteDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quoteReference = _data["quoteReference"];
            this.description = _data["description"];
            this.supplierId = _data["supplierId"];
            this.supplierCode = _data["supplierCode"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.quoteStatusId = _data["quoteStatusId"];
            this.quoteStatusName = _data["quoteStatusName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            if (Array.isArray(_data["labourTasks"])) {
                this.labourTasks = [] as any;
                for (let item of _data["labourTasks"])
                    this.labourTasks!.push(TaskQuoteDisplayModel.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(MaterialQuoteDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quoteReference"] = this.quoteReference;
        data["description"] = this.description;
        data["supplierId"] = this.supplierId;
        data["supplierCode"] = this.supplierCode;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["quoteStatusId"] = this.quoteStatusId;
        data["quoteStatusName"] = this.quoteStatusName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (Array.isArray(this.labourTasks)) {
            data["labourTasks"] = [];
            for (let item of this.labourTasks)
                data["labourTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuoteDisplayModel {
    id?: string;
    quoteReference?: string | undefined;
    description?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteStatusId?: number;
    quoteStatusName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTasks?: (TaskQuoteDisplayModel | undefined)[] | undefined;
    materials?: (MaterialQuoteDisplayModel | undefined)[] | undefined;
}

export class QuoteInputModel implements IQuoteInputModel {
    description?: string | undefined;
    supplierId?: string;
    taskQuotes?: (TaskQuoteInputModel | undefined)[] | undefined;
    materialQuotes?: (MaterialQuoteInputModel | undefined)[] | undefined;
    publishQuote?: boolean;

    constructor(data?: IQuoteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.supplierId = _data["supplierId"];
            if (Array.isArray(_data["taskQuotes"])) {
                this.taskQuotes = [] as any;
                for (let item of _data["taskQuotes"])
                    this.taskQuotes!.push(TaskQuoteInputModel.fromJS(item));
            }
            if (Array.isArray(_data["materialQuotes"])) {
                this.materialQuotes = [] as any;
                for (let item of _data["materialQuotes"])
                    this.materialQuotes!.push(MaterialQuoteInputModel.fromJS(item));
            }
            this.publishQuote = _data["publishQuote"];
        }
    }

    static fromJS(data: any): QuoteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["supplierId"] = this.supplierId;
        if (Array.isArray(this.taskQuotes)) {
            data["taskQuotes"] = [];
            for (let item of this.taskQuotes)
                data["taskQuotes"].push(item.toJSON());
        }
        if (Array.isArray(this.materialQuotes)) {
            data["materialQuotes"] = [];
            for (let item of this.materialQuotes)
                data["materialQuotes"].push(item.toJSON());
        }
        data["publishQuote"] = this.publishQuote;
        return data;
    }
}

export interface IQuoteInputModel {
    description?: string | undefined;
    supplierId?: string;
    taskQuotes?: (TaskQuoteInputModel | undefined)[] | undefined;
    materialQuotes?: (MaterialQuoteInputModel | undefined)[] | undefined;
    publishQuote?: boolean;
}

export class QuoteListDisplayModel implements IQuoteListDisplayModel {
    id?: string;
    quoteReference?: string | undefined;
    description?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteStatusId?: number;
    quoteStatusName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;

    constructor(data?: IQuoteListDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quoteReference = _data["quoteReference"];
            this.description = _data["description"];
            this.supplierId = _data["supplierId"];
            this.supplierCode = _data["supplierCode"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.quoteStatusId = _data["quoteStatusId"];
            this.quoteStatusName = _data["quoteStatusName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuoteListDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteListDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quoteReference"] = this.quoteReference;
        data["description"] = this.description;
        data["supplierId"] = this.supplierId;
        data["supplierCode"] = this.supplierCode;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["quoteStatusId"] = this.quoteStatusId;
        data["quoteStatusName"] = this.quoteStatusName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQuoteListDisplayModel {
    id?: string;
    quoteReference?: string | undefined;
    description?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    quoteStatusId?: number;
    quoteStatusName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
}

export class QuoteListDisplayModelPagedResult implements IQuoteListDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (QuoteListDisplayModel | undefined)[] | undefined;

    constructor(data?: IQuoteListDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(QuoteListDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteListDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteListDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuoteListDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (QuoteListDisplayModel | undefined)[] | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    token?: string | undefined;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IRefreshTokenResponse {
    token?: string | undefined;
}

export class ReorderModel implements IReorderModel {
    objectId?: string;
    newDisplayOrder?: number;

    constructor(data?: IReorderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.newDisplayOrder = _data["newDisplayOrder"];
        }
    }

    static fromJS(data: any): ReorderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["newDisplayOrder"] = this.newDisplayOrder;
        return data;
    }
}

export interface IReorderModel {
    objectId?: string;
    newDisplayOrder?: number;
}

export class ReworkTaskInputModel implements IReworkTaskInputModel {
    uncompletedTasks?: (LabourTaskInputModel | undefined)[] | undefined;

    constructor(data?: IReworkTaskInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uncompletedTasks"])) {
                this.uncompletedTasks = [] as any;
                for (let item of _data["uncompletedTasks"])
                    this.uncompletedTasks!.push(LabourTaskInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReworkTaskInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReworkTaskInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uncompletedTasks)) {
            data["uncompletedTasks"] = [];
            for (let item of this.uncompletedTasks)
                data["uncompletedTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReworkTaskInputModel {
    uncompletedTasks?: (LabourTaskInputModel | undefined)[] | undefined;
}

export class ScheduleEarlyPayoutInputModel implements IScheduleEarlyPayoutInputModel {
    accountId?: string;
    tokenId?: string;
    scheduledPayoutDate?: Date;

    constructor(data?: IScheduleEarlyPayoutInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.tokenId = _data["tokenId"];
            this.scheduledPayoutDate = _data["scheduledPayoutDate"] ? new Date(_data["scheduledPayoutDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleEarlyPayoutInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleEarlyPayoutInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["tokenId"] = this.tokenId;
        data["scheduledPayoutDate"] = this.scheduledPayoutDate ? this.scheduledPayoutDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduleEarlyPayoutInputModel {
    accountId?: string;
    tokenId?: string;
    scheduledPayoutDate?: Date;
}

export class ScheduledPayoutDisplayModel implements IScheduledPayoutDisplayModel {
    id?: string;
    accountId?: string;
    accountInvestorId?: string;
    accountInvestorName?: string | undefined;
    accountInvestorFirstName?: string | undefined;
    accountInvestorLastName?: string | undefined;
    sourceTokenId?: string;
    sourceTokenName?: string | undefined;
    sourceTokenSymbol?: string | undefined;
    sourceTokenBalance?: number;
    date?: Date;
    displayDate?: string | undefined;
    payoutTypeId?: number;
    payoutTypeName?: string | undefined;
    payoutTokenId?: string;
    payoutTokenName?: string | undefined;
    payoutTokenSymbol?: string | undefined;
    payoutAmount?: number;
    transactionId?: string | undefined;
    brokerName?: string | undefined;
    accountInvestorBrokerFirstName?: string | undefined;
    accountInvestorBrokerLastName?: string | undefined;

    constructor(data?: IScheduledPayoutDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.accountInvestorId = _data["accountInvestorId"];
            this.accountInvestorName = _data["accountInvestorName"];
            this.accountInvestorFirstName = _data["accountInvestorFirstName"];
            this.accountInvestorLastName = _data["accountInvestorLastName"];
            this.sourceTokenId = _data["sourceTokenId"];
            this.sourceTokenName = _data["sourceTokenName"];
            this.sourceTokenSymbol = _data["sourceTokenSymbol"];
            this.sourceTokenBalance = _data["sourceTokenBalance"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.displayDate = _data["displayDate"];
            this.payoutTypeId = _data["payoutTypeId"];
            this.payoutTypeName = _data["payoutTypeName"];
            this.payoutTokenId = _data["payoutTokenId"];
            this.payoutTokenName = _data["payoutTokenName"];
            this.payoutTokenSymbol = _data["payoutTokenSymbol"];
            this.payoutAmount = _data["payoutAmount"];
            this.transactionId = _data["transactionId"];
            this.brokerName = _data["brokerName"];
            this.accountInvestorBrokerFirstName = _data["accountInvestorBrokerFirstName"];
            this.accountInvestorBrokerLastName = _data["accountInvestorBrokerLastName"];
        }
    }

    static fromJS(data: any): ScheduledPayoutDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledPayoutDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["accountInvestorId"] = this.accountInvestorId;
        data["accountInvestorName"] = this.accountInvestorName;
        data["accountInvestorFirstName"] = this.accountInvestorFirstName;
        data["accountInvestorLastName"] = this.accountInvestorLastName;
        data["sourceTokenId"] = this.sourceTokenId;
        data["sourceTokenName"] = this.sourceTokenName;
        data["sourceTokenSymbol"] = this.sourceTokenSymbol;
        data["sourceTokenBalance"] = this.sourceTokenBalance;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["displayDate"] = this.displayDate;
        data["payoutTypeId"] = this.payoutTypeId;
        data["payoutTypeName"] = this.payoutTypeName;
        data["payoutTokenId"] = this.payoutTokenId;
        data["payoutTokenName"] = this.payoutTokenName;
        data["payoutTokenSymbol"] = this.payoutTokenSymbol;
        data["payoutAmount"] = this.payoutAmount;
        data["transactionId"] = this.transactionId;
        data["brokerName"] = this.brokerName;
        data["accountInvestorBrokerFirstName"] = this.accountInvestorBrokerFirstName;
        data["accountInvestorBrokerLastName"] = this.accountInvestorBrokerLastName;
        return data;
    }
}

export interface IScheduledPayoutDisplayModel {
    id?: string;
    accountId?: string;
    accountInvestorId?: string;
    accountInvestorName?: string | undefined;
    accountInvestorFirstName?: string | undefined;
    accountInvestorLastName?: string | undefined;
    sourceTokenId?: string;
    sourceTokenName?: string | undefined;
    sourceTokenSymbol?: string | undefined;
    sourceTokenBalance?: number;
    date?: Date;
    displayDate?: string | undefined;
    payoutTypeId?: number;
    payoutTypeName?: string | undefined;
    payoutTokenId?: string;
    payoutTokenName?: string | undefined;
    payoutTokenSymbol?: string | undefined;
    payoutAmount?: number;
    transactionId?: string | undefined;
    brokerName?: string | undefined;
    accountInvestorBrokerFirstName?: string | undefined;
    accountInvestorBrokerLastName?: string | undefined;
}

export class ScheduledPayoutDisplayModelPagedResult implements IScheduledPayoutDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ScheduledPayoutDisplayModel | undefined)[] | undefined;

    constructor(data?: IScheduledPayoutDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ScheduledPayoutDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduledPayoutDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledPayoutDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduledPayoutDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ScheduledPayoutDisplayModel | undefined)[] | undefined;
}

export class ScheduledTokenConversionDisplayModel implements IScheduledTokenConversionDisplayModel {
    id?: string;
    sourceTokenName?: string | undefined;
    sourceQty?: number;
    destinationTokenName?: string | undefined;
    destinationQty?: number;
    conversionDate?: Date;
    processedOn?: Date | undefined;

    constructor(data?: IScheduledTokenConversionDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceTokenName = _data["sourceTokenName"];
            this.sourceQty = _data["sourceQty"];
            this.destinationTokenName = _data["destinationTokenName"];
            this.destinationQty = _data["destinationQty"];
            this.conversionDate = _data["conversionDate"] ? new Date(_data["conversionDate"].toString()) : <any>undefined;
            this.processedOn = _data["processedOn"] ? new Date(_data["processedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledTokenConversionDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledTokenConversionDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceTokenName"] = this.sourceTokenName;
        data["sourceQty"] = this.sourceQty;
        data["destinationTokenName"] = this.destinationTokenName;
        data["destinationQty"] = this.destinationQty;
        data["conversionDate"] = this.conversionDate ? this.conversionDate.toISOString() : <any>undefined;
        data["processedOn"] = this.processedOn ? this.processedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduledTokenConversionDisplayModel {
    id?: string;
    sourceTokenName?: string | undefined;
    sourceQty?: number;
    destinationTokenName?: string | undefined;
    destinationQty?: number;
    conversionDate?: Date;
    processedOn?: Date | undefined;
}

export class ScheduledTokenConversionDisplayModelPagedResult implements IScheduledTokenConversionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ScheduledTokenConversionDisplayModel | undefined)[] | undefined;

    constructor(data?: IScheduledTokenConversionDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ScheduledTokenConversionDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduledTokenConversionDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledTokenConversionDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduledTokenConversionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ScheduledTokenConversionDisplayModel | undefined)[] | undefined;
}

export class ScheduledTokenConversionInputModel implements IScheduledTokenConversionInputModel {
    sourceTokenId?: string;
    destinationTokenId?: string;
    sourceQty?: number;
    destinationQty?: number;
    conversionDate?: Date;

    constructor(data?: IScheduledTokenConversionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceTokenId = _data["sourceTokenId"];
            this.destinationTokenId = _data["destinationTokenId"];
            this.sourceQty = _data["sourceQty"];
            this.destinationQty = _data["destinationQty"];
            this.conversionDate = _data["conversionDate"] ? new Date(_data["conversionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledTokenConversionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledTokenConversionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceTokenId"] = this.sourceTokenId;
        data["destinationTokenId"] = this.destinationTokenId;
        data["sourceQty"] = this.sourceQty;
        data["destinationQty"] = this.destinationQty;
        data["conversionDate"] = this.conversionDate ? this.conversionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduledTokenConversionInputModel {
    sourceTokenId?: string;
    destinationTokenId?: string;
    sourceQty?: number;
    destinationQty?: number;
    conversionDate?: Date;
}

export class SecureBlobUrlRequest implements ISecureBlobUrlRequest {
    url?: string | undefined;
    container?: string | undefined;

    constructor(data?: ISecureBlobUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.container = _data["container"];
        }
    }

    static fromJS(data: any): SecureBlobUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecureBlobUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["container"] = this.container;
        return data;
    }
}

export interface ISecureBlobUrlRequest {
    url?: string | undefined;
    container?: string | undefined;
}

export class ShareholderMeetingDisplayModel implements IShareholderMeetingDisplayModel {
    id?: string;
    projectId?: string;
    projectName?: string | undefined;
    projectCoverImageLink?: string | undefined;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenTypeId?: number;
    tokenTypeName?: string | undefined;
    startDate?: Date;
    readonly startDateString?: string | undefined;
    votingCloseDate?: Date;
    statusId?: number;
    statusName?: string | undefined;
    meetingTitle?: string | undefined;

    constructor(data?: IShareholderMeetingDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectCoverImageLink = _data["projectCoverImageLink"];
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenTypeId = _data["tokenTypeId"];
            this.tokenTypeName = _data["tokenTypeName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            (<any>this).startDateString = _data["startDateString"];
            this.votingCloseDate = _data["votingCloseDate"] ? new Date(_data["votingCloseDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.meetingTitle = _data["meetingTitle"];
        }
    }

    static fromJS(data: any): ShareholderMeetingDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectCoverImageLink"] = this.projectCoverImageLink;
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenTypeId"] = this.tokenTypeId;
        data["tokenTypeName"] = this.tokenTypeName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startDateString"] = this.startDateString;
        data["votingCloseDate"] = this.votingCloseDate ? this.votingCloseDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["meetingTitle"] = this.meetingTitle;
        return data;
    }
}

export interface IShareholderMeetingDisplayModel {
    id?: string;
    projectId?: string;
    projectName?: string | undefined;
    projectCoverImageLink?: string | undefined;
    tokenId?: string;
    tokenName?: string | undefined;
    tokenTypeId?: number;
    tokenTypeName?: string | undefined;
    startDate?: Date;
    startDateString?: string | undefined;
    votingCloseDate?: Date;
    statusId?: number;
    statusName?: string | undefined;
    meetingTitle?: string | undefined;
}

export class ShareholderMeetingDisplayModelPagedResult implements IShareholderMeetingDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (ShareholderMeetingDisplayModel | undefined)[] | undefined;

    constructor(data?: IShareholderMeetingDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ShareholderMeetingDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShareholderMeetingDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShareholderMeetingDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (ShareholderMeetingDisplayModel | undefined)[] | undefined;
}

export class ShareholderMeetingDocumentDisplayModel implements IShareholderMeetingDocumentDisplayModel {
    id?: string;
    name?: string | undefined;
    url?: string | undefined;
    displayOrder?: number;

    constructor(data?: IShareholderMeetingDocumentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ShareholderMeetingDocumentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingDocumentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IShareholderMeetingDocumentDisplayModel {
    id?: string;
    name?: string | undefined;
    url?: string | undefined;
    displayOrder?: number;
}

export class ShareholderMeetingDocumentInputModel implements IShareholderMeetingDocumentInputModel {
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: IShareholderMeetingDocumentInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ShareholderMeetingDocumentInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingDocumentInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IShareholderMeetingDocumentInputModel {
    name?: string | undefined;
    url?: string | undefined;
}

export class ShareholderMeetingInputModel implements IShareholderMeetingInputModel {
    projectId?: string;
    tokenId?: string;
    startDate?: Date;
    votingCloseDate?: Date;
    meetingTitle?: string | undefined;

    constructor(data?: IShareholderMeetingInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.tokenId = _data["tokenId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.votingCloseDate = _data["votingCloseDate"] ? new Date(_data["votingCloseDate"].toString()) : <any>undefined;
            this.meetingTitle = _data["meetingTitle"];
        }
    }

    static fromJS(data: any): ShareholderMeetingInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["tokenId"] = this.tokenId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["votingCloseDate"] = this.votingCloseDate ? this.votingCloseDate.toISOString() : <any>undefined;
        data["meetingTitle"] = this.meetingTitle;
        return data;
    }
}

export interface IShareholderMeetingInputModel {
    projectId?: string;
    tokenId?: string;
    startDate?: Date;
    votingCloseDate?: Date;
    meetingTitle?: string | undefined;
}

export class ShareholderMeetingResolutionDisplayModel implements IShareholderMeetingResolutionDisplayModel {
    id?: string;
    chatId?: string | undefined;
    shareholderMeetingId?: string;
    name?: string | undefined;
    description?: string | undefined;
    tokenId?: string;
    tokenEthereumContractAddress?: string | undefined;
    displayOrder?: number;

    constructor(data?: IShareholderMeetingResolutionDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.shareholderMeetingId = _data["shareholderMeetingId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tokenId = _data["tokenId"];
            this.tokenEthereumContractAddress = _data["tokenEthereumContractAddress"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ShareholderMeetingResolutionDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingResolutionDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["shareholderMeetingId"] = this.shareholderMeetingId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tokenId"] = this.tokenId;
        data["tokenEthereumContractAddress"] = this.tokenEthereumContractAddress;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IShareholderMeetingResolutionDisplayModel {
    id?: string;
    chatId?: string | undefined;
    shareholderMeetingId?: string;
    name?: string | undefined;
    description?: string | undefined;
    tokenId?: string;
    tokenEthereumContractAddress?: string | undefined;
    displayOrder?: number;
}

export class ShareholderMeetingResolutionInputModel implements IShareholderMeetingResolutionInputModel {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IShareholderMeetingResolutionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ShareholderMeetingResolutionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderMeetingResolutionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IShareholderMeetingResolutionInputModel {
    name?: string | undefined;
    description?: string | undefined;
}

export class StringLookupModel implements IStringLookupModel {
    id!: string;
    name!: string;

    constructor(data?: IStringLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StringLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new StringLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStringLookupModel {
    id: string;
    name: string;
}

export class SupplierDisplayModel implements ISupplierDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    supplierCode?: string | undefined;
    taxNumber?: string | undefined;

    constructor(data?: ISupplierDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.companyName = _data["companyName"];
            this.supplierCode = _data["supplierCode"];
            this.taxNumber = _data["taxNumber"];
        }
    }

    static fromJS(data: any): SupplierDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        data["supplierCode"] = this.supplierCode;
        data["taxNumber"] = this.taxNumber;
        return data;
    }
}

export interface ISupplierDisplayModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    supplierCode?: string | undefined;
    taxNumber?: string | undefined;
}

export class SupplierDisplayModelPagedResult implements ISupplierDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (SupplierDisplayModel | undefined)[] | undefined;

    constructor(data?: ISupplierDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SupplierDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplierDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (SupplierDisplayModel | undefined)[] | undefined;
}

export class TaskConstraintDisplayModel implements ITaskConstraintDisplayModel {
    id?: string;
    constraintTypeId?: number;
    constraintTypeName?: string | undefined;
    constraintStatusId?: number;
    constraintStatusName?: string | undefined;
    amount?: number;
    specialApproval?: boolean;
    description?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTaskId?: string;
    labourTaskSummary?: string | undefined;
    labourTaskWeekStart?: number;
    labourTaskWeekDue?: number;
    taskPrerequisiteId?: string | undefined;

    constructor(data?: ITaskConstraintDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.constraintTypeId = _data["constraintTypeId"];
            this.constraintTypeName = _data["constraintTypeName"];
            this.constraintStatusId = _data["constraintStatusId"];
            this.constraintStatusName = _data["constraintStatusName"];
            this.amount = _data["amount"];
            this.specialApproval = _data["specialApproval"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.labourTaskId = _data["labourTaskId"];
            this.labourTaskSummary = _data["labourTaskSummary"];
            this.labourTaskWeekStart = _data["labourTaskWeekStart"];
            this.labourTaskWeekDue = _data["labourTaskWeekDue"];
            this.taskPrerequisiteId = _data["taskPrerequisiteId"];
        }
    }

    static fromJS(data: any): TaskConstraintDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConstraintDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constraintTypeId"] = this.constraintTypeId;
        data["constraintTypeName"] = this.constraintTypeName;
        data["constraintStatusId"] = this.constraintStatusId;
        data["constraintStatusName"] = this.constraintStatusName;
        data["amount"] = this.amount;
        data["specialApproval"] = this.specialApproval;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["labourTaskId"] = this.labourTaskId;
        data["labourTaskSummary"] = this.labourTaskSummary;
        data["labourTaskWeekStart"] = this.labourTaskWeekStart;
        data["labourTaskWeekDue"] = this.labourTaskWeekDue;
        data["taskPrerequisiteId"] = this.taskPrerequisiteId;
        return data;
    }
}

export interface ITaskConstraintDisplayModel {
    id?: string;
    constraintTypeId?: number;
    constraintTypeName?: string | undefined;
    constraintStatusId?: number;
    constraintStatusName?: string | undefined;
    amount?: number;
    specialApproval?: boolean;
    description?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTaskId?: string;
    labourTaskSummary?: string | undefined;
    labourTaskWeekStart?: number;
    labourTaskWeekDue?: number;
    taskPrerequisiteId?: string | undefined;
}

export class TaskConstraintInputModel implements ITaskConstraintInputModel {
    constraintTypeId?: number;
    amount?: number | undefined;
    specialApproval?: boolean;
    description?: string | undefined;

    constructor(data?: ITaskConstraintInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constraintTypeId = _data["constraintTypeId"];
            this.amount = _data["amount"];
            this.specialApproval = _data["specialApproval"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaskConstraintInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConstraintInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constraintTypeId"] = this.constraintTypeId;
        data["amount"] = this.amount;
        data["specialApproval"] = this.specialApproval;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaskConstraintInputModel {
    constraintTypeId?: number;
    amount?: number | undefined;
    specialApproval?: boolean;
    description?: string | undefined;
}

export class TaskDisplayModel implements ITaskDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    details?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    chatId?: string | undefined;
    supplierQuoteId?: string | undefined;
    acceptedQuoteId?: string | undefined;
    qualityAssessorId?: string | undefined;
    qualityAssessorUserInvestorAccountName?: string | undefined;
    acceptedQuoteSupplierUserInvestorAccountName?: string | undefined;
    contractId?: string | undefined;
    contractStatusId?: number | undefined;
    cancellationComment?: string | undefined;
    parentTaskId?: string | undefined;
    taskConstraints?: (TaskConstraintDisplayModel | undefined)[] | undefined;
    supplierTaskQuote?: TaskQuoteDisplayModel | undefined;
    taskQuotes?: (TaskQuoteDisplayModel | undefined)[] | undefined;
    acceptedQuote?: QuoteDisplayModel | undefined;
    startWeekDate?: Date | undefined;
    dueWeekDate?: Date | undefined;

    constructor(data?: ITaskDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.taskStatusId = _data["taskStatusId"];
            this.taskStatusName = _data["taskStatusName"];
            this.weekStart = _data["weekStart"];
            this.weekDue = _data["weekDue"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectAddress = _data["projectAddress"];
            this.projectEstimatedStartDate = _data["projectEstimatedStartDate"] ? new Date(_data["projectEstimatedStartDate"].toString()) : <any>undefined;
            this.projectEstimatedEndDate = _data["projectEstimatedEndDate"] ? new Date(_data["projectEstimatedEndDate"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.chatId = _data["chatId"];
            this.supplierQuoteId = _data["supplierQuoteId"];
            this.acceptedQuoteId = _data["acceptedQuoteId"];
            this.qualityAssessorId = _data["qualityAssessorId"];
            this.qualityAssessorUserInvestorAccountName = _data["qualityAssessorUserInvestorAccountName"];
            this.acceptedQuoteSupplierUserInvestorAccountName = _data["acceptedQuoteSupplierUserInvestorAccountName"];
            this.contractId = _data["contractId"];
            this.contractStatusId = _data["contractStatusId"];
            this.cancellationComment = _data["cancellationComment"];
            this.parentTaskId = _data["parentTaskId"];
            if (Array.isArray(_data["taskConstraints"])) {
                this.taskConstraints = [] as any;
                for (let item of _data["taskConstraints"])
                    this.taskConstraints!.push(TaskConstraintDisplayModel.fromJS(item));
            }
            this.supplierTaskQuote = _data["supplierTaskQuote"] ? TaskQuoteDisplayModel.fromJS(_data["supplierTaskQuote"]) : <any>undefined;
            if (Array.isArray(_data["taskQuotes"])) {
                this.taskQuotes = [] as any;
                for (let item of _data["taskQuotes"])
                    this.taskQuotes!.push(TaskQuoteDisplayModel.fromJS(item));
            }
            this.acceptedQuote = _data["acceptedQuote"] ? QuoteDisplayModel.fromJS(_data["acceptedQuote"]) : <any>undefined;
            this.startWeekDate = _data["startWeekDate"] ? new Date(_data["startWeekDate"].toString()) : <any>undefined;
            this.dueWeekDate = _data["dueWeekDate"] ? new Date(_data["dueWeekDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["taskStatusId"] = this.taskStatusId;
        data["taskStatusName"] = this.taskStatusName;
        data["weekStart"] = this.weekStart;
        data["weekDue"] = this.weekDue;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectAddress"] = this.projectAddress;
        data["projectEstimatedStartDate"] = this.projectEstimatedStartDate ? this.projectEstimatedStartDate.toISOString() : <any>undefined;
        data["projectEstimatedEndDate"] = this.projectEstimatedEndDate ? this.projectEstimatedEndDate.toISOString() : <any>undefined;
        data["details"] = this.details;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["chatId"] = this.chatId;
        data["supplierQuoteId"] = this.supplierQuoteId;
        data["acceptedQuoteId"] = this.acceptedQuoteId;
        data["qualityAssessorId"] = this.qualityAssessorId;
        data["qualityAssessorUserInvestorAccountName"] = this.qualityAssessorUserInvestorAccountName;
        data["acceptedQuoteSupplierUserInvestorAccountName"] = this.acceptedQuoteSupplierUserInvestorAccountName;
        data["contractId"] = this.contractId;
        data["contractStatusId"] = this.contractStatusId;
        data["cancellationComment"] = this.cancellationComment;
        data["parentTaskId"] = this.parentTaskId;
        if (Array.isArray(this.taskConstraints)) {
            data["taskConstraints"] = [];
            for (let item of this.taskConstraints)
                data["taskConstraints"].push(item.toJSON());
        }
        data["supplierTaskQuote"] = this.supplierTaskQuote ? this.supplierTaskQuote.toJSON() : <any>undefined;
        if (Array.isArray(this.taskQuotes)) {
            data["taskQuotes"] = [];
            for (let item of this.taskQuotes)
                data["taskQuotes"].push(item.toJSON());
        }
        data["acceptedQuote"] = this.acceptedQuote ? this.acceptedQuote.toJSON() : <any>undefined;
        data["startWeekDate"] = this.startWeekDate ? this.startWeekDate.toISOString() : <any>undefined;
        data["dueWeekDate"] = this.dueWeekDate ? this.dueWeekDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITaskDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    details?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    chatId?: string | undefined;
    supplierQuoteId?: string | undefined;
    acceptedQuoteId?: string | undefined;
    qualityAssessorId?: string | undefined;
    qualityAssessorUserInvestorAccountName?: string | undefined;
    acceptedQuoteSupplierUserInvestorAccountName?: string | undefined;
    contractId?: string | undefined;
    contractStatusId?: number | undefined;
    cancellationComment?: string | undefined;
    parentTaskId?: string | undefined;
    taskConstraints?: (TaskConstraintDisplayModel | undefined)[] | undefined;
    supplierTaskQuote?: TaskQuoteDisplayModel | undefined;
    taskQuotes?: (TaskQuoteDisplayModel | undefined)[] | undefined;
    acceptedQuote?: QuoteDisplayModel | undefined;
    startWeekDate?: Date | undefined;
    dueWeekDate?: Date | undefined;
}

export class TaskDocumentDisplayModel implements ITaskDocumentDisplayModel {
    id?: string;
    labourTaskId?: string;
    projectDocumentId?: string | undefined;
    name?: string | undefined;
    labourTaskSummary?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITaskDocumentDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.labourTaskId = _data["labourTaskId"];
            this.projectDocumentId = _data["projectDocumentId"];
            this.name = _data["name"];
            this.labourTaskSummary = _data["labourTaskSummary"];
            this.description = _data["description"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TaskDocumentDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDocumentDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["labourTaskId"] = this.labourTaskId;
        data["projectDocumentId"] = this.projectDocumentId;
        data["name"] = this.name;
        data["labourTaskSummary"] = this.labourTaskSummary;
        data["description"] = this.description;
        data["url"] = this.url;
        return data;
    }
}

export interface ITaskDocumentDisplayModel {
    id?: string;
    labourTaskId?: string;
    projectDocumentId?: string | undefined;
    name?: string | undefined;
    labourTaskSummary?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
}

export class TaskDocumentImportInputModel implements ITaskDocumentImportInputModel {
    labourTaskIds?: string[] | undefined;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITaskDocumentImportInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labourTaskIds"])) {
                this.labourTaskIds = [] as any;
                for (let item of _data["labourTaskIds"])
                    this.labourTaskIds!.push(item);
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TaskDocumentImportInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDocumentImportInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labourTaskIds)) {
            data["labourTaskIds"] = [];
            for (let item of this.labourTaskIds)
                data["labourTaskIds"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        return data;
    }
}

export interface ITaskDocumentImportInputModel {
    labourTaskIds?: string[] | undefined;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
}

export class TaskDocumentProjectInputModel implements ITaskDocumentProjectInputModel {
    labourTaskIds?: string[] | undefined;
    projectDocumentIds?: string[] | undefined;

    constructor(data?: ITaskDocumentProjectInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labourTaskIds"])) {
                this.labourTaskIds = [] as any;
                for (let item of _data["labourTaskIds"])
                    this.labourTaskIds!.push(item);
            }
            if (Array.isArray(_data["projectDocumentIds"])) {
                this.projectDocumentIds = [] as any;
                for (let item of _data["projectDocumentIds"])
                    this.projectDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskDocumentProjectInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDocumentProjectInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labourTaskIds)) {
            data["labourTaskIds"] = [];
            for (let item of this.labourTaskIds)
                data["labourTaskIds"].push(item);
        }
        if (Array.isArray(this.projectDocumentIds)) {
            data["projectDocumentIds"] = [];
            for (let item of this.projectDocumentIds)
                data["projectDocumentIds"].push(item);
        }
        return data;
    }
}

export interface ITaskDocumentProjectInputModel {
    labourTaskIds?: string[] | undefined;
    projectDocumentIds?: string[] | undefined;
}

export class TaskListDisplayModel implements ITaskListDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    details?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    supplierQuoteId?: string | undefined;
    acceptedQuoteId?: string | undefined;
    qualityAssessorId?: string | undefined;
    qualityAssessorUserInvestorAccountName?: string | undefined;
    acceptedQuoteSupplierUserInvestorAccountName?: string | undefined;

    constructor(data?: ITaskListDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.taskStatusId = _data["taskStatusId"];
            this.taskStatusName = _data["taskStatusName"];
            this.weekStart = _data["weekStart"];
            this.weekDue = _data["weekDue"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectAddress = _data["projectAddress"];
            this.projectEstimatedStartDate = _data["projectEstimatedStartDate"] ? new Date(_data["projectEstimatedStartDate"].toString()) : <any>undefined;
            this.projectEstimatedEndDate = _data["projectEstimatedEndDate"] ? new Date(_data["projectEstimatedEndDate"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.supplierQuoteId = _data["supplierQuoteId"];
            this.acceptedQuoteId = _data["acceptedQuoteId"];
            this.qualityAssessorId = _data["qualityAssessorId"];
            this.qualityAssessorUserInvestorAccountName = _data["qualityAssessorUserInvestorAccountName"];
            this.acceptedQuoteSupplierUserInvestorAccountName = _data["acceptedQuoteSupplierUserInvestorAccountName"];
        }
    }

    static fromJS(data: any): TaskListDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["taskStatusId"] = this.taskStatusId;
        data["taskStatusName"] = this.taskStatusName;
        data["weekStart"] = this.weekStart;
        data["weekDue"] = this.weekDue;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectAddress"] = this.projectAddress;
        data["projectEstimatedStartDate"] = this.projectEstimatedStartDate ? this.projectEstimatedStartDate.toISOString() : <any>undefined;
        data["projectEstimatedEndDate"] = this.projectEstimatedEndDate ? this.projectEstimatedEndDate.toISOString() : <any>undefined;
        data["details"] = this.details;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["supplierQuoteId"] = this.supplierQuoteId;
        data["acceptedQuoteId"] = this.acceptedQuoteId;
        data["qualityAssessorId"] = this.qualityAssessorId;
        data["qualityAssessorUserInvestorAccountName"] = this.qualityAssessorUserInvestorAccountName;
        data["acceptedQuoteSupplierUserInvestorAccountName"] = this.acceptedQuoteSupplierUserInvestorAccountName;
        return data;
    }
}

export interface ITaskListDisplayModel {
    id?: string;
    summary?: string | undefined;
    taskStatusId?: number;
    taskStatusName?: string | undefined;
    weekStart?: number;
    weekDue?: number;
    projectId?: string;
    projectName?: string | undefined;
    projectAddress?: string | undefined;
    projectEstimatedStartDate?: Date | undefined;
    projectEstimatedEndDate?: Date | undefined;
    details?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    supplierQuoteId?: string | undefined;
    acceptedQuoteId?: string | undefined;
    qualityAssessorId?: string | undefined;
    qualityAssessorUserInvestorAccountName?: string | undefined;
    acceptedQuoteSupplierUserInvestorAccountName?: string | undefined;
}

export class TaskListDisplayModelPagedResult implements ITaskListDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (TaskListDisplayModel | undefined)[] | undefined;

    constructor(data?: ITaskListDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TaskListDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskListDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskListDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (TaskListDisplayModel | undefined)[] | undefined;
}

export class TaskPrerequisiteDisplayModel implements ITaskPrerequisiteDisplayModel {
    id?: string;
    successCriteriaId?: string;
    successCriteria?: TaskConstraintDisplayModel | undefined;
    prerequisiteId?: string;
    prerequisite?: TaskConstraintDisplayModel | undefined;

    constructor(data?: ITaskPrerequisiteDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.successCriteriaId = _data["successCriteriaId"];
            this.successCriteria = _data["successCriteria"] ? TaskConstraintDisplayModel.fromJS(_data["successCriteria"]) : <any>undefined;
            this.prerequisiteId = _data["prerequisiteId"];
            this.prerequisite = _data["prerequisite"] ? TaskConstraintDisplayModel.fromJS(_data["prerequisite"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskPrerequisiteDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskPrerequisiteDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["successCriteriaId"] = this.successCriteriaId;
        data["successCriteria"] = this.successCriteria ? this.successCriteria.toJSON() : <any>undefined;
        data["prerequisiteId"] = this.prerequisiteId;
        data["prerequisite"] = this.prerequisite ? this.prerequisite.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskPrerequisiteDisplayModel {
    id?: string;
    successCriteriaId?: string;
    successCriteria?: TaskConstraintDisplayModel | undefined;
    prerequisiteId?: string;
    prerequisite?: TaskConstraintDisplayModel | undefined;
}

export class TaskPrerequisiteInputModel implements ITaskPrerequisiteInputModel {
    successCriteriaId?: string;
    prerequisiteId?: string;

    constructor(data?: ITaskPrerequisiteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCriteriaId = _data["successCriteriaId"];
            this.prerequisiteId = _data["prerequisiteId"];
        }
    }

    static fromJS(data: any): TaskPrerequisiteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskPrerequisiteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCriteriaId"] = this.successCriteriaId;
        data["prerequisiteId"] = this.prerequisiteId;
        return data;
    }
}

export interface ITaskPrerequisiteInputModel {
    successCriteriaId?: string;
    prerequisiteId?: string;
}

export class TaskQuoteDisplayModel implements ITaskQuoteDisplayModel {
    id?: string;
    labourTaskId?: string;
    quoteId?: string;
    quoteQuoteStatusId?: number;
    quoteQuoteStatusName?: string | undefined;
    labourTaskSummary?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    amount?: number | undefined;
    staffRequired?: string | undefined;
    duration?: string | undefined;
    comments?: string | undefined;
    labourTaskProjectId?: string;
    labourTaskProjectName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTask?: TaskDisplayModel | undefined;

    constructor(data?: ITaskQuoteDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.labourTaskId = _data["labourTaskId"];
            this.quoteId = _data["quoteId"];
            this.quoteQuoteStatusId = _data["quoteQuoteStatusId"];
            this.quoteQuoteStatusName = _data["quoteQuoteStatusName"];
            this.labourTaskSummary = _data["labourTaskSummary"];
            this.supplierId = _data["supplierId"];
            this.supplierCode = _data["supplierCode"];
            this.supplierUserInvestorAccountName = _data["supplierUserInvestorAccountName"];
            this.supplierUserEmailAddress = _data["supplierUserEmailAddress"];
            this.supplierUserFirstName = _data["supplierUserFirstName"];
            this.supplierUserLastName = _data["supplierUserLastName"];
            this.amount = _data["amount"];
            this.staffRequired = _data["staffRequired"];
            this.duration = _data["duration"];
            this.comments = _data["comments"];
            this.labourTaskProjectId = _data["labourTaskProjectId"];
            this.labourTaskProjectName = _data["labourTaskProjectName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.labourTask = _data["labourTask"] ? TaskDisplayModel.fromJS(_data["labourTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskQuoteDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuoteDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["labourTaskId"] = this.labourTaskId;
        data["quoteId"] = this.quoteId;
        data["quoteQuoteStatusId"] = this.quoteQuoteStatusId;
        data["quoteQuoteStatusName"] = this.quoteQuoteStatusName;
        data["labourTaskSummary"] = this.labourTaskSummary;
        data["supplierId"] = this.supplierId;
        data["supplierCode"] = this.supplierCode;
        data["supplierUserInvestorAccountName"] = this.supplierUserInvestorAccountName;
        data["supplierUserEmailAddress"] = this.supplierUserEmailAddress;
        data["supplierUserFirstName"] = this.supplierUserFirstName;
        data["supplierUserLastName"] = this.supplierUserLastName;
        data["amount"] = this.amount;
        data["staffRequired"] = this.staffRequired;
        data["duration"] = this.duration;
        data["comments"] = this.comments;
        data["labourTaskProjectId"] = this.labourTaskProjectId;
        data["labourTaskProjectName"] = this.labourTaskProjectName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["labourTask"] = this.labourTask ? this.labourTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskQuoteDisplayModel {
    id?: string;
    labourTaskId?: string;
    quoteId?: string;
    quoteQuoteStatusId?: number;
    quoteQuoteStatusName?: string | undefined;
    labourTaskSummary?: string | undefined;
    supplierId?: string;
    supplierCode?: string | undefined;
    supplierUserInvestorAccountName?: string | undefined;
    supplierUserEmailAddress?: string | undefined;
    supplierUserFirstName?: string | undefined;
    supplierUserLastName?: string | undefined;
    amount?: number | undefined;
    staffRequired?: string | undefined;
    duration?: string | undefined;
    comments?: string | undefined;
    labourTaskProjectId?: string;
    labourTaskProjectName?: string | undefined;
    createdOn?: Date;
    lastUpdated?: Date;
    labourTask?: TaskDisplayModel | undefined;
}

export class TaskQuoteDisplayModelPagedResult implements ITaskQuoteDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (TaskQuoteDisplayModel | undefined)[] | undefined;

    constructor(data?: ITaskQuoteDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TaskQuoteDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskQuoteDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuoteDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskQuoteDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (TaskQuoteDisplayModel | undefined)[] | undefined;
}

export class TaskQuoteInputModel implements ITaskQuoteInputModel {
    labourTaskId?: string;
    supplierId?: string;
    amount?: number | undefined;
    staffRequired?: string | undefined;
    duration?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ITaskQuoteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labourTaskId = _data["labourTaskId"];
            this.supplierId = _data["supplierId"];
            this.amount = _data["amount"];
            this.staffRequired = _data["staffRequired"];
            this.duration = _data["duration"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): TaskQuoteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuoteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labourTaskId"] = this.labourTaskId;
        data["supplierId"] = this.supplierId;
        data["amount"] = this.amount;
        data["staffRequired"] = this.staffRequired;
        data["duration"] = this.duration;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ITaskQuoteInputModel {
    labourTaskId?: string;
    supplierId?: string;
    amount?: number | undefined;
    staffRequired?: string | undefined;
    duration?: string | undefined;
    comments?: string | undefined;
}

export class TermsToAcceptDisplayModel implements ITermsToAcceptDisplayModel {
    id?: string;
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITermsToAcceptDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TermsToAcceptDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TermsToAcceptDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface ITermsToAcceptDisplayModel {
    id?: string;
    name?: string | undefined;
    url?: string | undefined;
}

export class TokenActionsModel implements ITokenActionsModel {
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    tokenBackingPledgeId?: string | undefined;
    tokenBackingPledgeName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    payoutTokenId?: string | undefined;
    payoutTokenName?: string | undefined;
    conversionTokenId?: string | undefined;
    conversionTokenName?: string | undefined;
    tokenCanReinvestInterest?: boolean;
    isReinvestingInterest?: boolean;
    products?: (ProductDisplayModel | undefined)[] | undefined;

    constructor(data?: ITokenActionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.tokenTokenTypeId = _data["tokenTokenTypeId"];
            this.tokenTokenTypeName = _data["tokenTokenTypeName"];
            this.tokenProjectId = _data["tokenProjectId"];
            this.tokenProjectName = _data["tokenProjectName"];
            this.tokenBackingPledgeId = _data["tokenBackingPledgeId"];
            this.tokenBackingPledgeName = _data["tokenBackingPledgeName"];
            this.balance = _data["balance"];
            this.currentValue = _data["currentValue"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.currentOutstandingValue = _data["currentOutstandingValue"];
            this.payoutTokenId = _data["payoutTokenId"];
            this.payoutTokenName = _data["payoutTokenName"];
            this.conversionTokenId = _data["conversionTokenId"];
            this.conversionTokenName = _data["conversionTokenName"];
            this.tokenCanReinvestInterest = _data["tokenCanReinvestInterest"];
            this.isReinvestingInterest = _data["isReinvestingInterest"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TokenActionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenActionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["tokenTokenTypeId"] = this.tokenTokenTypeId;
        data["tokenTokenTypeName"] = this.tokenTokenTypeName;
        data["tokenProjectId"] = this.tokenProjectId;
        data["tokenProjectName"] = this.tokenProjectName;
        data["tokenBackingPledgeId"] = this.tokenBackingPledgeId;
        data["tokenBackingPledgeName"] = this.tokenBackingPledgeName;
        data["balance"] = this.balance;
        data["currentValue"] = this.currentValue;
        data["outstandingBalance"] = this.outstandingBalance;
        data["currentOutstandingValue"] = this.currentOutstandingValue;
        data["payoutTokenId"] = this.payoutTokenId;
        data["payoutTokenName"] = this.payoutTokenName;
        data["conversionTokenId"] = this.conversionTokenId;
        data["conversionTokenName"] = this.conversionTokenName;
        data["tokenCanReinvestInterest"] = this.tokenCanReinvestInterest;
        data["isReinvestingInterest"] = this.isReinvestingInterest;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITokenActionsModel {
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    tokenTokenTypeId?: number;
    tokenTokenTypeName?: string | undefined;
    tokenProjectId?: string | undefined;
    tokenProjectName?: string | undefined;
    tokenBackingPledgeId?: string | undefined;
    tokenBackingPledgeName?: string | undefined;
    balance?: number;
    currentValue?: number;
    outstandingBalance?: number;
    currentOutstandingValue?: number;
    payoutTokenId?: string | undefined;
    payoutTokenName?: string | undefined;
    conversionTokenId?: string | undefined;
    conversionTokenName?: string | undefined;
    tokenCanReinvestInterest?: boolean;
    isReinvestingInterest?: boolean;
    products?: (ProductDisplayModel | undefined)[] | undefined;
}

export class TokenBalanceDisplayModel implements ITokenBalanceDisplayModel {
    token?: TokenDisplayModel | undefined;
    balance?: number;

    constructor(data?: ITokenBalanceDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? TokenDisplayModel.fromJS(_data["token"]) : <any>undefined;
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): TokenBalanceDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenBalanceDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        data["balance"] = this.balance;
        return data;
    }
}

export interface ITokenBalanceDisplayModel {
    token?: TokenDisplayModel | undefined;
    balance?: number;
}

export class TokenDisplayModel implements ITokenDisplayModel {
    id?: string;
    tokenTypeId?: number;
    tokenTypeName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    contractDocumentUrl?: string | undefined;
    commencementDate?: Date | undefined;
    expiryDate?: Date | undefined;
    ethereumContractAddress?: string | undefined;
    decimals?: number;
    interestRate?: number | undefined;
    paymentFrequencyId?: number | undefined;
    paymentFrequencyName?: string | undefined;
    canReinvestInterest?: boolean;
    payoutTokenId?: string | undefined;
    payoutTokenSymbol?: string | undefined;
    payoutTokenDecimals?: number | undefined;
    payoutTokenName?: string | undefined;
    isPrivate?: boolean;
    backingPledgeId?: string | undefined;
    backingPledgeDescription?: string | undefined;
    backingPledgeAccountId?: string | undefined;
    strikePrice?: string | undefined;
    initialValue?: number | undefined;
    finalValue?: number | undefined;
    currentFaceValue?: number | undefined;
    compoundingPeriod?: number | undefined;
    financialMonths?: number | undefined;
    appraisedCapitalValue?: number | undefined;
    offChainLoanValue?: number | undefined;
    aggregatorTokenTypeId?: number | undefined;
    aggregatorTokenId?: string | undefined;
    aggregatorTokenName?: string | undefined;
    tokenTypeIsERC20?: boolean;
    tokenTypeIsFaceValue?: boolean;
    currentValue?: TokenValue | undefined;
    readonly tokenValueCurrentValue?: number;
    readonly tokenValueCurrentDate?: Date;
    isTradeable?: boolean;
    isDeployedToBlockChain?: boolean;
    isLoanToValueAggregator?: boolean;

    constructor(data?: ITokenDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenTypeId = _data["tokenTypeId"];
            this.tokenTypeName = _data["tokenTypeName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.contractDocumentUrl = _data["contractDocumentUrl"];
            this.commencementDate = _data["commencementDate"] ? new Date(_data["commencementDate"].toString()) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.ethereumContractAddress = _data["ethereumContractAddress"];
            this.decimals = _data["decimals"];
            this.interestRate = _data["interestRate"];
            this.paymentFrequencyId = _data["paymentFrequencyId"];
            this.paymentFrequencyName = _data["paymentFrequencyName"];
            this.canReinvestInterest = _data["canReinvestInterest"];
            this.payoutTokenId = _data["payoutTokenId"];
            this.payoutTokenSymbol = _data["payoutTokenSymbol"];
            this.payoutTokenDecimals = _data["payoutTokenDecimals"];
            this.payoutTokenName = _data["payoutTokenName"];
            this.isPrivate = _data["isPrivate"];
            this.backingPledgeId = _data["backingPledgeId"];
            this.backingPledgeDescription = _data["backingPledgeDescription"];
            this.backingPledgeAccountId = _data["backingPledgeAccountId"];
            this.strikePrice = _data["strikePrice"];
            this.initialValue = _data["initialValue"];
            this.finalValue = _data["finalValue"];
            this.currentFaceValue = _data["currentFaceValue"];
            this.compoundingPeriod = _data["compoundingPeriod"];
            this.financialMonths = _data["financialMonths"];
            this.appraisedCapitalValue = _data["appraisedCapitalValue"];
            this.offChainLoanValue = _data["offChainLoanValue"];
            this.aggregatorTokenTypeId = _data["aggregatorTokenTypeId"];
            this.aggregatorTokenId = _data["aggregatorTokenId"];
            this.aggregatorTokenName = _data["aggregatorTokenName"];
            this.tokenTypeIsERC20 = _data["tokenTypeIsERC20"];
            this.tokenTypeIsFaceValue = _data["tokenTypeIsFaceValue"];
            this.currentValue = _data["currentValue"] ? TokenValue.fromJS(_data["currentValue"]) : <any>undefined;
            (<any>this).tokenValueCurrentValue = _data["tokenValueCurrentValue"];
            (<any>this).tokenValueCurrentDate = _data["tokenValueCurrentDate"] ? new Date(_data["tokenValueCurrentDate"].toString()) : <any>undefined;
            this.isTradeable = _data["isTradeable"];
            this.isDeployedToBlockChain = _data["isDeployedToBlockChain"];
            this.isLoanToValueAggregator = _data["isLoanToValueAggregator"];
        }
    }

    static fromJS(data: any): TokenDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenTypeId"] = this.tokenTypeId;
        data["tokenTypeName"] = this.tokenTypeName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["contractDocumentUrl"] = this.contractDocumentUrl;
        data["commencementDate"] = this.commencementDate ? this.commencementDate.toISOString() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["ethereumContractAddress"] = this.ethereumContractAddress;
        data["decimals"] = this.decimals;
        data["interestRate"] = this.interestRate;
        data["paymentFrequencyId"] = this.paymentFrequencyId;
        data["paymentFrequencyName"] = this.paymentFrequencyName;
        data["canReinvestInterest"] = this.canReinvestInterest;
        data["payoutTokenId"] = this.payoutTokenId;
        data["payoutTokenSymbol"] = this.payoutTokenSymbol;
        data["payoutTokenDecimals"] = this.payoutTokenDecimals;
        data["payoutTokenName"] = this.payoutTokenName;
        data["isPrivate"] = this.isPrivate;
        data["backingPledgeId"] = this.backingPledgeId;
        data["backingPledgeDescription"] = this.backingPledgeDescription;
        data["backingPledgeAccountId"] = this.backingPledgeAccountId;
        data["strikePrice"] = this.strikePrice;
        data["initialValue"] = this.initialValue;
        data["finalValue"] = this.finalValue;
        data["currentFaceValue"] = this.currentFaceValue;
        data["compoundingPeriod"] = this.compoundingPeriod;
        data["financialMonths"] = this.financialMonths;
        data["appraisedCapitalValue"] = this.appraisedCapitalValue;
        data["offChainLoanValue"] = this.offChainLoanValue;
        data["aggregatorTokenTypeId"] = this.aggregatorTokenTypeId;
        data["aggregatorTokenId"] = this.aggregatorTokenId;
        data["aggregatorTokenName"] = this.aggregatorTokenName;
        data["tokenTypeIsERC20"] = this.tokenTypeIsERC20;
        data["tokenTypeIsFaceValue"] = this.tokenTypeIsFaceValue;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>undefined;
        data["tokenValueCurrentValue"] = this.tokenValueCurrentValue;
        data["tokenValueCurrentDate"] = this.tokenValueCurrentDate ? this.tokenValueCurrentDate.toISOString() : <any>undefined;
        data["isTradeable"] = this.isTradeable;
        data["isDeployedToBlockChain"] = this.isDeployedToBlockChain;
        data["isLoanToValueAggregator"] = this.isLoanToValueAggregator;
        return data;
    }
}

export interface ITokenDisplayModel {
    id?: string;
    tokenTypeId?: number;
    tokenTypeName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    contractDocumentUrl?: string | undefined;
    commencementDate?: Date | undefined;
    expiryDate?: Date | undefined;
    ethereumContractAddress?: string | undefined;
    decimals?: number;
    interestRate?: number | undefined;
    paymentFrequencyId?: number | undefined;
    paymentFrequencyName?: string | undefined;
    canReinvestInterest?: boolean;
    payoutTokenId?: string | undefined;
    payoutTokenSymbol?: string | undefined;
    payoutTokenDecimals?: number | undefined;
    payoutTokenName?: string | undefined;
    isPrivate?: boolean;
    backingPledgeId?: string | undefined;
    backingPledgeDescription?: string | undefined;
    backingPledgeAccountId?: string | undefined;
    strikePrice?: string | undefined;
    initialValue?: number | undefined;
    finalValue?: number | undefined;
    currentFaceValue?: number | undefined;
    compoundingPeriod?: number | undefined;
    financialMonths?: number | undefined;
    appraisedCapitalValue?: number | undefined;
    offChainLoanValue?: number | undefined;
    aggregatorTokenTypeId?: number | undefined;
    aggregatorTokenId?: string | undefined;
    aggregatorTokenName?: string | undefined;
    tokenTypeIsERC20?: boolean;
    tokenTypeIsFaceValue?: boolean;
    currentValue?: TokenValue | undefined;
    tokenValueCurrentValue?: number;
    tokenValueCurrentDate?: Date;
    isTradeable?: boolean;
    isDeployedToBlockChain?: boolean;
    isLoanToValueAggregator?: boolean;
}

export class TokenDisplayModelPagedResult implements ITokenDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (TokenDisplayModel | undefined)[] | undefined;

    constructor(data?: ITokenDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TokenDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TokenDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITokenDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (TokenDisplayModel | undefined)[] | undefined;
}

export class TokenInputModel implements ITokenInputModel {
    tokenTypeId?: number;
    projectId?: string | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    decimals?: number;
    contractDocumentUrl?: string | undefined;
    commencementDate?: Date | undefined;
    expiryDate?: Date | undefined;
    interestRate?: number | undefined;
    paymentFrequencyId?: number | undefined;
    canReinvestInterest?: boolean;
    payoutTokenId?: string | undefined;
    backingPledgeId?: string | undefined;
    strikePrice?: string | undefined;
    initialValue?: number | undefined;
    compoundingPeriod?: number | undefined;
    financialMonths?: number | undefined;
    appraisedCapitalValue?: number | undefined;
    offChainLoanValue?: number | undefined;
    aggregatorTokenTypeId?: number | undefined;
    aggregatorTokenId?: string | undefined;

    constructor(data?: ITokenInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenTypeId = _data["tokenTypeId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.decimals = _data["decimals"];
            this.contractDocumentUrl = _data["contractDocumentUrl"];
            this.commencementDate = _data["commencementDate"] ? new Date(_data["commencementDate"].toString()) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.interestRate = _data["interestRate"];
            this.paymentFrequencyId = _data["paymentFrequencyId"];
            this.canReinvestInterest = _data["canReinvestInterest"];
            this.payoutTokenId = _data["payoutTokenId"];
            this.backingPledgeId = _data["backingPledgeId"];
            this.strikePrice = _data["strikePrice"];
            this.initialValue = _data["initialValue"];
            this.compoundingPeriod = _data["compoundingPeriod"];
            this.financialMonths = _data["financialMonths"];
            this.appraisedCapitalValue = _data["appraisedCapitalValue"];
            this.offChainLoanValue = _data["offChainLoanValue"];
            this.aggregatorTokenTypeId = _data["aggregatorTokenTypeId"];
            this.aggregatorTokenId = _data["aggregatorTokenId"];
        }
    }

    static fromJS(data: any): TokenInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenTypeId"] = this.tokenTypeId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["decimals"] = this.decimals;
        data["contractDocumentUrl"] = this.contractDocumentUrl;
        data["commencementDate"] = this.commencementDate ? this.commencementDate.toISOString() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["interestRate"] = this.interestRate;
        data["paymentFrequencyId"] = this.paymentFrequencyId;
        data["canReinvestInterest"] = this.canReinvestInterest;
        data["payoutTokenId"] = this.payoutTokenId;
        data["backingPledgeId"] = this.backingPledgeId;
        data["strikePrice"] = this.strikePrice;
        data["initialValue"] = this.initialValue;
        data["compoundingPeriod"] = this.compoundingPeriod;
        data["financialMonths"] = this.financialMonths;
        data["appraisedCapitalValue"] = this.appraisedCapitalValue;
        data["offChainLoanValue"] = this.offChainLoanValue;
        data["aggregatorTokenTypeId"] = this.aggregatorTokenTypeId;
        data["aggregatorTokenId"] = this.aggregatorTokenId;
        return data;
    }
}

export interface ITokenInputModel {
    tokenTypeId?: number;
    projectId?: string | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    decimals?: number;
    contractDocumentUrl?: string | undefined;
    commencementDate?: Date | undefined;
    expiryDate?: Date | undefined;
    interestRate?: number | undefined;
    paymentFrequencyId?: number | undefined;
    canReinvestInterest?: boolean;
    payoutTokenId?: string | undefined;
    backingPledgeId?: string | undefined;
    strikePrice?: string | undefined;
    initialValue?: number | undefined;
    compoundingPeriod?: number | undefined;
    financialMonths?: number | undefined;
    appraisedCapitalValue?: number | undefined;
    offChainLoanValue?: number | undefined;
    aggregatorTokenTypeId?: number | undefined;
    aggregatorTokenId?: string | undefined;
}

export class TokenSelectionModel implements ITokenSelectionModel {
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    exchangeRate?: number;
    balance?: number;

    constructor(data?: ITokenSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.exchangeRate = _data["exchangeRate"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): TokenSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["exchangeRate"] = this.exchangeRate;
        data["balance"] = this.balance;
        return data;
    }
}

export interface ITokenSelectionModel {
    tokenId?: string;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    exchangeRate?: number;
    balance?: number;
}

export class TokenType implements ITokenType {
    id?: number;
    name?: string | undefined;
    burnOnRedemption?: boolean;
    isERC20?: boolean;
    isFaceValue?: boolean;

    constructor(data?: ITokenType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.burnOnRedemption = _data["burnOnRedemption"];
            this.isERC20 = _data["isERC20"];
            this.isFaceValue = _data["isFaceValue"];
        }
    }

    static fromJS(data: any): TokenType {
        data = typeof data === 'object' ? data : {};
        let result = new TokenType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["burnOnRedemption"] = this.burnOnRedemption;
        data["isERC20"] = this.isERC20;
        data["isFaceValue"] = this.isFaceValue;
        return data;
    }
}

export interface ITokenType {
    id?: number;
    name?: string | undefined;
    burnOnRedemption?: boolean;
    isERC20?: boolean;
    isFaceValue?: boolean;
}

export class TokenValue implements ITokenValue {
    id?: string;
    isDeleted?: boolean;
    tokenId?: string;
    effectiveDate?: Date;
    value?: number;

    constructor(data?: ITokenValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.tokenId = _data["tokenId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TokenValue {
        data = typeof data === 'object' ? data : {};
        let result = new TokenValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["tokenId"] = this.tokenId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ITokenValue {
    id?: string;
    isDeleted?: boolean;
    tokenId?: string;
    effectiveDate?: Date;
    value?: number;
}

export class TokenValueDisplayModel implements ITokenValueDisplayModel {
    id?: string;
    effectiveDate?: Date;
    value?: number;

    constructor(data?: ITokenValueDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TokenValueDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenValueDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ITokenValueDisplayModel {
    id?: string;
    effectiveDate?: Date;
    value?: number;
}

export class TokenValueInputModel implements ITokenValueInputModel {
    effectiveDate?: Date;
    value?: number;

    constructor(data?: ITokenValueInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TokenValueInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenValueInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ITokenValueInputModel {
    effectiveDate?: Date;
    value?: number;
}

export class TotpLinkDisplayModel implements ITotpLinkDisplayModel {
    totpLink?: string | undefined;
    hasPreviousTotpSeed?: boolean;
    code?: string | undefined;

    constructor(data?: ITotpLinkDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totpLink = _data["totpLink"];
            this.hasPreviousTotpSeed = _data["hasPreviousTotpSeed"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): TotpLinkDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotpLinkDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totpLink"] = this.totpLink;
        data["hasPreviousTotpSeed"] = this.hasPreviousTotpSeed;
        data["code"] = this.code;
        return data;
    }
}

export interface ITotpLinkDisplayModel {
    totpLink?: string | undefined;
    hasPreviousTotpSeed?: boolean;
    code?: string | undefined;
}

export class TransactionDisplayModel implements ITransactionDisplayModel {
    id?: string;
    effectiveDate?: Date;
    debitAccountId?: string;
    debitAccountInvestorId?: string | undefined;
    debitAccountName?: string | undefined;
    debitAccountInvestorCompanyName?: string | undefined;
    debitAccountInvestorUserFirstName?: string | undefined;
    debitAccountInvestorUserLastName?: string | undefined;
    creditAccountId?: string;
    creditAccountInvestorId?: string | undefined;
    creditAccountName?: string | undefined;
    creditAccountInvestorCompanyName?: string | undefined;
    creditAccountInvestorUserFirstName?: string | undefined;
    creditAccountInvestorUserLastName?: string | undefined;
    amount?: number;
    purchaseId?: string;
    transactionTypeId?: number;
    transactionTypeName?: string | undefined;
    transactionStatusId?: number;
    transactionStatusName?: string | undefined;
    transactionStatusIsOutstandingForClient?: boolean;
    transactionStatusIsOutstandingForSystem?: boolean;
    readonly transactionStatusIsOutstanding?: boolean;
    readonly transactionOutstandingMessage?: string | undefined;
    transactionSourceId?: number;
    transactionSourceName?: string | undefined;
    hasBeenSynced?: boolean;
    ethereumTransactionHash?: string | undefined;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    description?: string | undefined;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;

    constructor(data?: ITransactionDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.debitAccountId = _data["debitAccountId"];
            this.debitAccountInvestorId = _data["debitAccountInvestorId"];
            this.debitAccountName = _data["debitAccountName"];
            this.debitAccountInvestorCompanyName = _data["debitAccountInvestorCompanyName"];
            this.debitAccountInvestorUserFirstName = _data["debitAccountInvestorUserFirstName"];
            this.debitAccountInvestorUserLastName = _data["debitAccountInvestorUserLastName"];
            this.creditAccountId = _data["creditAccountId"];
            this.creditAccountInvestorId = _data["creditAccountInvestorId"];
            this.creditAccountName = _data["creditAccountName"];
            this.creditAccountInvestorCompanyName = _data["creditAccountInvestorCompanyName"];
            this.creditAccountInvestorUserFirstName = _data["creditAccountInvestorUserFirstName"];
            this.creditAccountInvestorUserLastName = _data["creditAccountInvestorUserLastName"];
            this.amount = _data["amount"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.transactionTypeName = _data["transactionTypeName"];
            this.transactionStatusId = _data["transactionStatusId"];
            this.transactionStatusName = _data["transactionStatusName"];
            this.transactionStatusIsOutstandingForClient = _data["transactionStatusIsOutstandingForClient"];
            this.transactionStatusIsOutstandingForSystem = _data["transactionStatusIsOutstandingForSystem"];
            (<any>this).transactionStatusIsOutstanding = _data["transactionStatusIsOutstanding"];
            (<any>this).transactionOutstandingMessage = _data["transactionOutstandingMessage"];
            this.transactionSourceId = _data["transactionSourceId"];
            this.transactionSourceName = _data["transactionSourceName"];
            this.hasBeenSynced = _data["hasBeenSynced"];
            this.ethereumTransactionHash = _data["ethereumTransactionHash"];
            this.tokenName = _data["tokenName"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.description = _data["description"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByUserFirstName = _data["createdByUserFirstName"];
            this.createdByUserLastName = _data["createdByUserLastName"];
        }
    }

    static fromJS(data: any): TransactionDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["debitAccountId"] = this.debitAccountId;
        data["debitAccountInvestorId"] = this.debitAccountInvestorId;
        data["debitAccountName"] = this.debitAccountName;
        data["debitAccountInvestorCompanyName"] = this.debitAccountInvestorCompanyName;
        data["debitAccountInvestorUserFirstName"] = this.debitAccountInvestorUserFirstName;
        data["debitAccountInvestorUserLastName"] = this.debitAccountInvestorUserLastName;
        data["creditAccountId"] = this.creditAccountId;
        data["creditAccountInvestorId"] = this.creditAccountInvestorId;
        data["creditAccountName"] = this.creditAccountName;
        data["creditAccountInvestorCompanyName"] = this.creditAccountInvestorCompanyName;
        data["creditAccountInvestorUserFirstName"] = this.creditAccountInvestorUserFirstName;
        data["creditAccountInvestorUserLastName"] = this.creditAccountInvestorUserLastName;
        data["amount"] = this.amount;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionTypeName"] = this.transactionTypeName;
        data["transactionStatusId"] = this.transactionStatusId;
        data["transactionStatusName"] = this.transactionStatusName;
        data["transactionStatusIsOutstandingForClient"] = this.transactionStatusIsOutstandingForClient;
        data["transactionStatusIsOutstandingForSystem"] = this.transactionStatusIsOutstandingForSystem;
        data["transactionStatusIsOutstanding"] = this.transactionStatusIsOutstanding;
        data["transactionOutstandingMessage"] = this.transactionOutstandingMessage;
        data["transactionSourceId"] = this.transactionSourceId;
        data["transactionSourceName"] = this.transactionSourceName;
        data["hasBeenSynced"] = this.hasBeenSynced;
        data["ethereumTransactionHash"] = this.ethereumTransactionHash;
        data["tokenName"] = this.tokenName;
        data["tokenSymbol"] = this.tokenSymbol;
        data["description"] = this.description;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByUserFirstName"] = this.createdByUserFirstName;
        data["createdByUserLastName"] = this.createdByUserLastName;
        return data;
    }
}

export interface ITransactionDisplayModel {
    id?: string;
    effectiveDate?: Date;
    debitAccountId?: string;
    debitAccountInvestorId?: string | undefined;
    debitAccountName?: string | undefined;
    debitAccountInvestorCompanyName?: string | undefined;
    debitAccountInvestorUserFirstName?: string | undefined;
    debitAccountInvestorUserLastName?: string | undefined;
    creditAccountId?: string;
    creditAccountInvestorId?: string | undefined;
    creditAccountName?: string | undefined;
    creditAccountInvestorCompanyName?: string | undefined;
    creditAccountInvestorUserFirstName?: string | undefined;
    creditAccountInvestorUserLastName?: string | undefined;
    amount?: number;
    transactionTypeId?: number;
    transactionTypeName?: string | undefined;
    transactionStatusId?: number;
    transactionStatusName?: string | undefined;
    transactionStatusIsOutstandingForClient?: boolean;
    transactionStatusIsOutstandingForSystem?: boolean;
    transactionStatusIsOutstanding?: boolean;
    transactionOutstandingMessage?: string | undefined;
    transactionSourceId?: number;
    transactionSourceName?: string | undefined;
    hasBeenSynced?: boolean;
    ethereumTransactionHash?: string | undefined;
    tokenName?: string | undefined;
    tokenSymbol?: string | undefined;
    description?: string | undefined;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
}

export class TransactionDisplayModelPagedResult implements ITransactionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (TransactionDisplayModel | undefined)[] | undefined;

    constructor(data?: ITransactionDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransactionDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransactionDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (TransactionDisplayModel | undefined)[] | undefined;
}

export class TransactionInputModel implements ITransactionInputModel {
    debitAccountId?: string;
    creditAccountId?: string;
    amount?: number;
    transactionTypeId?: number;
    manualTransactionTypeId?: number | undefined;
    effectiveDate?: Date | undefined;
    transactionStatusId?: number | undefined;
    tokenId?: string;
    description?: string | undefined;
    transactionSourceId?: number | undefined;

    constructor(data?: ITransactionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.debitAccountId = _data["debitAccountId"];
            this.creditAccountId = _data["creditAccountId"];
            this.amount = _data["amount"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.manualTransactionTypeId = _data["manualTransactionTypeId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.transactionStatusId = _data["transactionStatusId"];
            this.tokenId = _data["tokenId"];
            this.description = _data["description"];
            this.transactionSourceId = _data["transactionSourceId"];
        }
    }

    static fromJS(data: any): TransactionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["debitAccountId"] = this.debitAccountId;
        data["creditAccountId"] = this.creditAccountId;
        data["amount"] = this.amount;
        data["transactionTypeId"] = this.transactionTypeId;
        data["manualTransactionTypeId"] = this.manualTransactionTypeId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["transactionStatusId"] = this.transactionStatusId;
        data["tokenId"] = this.tokenId;
        data["description"] = this.description;
        data["transactionSourceId"] = this.transactionSourceId;
        return data;
    }
}

export interface ITransactionInputModel {
    debitAccountId?: string;
    creditAccountId?: string;
    amount?: number;
    transactionTypeId?: number;
    manualTransactionTypeId?: number | undefined;
    effectiveDate?: Date | undefined;
    transactionStatusId?: number | undefined;
    tokenId?: string;
    description?: string | undefined;
    transactionSourceId?: number | undefined;
}

export class TwilioEvent implements ITwilioEvent {
    event?: string | undefined;
    time?: Date;
    requestId?: string | undefined;
    objects?: EventObject | undefined;

    constructor(data?: ITwilioEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.requestId = _data["requestId"];
            this.objects = _data["objects"] ? EventObject.fromJS(_data["objects"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TwilioEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["objects"] = this.objects ? this.objects.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITwilioEvent {
    event?: string | undefined;
    time?: Date;
    requestId?: string | undefined;
    objects?: EventObject | undefined;
}

export class UserAccountModel implements IUserAccountModel {
    userId?: string;
    userTypeId?: number;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;
    isAdmin?: boolean;
    picture?: string | undefined;
    investorId?: string | undefined;
    investorStatusId?: number;
    investorTypeId?: number;
    investorQualifyingCriteriaId?: string | undefined;
    brokerId?: string | undefined;
    investorDefaultCurrencyTokenId?: string | undefined;
    investorAccount?: AccountDisplayModel | undefined;
    investorRequiresTakeOnConfirmation?: boolean | undefined;
    referralCode?: string | undefined;
    usesBankId?: boolean;
    supplierId?: string | undefined;
    qualityAssessorId?: string | undefined;
    mfaTypeId?: number | undefined;
    dispIdentifier?: string | undefined;

    constructor(data?: IUserAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userTypeId = _data["userTypeId"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.contactNumber = _data["contactNumber"];
            this.isAdmin = _data["isAdmin"];
            this.picture = _data["picture"];
            this.investorId = _data["investorId"];
            this.investorStatusId = _data["investorStatusId"];
            this.investorTypeId = _data["investorTypeId"];
            this.investorQualifyingCriteriaId = _data["investorQualifyingCriteriaId"];
            this.brokerId = _data["brokerId"];
            this.investorDefaultCurrencyTokenId = _data["investorDefaultCurrencyTokenId"];
            this.investorAccount = _data["investorAccount"] ? AccountDisplayModel.fromJS(_data["investorAccount"]) : <any>undefined;
            this.investorRequiresTakeOnConfirmation = _data["investorRequiresTakeOnConfirmation"];
            this.referralCode = _data["referralCode"];
            this.usesBankId = _data["usesBankId"];
            this.supplierId = _data["supplierId"];
            this.qualityAssessorId = _data["qualityAssessorId"];
            this.mfaTypeId = _data["mfaTypeId"];
            this.dispIdentifier = _data["dispIdentifier"];
        }
    }

    static fromJS(data: any): UserAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userTypeId"] = this.userTypeId;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["contactNumber"] = this.contactNumber;
        data["isAdmin"] = this.isAdmin;
        data["picture"] = this.picture;
        data["investorId"] = this.investorId;
        data["investorStatusId"] = this.investorStatusId;
        data["investorTypeId"] = this.investorTypeId;
        data["investorQualifyingCriteriaId"] = this.investorQualifyingCriteriaId;
        data["brokerId"] = this.brokerId;
        data["investorDefaultCurrencyTokenId"] = this.investorDefaultCurrencyTokenId;
        data["investorAccount"] = this.investorAccount ? this.investorAccount.toJSON() : <any>undefined;
        data["investorRequiresTakeOnConfirmation"] = this.investorRequiresTakeOnConfirmation;
        data["referralCode"] = this.referralCode;
        data["usesBankId"] = this.usesBankId;
        data["supplierId"] = this.supplierId;
        data["qualityAssessorId"] = this.qualityAssessorId;
        data["mfaTypeId"] = this.mfaTypeId;
        data["dispIdentifier"] = this.dispIdentifier;
        return data;
    }
}

export interface IUserAccountModel {
    userId?: string;
    userTypeId?: number;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;
    isAdmin?: boolean;
    picture?: string | undefined;
    investorId?: string | undefined;
    investorStatusId?: number;
    investorTypeId?: number;
    investorQualifyingCriteriaId?: string | undefined;
    brokerId?: string | undefined;
    investorDefaultCurrencyTokenId?: string | undefined;
    investorAccount?: AccountDisplayModel | undefined;
    investorRequiresTakeOnConfirmation?: boolean | undefined;
    referralCode?: string | undefined;
    usesBankId?: boolean;
    supplierId?: string | undefined;
    qualityAssessorId?: string | undefined;
    mfaTypeId?: number | undefined;
    dispIdentifier?: string | undefined;
}

export class UserDisplayModel implements IUserDisplayModel {
    id?: string;
    emailAddress?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    createdOn?: Date;
    lastLoginDate?: Date | undefined;
    profileImageUrl?: string | undefined;
    roles?: string | undefined;
    isAdmin?: boolean;
    hasBeenActivated?: boolean;
    userTypeId?: number;
    userTypeName?: string | undefined;
    investor?: InvestorDisplayModel | undefined;
    broker?: BrokerDisplayModel | undefined;
    supplier?: SupplierDisplayModel | undefined;
    qualityAssessor?: QualityAssessorDisplayModel | undefined;

    constructor(data?: IUserDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactNumber = _data["contactNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : <any>undefined;
            this.profileImageUrl = _data["profileImageUrl"];
            this.roles = _data["roles"];
            this.isAdmin = _data["isAdmin"];
            this.hasBeenActivated = _data["hasBeenActivated"];
            this.userTypeId = _data["userTypeId"];
            this.userTypeName = _data["userTypeName"];
            this.investor = _data["investor"] ? InvestorDisplayModel.fromJS(_data["investor"]) : <any>undefined;
            this.broker = _data["broker"] ? BrokerDisplayModel.fromJS(_data["broker"]) : <any>undefined;
            this.supplier = _data["supplier"] ? SupplierDisplayModel.fromJS(_data["supplier"]) : <any>undefined;
            this.qualityAssessor = _data["qualityAssessor"] ? QualityAssessorDisplayModel.fromJS(_data["qualityAssessor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactNumber"] = this.contactNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>undefined;
        data["profileImageUrl"] = this.profileImageUrl;
        data["roles"] = this.roles;
        data["isAdmin"] = this.isAdmin;
        data["hasBeenActivated"] = this.hasBeenActivated;
        data["userTypeId"] = this.userTypeId;
        data["userTypeName"] = this.userTypeName;
        data["investor"] = this.investor ? this.investor.toJSON() : <any>undefined;
        data["broker"] = this.broker ? this.broker.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["qualityAssessor"] = this.qualityAssessor ? this.qualityAssessor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDisplayModel {
    id?: string;
    emailAddress?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    createdOn?: Date;
    lastLoginDate?: Date | undefined;
    profileImageUrl?: string | undefined;
    roles?: string | undefined;
    isAdmin?: boolean;
    hasBeenActivated?: boolean;
    userTypeId?: number;
    userTypeName?: string | undefined;
    investor?: InvestorDisplayModel | undefined;
    broker?: BrokerDisplayModel | undefined;
    supplier?: SupplierDisplayModel | undefined;
    qualityAssessor?: QualityAssessorDisplayModel | undefined;
}

export class UserInputModel implements IUserInputModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;

    constructor(data?: IUserInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): UserInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface IUserInputModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;
}

export class UserListModel implements IUserListModel {
    id?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    createdOn?: Date;
    userSessionLastLoginDate?: Date | undefined;
    roles?: string | undefined;
    isAdmin?: boolean;
    hasBeenActivated?: boolean;
    userTypeId?: number;
    userTypeName?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.userSessionLastLoginDate = _data["userSessionLastLoginDate"] ? new Date(_data["userSessionLastLoginDate"].toString()) : <any>undefined;
            this.roles = _data["roles"];
            this.isAdmin = _data["isAdmin"];
            this.hasBeenActivated = _data["hasBeenActivated"];
            this.userTypeId = _data["userTypeId"];
            this.userTypeName = _data["userTypeName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["userSessionLastLoginDate"] = this.userSessionLastLoginDate ? this.userSessionLastLoginDate.toISOString() : <any>undefined;
        data["roles"] = this.roles;
        data["isAdmin"] = this.isAdmin;
        data["hasBeenActivated"] = this.hasBeenActivated;
        data["userTypeId"] = this.userTypeId;
        data["userTypeName"] = this.userTypeName;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserListModel {
    id?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    createdOn?: Date;
    userSessionLastLoginDate?: Date | undefined;
    roles?: string | undefined;
    isAdmin?: boolean;
    hasBeenActivated?: boolean;
    userTypeId?: number;
    userTypeName?: string | undefined;
    name?: string | undefined;
}

export class UserListModelPagedResult implements IUserListModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (UserListModel | undefined)[] | undefined;

    constructor(data?: IUserListModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserListModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserListModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserListModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserListModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (UserListModel | undefined)[] | undefined;
}

export class UserProfileInputModel implements IUserProfileInputModel {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;

    constructor(data?: IUserProfileInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleNames = _data["middleNames"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.contactNumber = _data["contactNumber"];
        }
    }

    static fromJS(data: any): UserProfileInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleNames"] = this.middleNames;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["contactNumber"] = this.contactNumber;
        return data;
    }
}

export interface IUserProfileInputModel {
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    dateOfBirth?: Date | undefined;
    contactNumber?: string | undefined;
}

export class UserRegistrationModel implements IUserRegistrationModel {
    userTypeId?: number;
    investorTypeId?: number;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    referralCode?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    defaultCurrencyTokenId?: string;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    countryId?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    advisoryNumber?: string | undefined;
    password?: string | undefined;
    recaptcha?: string | undefined;
    acceptTermsOfUse?: boolean;

    constructor(data?: IUserRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypeId = _data["userTypeId"];
            this.investorTypeId = _data["investorTypeId"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.referralCode = _data["referralCode"];
            this.contactNumber = _data["contactNumber"];
            this.idNumber = _data["idNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.defaultCurrencyTokenId = _data["defaultCurrencyTokenId"];
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyOwner = _data["companyOwner"];
            this.countryId = _data["countryId"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.advisoryNumber = _data["advisoryNumber"];
            this.password = _data["password"];
            this.recaptcha = _data["recaptcha"];
            this.acceptTermsOfUse = _data["acceptTermsOfUse"];
        }
    }

    static fromJS(data: any): UserRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypeId"] = this.userTypeId;
        data["investorTypeId"] = this.investorTypeId;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["referralCode"] = this.referralCode;
        data["contactNumber"] = this.contactNumber;
        data["idNumber"] = this.idNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["defaultCurrencyTokenId"] = this.defaultCurrencyTokenId;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyOwner"] = this.companyOwner;
        data["countryId"] = this.countryId;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["advisoryNumber"] = this.advisoryNumber;
        data["password"] = this.password;
        data["recaptcha"] = this.recaptcha;
        data["acceptTermsOfUse"] = this.acceptTermsOfUse;
        return data;
    }
}

export interface IUserRegistrationModel {
    userTypeId?: number;
    investorTypeId?: number;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    referralCode?: string | undefined;
    contactNumber?: string | undefined;
    idNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    defaultCurrencyTokenId?: string;
    companyName?: string | undefined;
    companyRegNo?: string | undefined;
    companyOwner?: string | undefined;
    countryId?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    advisoryNumber?: string | undefined;
    password?: string | undefined;
    recaptcha?: string | undefined;
    acceptTermsOfUse?: boolean;
}

export class UserRegistrationResponse implements IUserRegistrationResponse {
    userId?: string;
    message?: string | undefined;

    constructor(data?: IUserRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UserRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["message"] = this.message;
        return data;
    }
}

export interface IUserRegistrationResponse {
    userId?: string;
    message?: string | undefined;
}

export class UserVerificationResponse implements IUserVerificationResponse {
    isMfaEnabled?: boolean;
    mfaTypeId?: number | undefined;
    contactNumber?: string | undefined;
    totpLinkDisplayModel?: TotpLinkDisplayModel | undefined;

    constructor(data?: IUserVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMfaEnabled = _data["isMfaEnabled"];
            this.mfaTypeId = _data["mfaTypeId"];
            this.contactNumber = _data["contactNumber"];
            this.totpLinkDisplayModel = _data["totpLinkDisplayModel"] ? TotpLinkDisplayModel.fromJS(_data["totpLinkDisplayModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMfaEnabled"] = this.isMfaEnabled;
        data["mfaTypeId"] = this.mfaTypeId;
        data["contactNumber"] = this.contactNumber;
        data["totpLinkDisplayModel"] = this.totpLinkDisplayModel ? this.totpLinkDisplayModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserVerificationResponse {
    isMfaEnabled?: boolean;
    mfaTypeId?: number | undefined;
    contactNumber?: string | undefined;
    totpLinkDisplayModel?: TotpLinkDisplayModel | undefined;
}

export class UtilityTokenDepositDetailsDisplayModel implements IUtilityTokenDepositDetailsDisplayModel {
    id?: string;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    bank?: string | undefined;
    accountHolder?: string | undefined;
    accountNumber?: string | undefined;
    bicswift?: string | undefined;
    iban?: string | undefined;

    constructor(data?: IUtilityTokenDepositDetailsDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.bank = _data["bank"];
            this.accountHolder = _data["accountHolder"];
            this.accountNumber = _data["accountNumber"];
            this.bicswift = _data["bicswift"];
            this.iban = _data["iban"];
        }
    }

    static fromJS(data: any): UtilityTokenDepositDetailsDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityTokenDepositDetailsDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["bank"] = this.bank;
        data["accountHolder"] = this.accountHolder;
        data["accountNumber"] = this.accountNumber;
        data["bicswift"] = this.bicswift;
        data["iban"] = this.iban;
        return data;
    }
}

export interface IUtilityTokenDepositDetailsDisplayModel {
    id?: string;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    bank?: string | undefined;
    accountHolder?: string | undefined;
    accountNumber?: string | undefined;
    bicswift?: string | undefined;
    iban?: string | undefined;
}

export class VotingResultModel implements IVotingResultModel {
    resolutionId?: string;
    resolutionName?: string | undefined;
    votingOptionId?: number | undefined;
    votingOptionName?: string | undefined;
    balance?: number;

    constructor(data?: IVotingResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolutionId = _data["resolutionId"];
            this.resolutionName = _data["resolutionName"];
            this.votingOptionId = _data["votingOptionId"];
            this.votingOptionName = _data["votingOptionName"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): VotingResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new VotingResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolutionId"] = this.resolutionId;
        data["resolutionName"] = this.resolutionName;
        data["votingOptionId"] = this.votingOptionId;
        data["votingOptionName"] = this.votingOptionName;
        data["balance"] = this.balance;
        return data;
    }
}

export interface IVotingResultModel {
    resolutionId?: string;
    resolutionName?: string | undefined;
    votingOptionId?: number | undefined;
    votingOptionName?: string | undefined;
    balance?: number;
}

export class VotingTokenBalanceModel implements IVotingTokenBalanceModel {
    tokenId?: string;
    resolutionId?: string;
    resolutionName?: string | undefined;
    meetingId?: string;
    votingStartDate?: Date;
    votingCloseDate?: Date;
    balance?: number;

    constructor(data?: IVotingTokenBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenId = _data["tokenId"];
            this.resolutionId = _data["resolutionId"];
            this.resolutionName = _data["resolutionName"];
            this.meetingId = _data["meetingId"];
            this.votingStartDate = _data["votingStartDate"] ? new Date(_data["votingStartDate"].toString()) : <any>undefined;
            this.votingCloseDate = _data["votingCloseDate"] ? new Date(_data["votingCloseDate"].toString()) : <any>undefined;
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): VotingTokenBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new VotingTokenBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenId"] = this.tokenId;
        data["resolutionId"] = this.resolutionId;
        data["resolutionName"] = this.resolutionName;
        data["meetingId"] = this.meetingId;
        data["votingStartDate"] = this.votingStartDate ? this.votingStartDate.toISOString() : <any>undefined;
        data["votingCloseDate"] = this.votingCloseDate ? this.votingCloseDate.toISOString() : <any>undefined;
        data["balance"] = this.balance;
        return data;
    }
}

export interface IVotingTokenBalanceModel {
    tokenId?: string;
    resolutionId?: string;
    resolutionName?: string | undefined;
    meetingId?: string;
    votingStartDate?: Date;
    votingCloseDate?: Date;
    balance?: number;
}

export class WhitelistIpDisplayModel implements IWhitelistIpDisplayModel {
    id?: string;
    name?: string | undefined;
    ipAddress?: string | undefined;
    lastActive?: Date | undefined;

    constructor(data?: IWhitelistIpDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.lastActive = _data["lastActive"] ? new Date(_data["lastActive"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WhitelistIpDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new WhitelistIpDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWhitelistIpDisplayModel {
    id?: string;
    name?: string | undefined;
    ipAddress?: string | undefined;
    lastActive?: Date | undefined;
}

export class WhitelistIpInputModel implements IWhitelistIpInputModel {
    name?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IWhitelistIpInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): WhitelistIpInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new WhitelistIpInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IWhitelistIpInputModel {
    name?: string | undefined;
    ipAddress?: string | undefined;
}

export class WithdrawalConversionInputModel implements IWithdrawalConversionInputModel {
    id?: string;
    investorId?: string;
    tokenId?: string;
    quantity?: number;
    effectiveDate?: Date;

    constructor(data?: IWithdrawalConversionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investorId = _data["investorId"];
            this.tokenId = _data["tokenId"];
            this.quantity = _data["quantity"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WithdrawalConversionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalConversionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investorId"] = this.investorId;
        data["tokenId"] = this.tokenId;
        data["quantity"] = this.quantity;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWithdrawalConversionInputModel {
    id?: string;
    investorId?: string;
    tokenId?: string;
    quantity?: number;
    effectiveDate?: Date;
}

export class WithdrawalDisplayModel implements IWithdrawalDisplayModel {
    id?: string;
    createdOn?: Date;
    readonly hasBeenProcessed?: boolean;
    processedOn?: Date | undefined;
    amount?: number;
    investorId?: string;
    investorName?: string | undefined;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorUserEmailAddress?: string | undefined;
    investorAddress?: string | undefined;
    investorAddressLine1?: string | undefined;
    investorAddressLine2?: string | undefined;
    investorCity?: string | undefined;
    investorPostalCode?: string | undefined;
    transactionId?: string;
    transactionHasBeenSynced?: boolean;
    transactionSubmittedToBlockchainOn?: Date | undefined;
    transactionEthereumTransactionHash?: string | undefined;
    bankAccountId?: string;
    bankAccountName?: string | undefined;
    bankAccountAccountNumber?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    createdByUserId?: string;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
    processedByUserId?: string | undefined;
    processedByUserName?: string | undefined;
    processedByUserFirstName?: string | undefined;
    processedByUserLastName?: string | undefined;

    constructor(data?: IWithdrawalDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            (<any>this).hasBeenProcessed = _data["hasBeenProcessed"];
            this.processedOn = _data["processedOn"] ? new Date(_data["processedOn"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.investorCompanyName = _data["investorCompanyName"];
            this.investorUserFirstName = _data["investorUserFirstName"];
            this.investorUserLastName = _data["investorUserLastName"];
            this.investorUserEmailAddress = _data["investorUserEmailAddress"];
            this.investorAddress = _data["investorAddress"];
            this.investorAddressLine1 = _data["investorAddressLine1"];
            this.investorAddressLine2 = _data["investorAddressLine2"];
            this.investorCity = _data["investorCity"];
            this.investorPostalCode = _data["investorPostalCode"];
            this.transactionId = _data["transactionId"];
            this.transactionHasBeenSynced = _data["transactionHasBeenSynced"];
            this.transactionSubmittedToBlockchainOn = _data["transactionSubmittedToBlockchainOn"] ? new Date(_data["transactionSubmittedToBlockchainOn"].toString()) : <any>undefined;
            this.transactionEthereumTransactionHash = _data["transactionEthereumTransactionHash"];
            this.bankAccountId = _data["bankAccountId"];
            this.bankAccountName = _data["bankAccountName"];
            this.bankAccountAccountNumber = _data["bankAccountAccountNumber"];
            this.tokenId = _data["tokenId"];
            this.tokenSymbol = _data["tokenSymbol"];
            this.tokenName = _data["tokenName"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByUserFirstName = _data["createdByUserFirstName"];
            this.createdByUserLastName = _data["createdByUserLastName"];
            this.processedByUserId = _data["processedByUserId"];
            this.processedByUserName = _data["processedByUserName"];
            this.processedByUserFirstName = _data["processedByUserFirstName"];
            this.processedByUserLastName = _data["processedByUserLastName"];
        }
    }

    static fromJS(data: any): WithdrawalDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["hasBeenProcessed"] = this.hasBeenProcessed;
        data["processedOn"] = this.processedOn ? this.processedOn.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["investorCompanyName"] = this.investorCompanyName;
        data["investorUserFirstName"] = this.investorUserFirstName;
        data["investorUserLastName"] = this.investorUserLastName;
        data["investorUserEmailAddress"] = this.investorUserEmailAddress;
        data["investorAddress"] = this.investorAddress;
        data["investorAddressLine1"] = this.investorAddressLine1;
        data["investorAddressLine2"] = this.investorAddressLine2;
        data["investorCity"] = this.investorCity;
        data["investorPostalCode"] = this.investorPostalCode;
        data["transactionId"] = this.transactionId;
        data["transactionHasBeenSynced"] = this.transactionHasBeenSynced;
        data["transactionSubmittedToBlockchainOn"] = this.transactionSubmittedToBlockchainOn ? this.transactionSubmittedToBlockchainOn.toISOString() : <any>undefined;
        data["transactionEthereumTransactionHash"] = this.transactionEthereumTransactionHash;
        data["bankAccountId"] = this.bankAccountId;
        data["bankAccountName"] = this.bankAccountName;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        data["tokenId"] = this.tokenId;
        data["tokenSymbol"] = this.tokenSymbol;
        data["tokenName"] = this.tokenName;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByUserFirstName"] = this.createdByUserFirstName;
        data["createdByUserLastName"] = this.createdByUserLastName;
        data["processedByUserId"] = this.processedByUserId;
        data["processedByUserName"] = this.processedByUserName;
        data["processedByUserFirstName"] = this.processedByUserFirstName;
        data["processedByUserLastName"] = this.processedByUserLastName;
        return data;
    }
}

export interface IWithdrawalDisplayModel {
    id?: string;
    createdOn?: Date;
    hasBeenProcessed?: boolean;
    processedOn?: Date | undefined;
    amount?: number;
    investorId?: string;
    investorName?: string | undefined;
    investorCompanyName?: string | undefined;
    investorUserFirstName?: string | undefined;
    investorUserLastName?: string | undefined;
    investorUserEmailAddress?: string | undefined;
    investorAddress?: string | undefined;
    investorAddressLine1?: string | undefined;
    investorAddressLine2?: string | undefined;
    investorCity?: string | undefined;
    investorPostalCode?: string | undefined;
    transactionId?: string;
    transactionHasBeenSynced?: boolean;
    transactionSubmittedToBlockchainOn?: Date | undefined;
    transactionEthereumTransactionHash?: string | undefined;
    bankAccountId?: string;
    bankAccountName?: string | undefined;
    bankAccountAccountNumber?: string | undefined;
    tokenId?: string;
    tokenSymbol?: string | undefined;
    tokenName?: string | undefined;
    createdByUserId?: string;
    createdByUserName?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
    processedByUserId?: string | undefined;
    processedByUserName?: string | undefined;
    processedByUserFirstName?: string | undefined;
    processedByUserLastName?: string | undefined;
}

export class WithdrawalDisplayModelPagedResult implements IWithdrawalDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    readonly firstRowOnPage?: number;
    readonly lastRowOnPage?: number;
    results?: (WithdrawalDisplayModel | undefined)[] | undefined;

    constructor(data?: IWithdrawalDisplayModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            (<any>this).firstRowOnPage = _data["firstRowOnPage"];
            (<any>this).lastRowOnPage = _data["lastRowOnPage"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WithdrawalDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithdrawalDisplayModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalDisplayModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWithdrawalDisplayModelPagedResult {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    firstRowOnPage?: number;
    lastRowOnPage?: number;
    results?: (WithdrawalDisplayModel | undefined)[] | undefined;
}

export class WithdrawalInputModel implements IWithdrawalInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    bankAccountId?: string;

    constructor(data?: IWithdrawalInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.tokenId = _data["tokenId"];
            this.amount = _data["amount"];
            this.bankAccountId = _data["bankAccountId"];
        }
    }

    static fromJS(data: any): WithdrawalInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["tokenId"] = this.tokenId;
        data["amount"] = this.amount;
        data["bankAccountId"] = this.bankAccountId;
        return data;
    }
}

export interface IWithdrawalInputModel {
    investorId?: string;
    tokenId?: string;
    amount?: number;
    bankAccountId?: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
